/* tslint:disable */
/* eslint-disable */
/**
 * World Rugby SCRM
 * World Rugby SCRM API
 *
 * The version of the OpenAPI document: 0.8.6
 * Contact: gareth@koan.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * information about the api
 * @export
 * @interface ApiKey
 */
export interface ApiKey {
    /**
     * unique id
     * @type {number}
     * @memberof ApiKey
     */
    'id'?: number;
    /**
     * user provided human friendly name
     * @type {string}
     * @memberof ApiKey
     */
    'name'?: string;
    /**
     * api generated key that is sent in the X-API-Key header
     * @type {string}
     * @memberof ApiKey
     */
    'key'?: string;
    /**
     * 
     * @type {Org}
     * @memberof ApiKey
     */
    'org'?: Org;
    /**
     * 
     * @type {User}
     * @memberof ApiKey
     */
    'createdBy'?: User;
    /**
     * UTC date time it was created
     * @type {string}
     * @memberof ApiKey
     */
    'createdAt'?: string;
}
/**
 * one page of api keys
 * @export
 * @interface ApiKeysOnPage
 */
export interface ApiKeysOnPage {
    /**
     * 
     * @type {Array<ApiKey>}
     * @memberof ApiKeysOnPage
     */
    'data'?: Array<ApiKey>;
    /**
     * 
     * @type {Paginator}
     * @memberof ApiKeysOnPage
     */
    'paginator'?: Paginator;
}
/**
 * RFC7807 response sent when an api call fails or has nothing else useful to say
 * @export
 * @interface ApiResponse
 */
export interface ApiResponse {
    /**
     * a url leadinng to documentation about the error or message
     * @type {string}
     * @memberof ApiResponse
     */
    'type'?: string;
    /**
     * HTTP status code
     * @type {number}
     * @memberof ApiResponse
     */
    'status': number;
    /**
     * short human readable summary
     * @type {string}
     * @memberof ApiResponse
     */
    'title': string;
    /**
     * how the user migth correct the problem
     * @type {string}
     * @memberof ApiResponse
     */
    'detail': string;
}
/**
 * information about the api
 * @export
 * @interface ApiVersion
 */
export interface ApiVersion {
    /**
     * the OpenAPI yaml version number from the top of this file
     * @type {string}
     * @memberof ApiVersion
     */
    'version'?: string;
    /**
     * the git commit id for this deploy
     * @type {string}
     * @memberof ApiVersion
     */
    'gitRevision'?: string;
    /**
     * name of the branch or tag deployed
     * @type {string}
     * @memberof ApiVersion
     */
    'gitBranch'?: string;
    /**
     * UTC date time of the branch / tag / release
     * @type {string}
     * @memberof ApiVersion
     */
    'buildDate'?: string;
}
/**
 * foo
 * @export
 * @interface Assessment
 */
export interface Assessment {
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    'id'?: number;
    /**
     * id of assessment for Baseline
     * @type {number}
     * @memberof Assessment
     */
    'baselineId'?: number;
    /**
     * 
     * @type {AssessmentType}
     * @memberof Assessment
     */
    'assessmentType'?: AssessmentType;
    /**
     * 
     * @type {Player}
     * @memberof Assessment
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof Assessment
     */
    'team'?: Team;
    /**
     * 
     * @type {Event}
     * @memberof Assessment
     */
    'event'?: Event;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'requestedBy'?: AssessmentRequestedByEnum;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'completedBy'?: AssessmentCompletedByEnum;
    /**
     * 
     * @type {User}
     * @memberof Assessment
     */
    'assessor'?: User;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {User}
     * @memberof Assessment
     */
    'reviewedBy'?: User;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    'reviewedAt'?: string;
    /**
     * reason for hai3
     * @type {string}
     * @memberof Assessment
     */
    'reason'?: string;
    /**
     * free text field for other info
     * @type {string}
     * @memberof Assessment
     */
    'notes'?: string;
    /**
     * does a baseline retest need to happen?
     * @type {boolean}
     * @memberof Assessment
     */
    'retestRequired'?: boolean;
    /**
     * 
     * @type {Array<BaselineModesEnum>}
     * @memberof Assessment
     */
    'modesToRetest'?: Array<BaselineModesEnum>;
    /**
     * number of errors
     * @type {number}
     * @memberof Assessment
     */
    'balanceDoubleLegErrors'?: number;
    /**
     * number of errors
     * @type {number}
     * @memberof Assessment
     */
    'balanceSingleLegErrors'?: number;
    /**
     * number of errors
     * @type {number}
     * @memberof Assessment
     */
    'balanceTandemErrors'?: number;
    /**
     * information about where the assessment came from
     * @type {string}
     * @memberof Assessment
     */
    'version'?: string;
    /**
     * 
     * @type {UnableToCompleteReason}
     * @memberof Assessment
     */
    'unableReason'?: UnableToCompleteReason;
    /**
     * 
     * @type {CogMode}
     * @memberof Assessment
     */
    'cog'?: CogMode;
    /**
     * 
     * @type {DelayedRecallMode}
     * @memberof Assessment
     */
    'delayedRecall'?: DelayedRecallMode;
    /**
     * 
     * @type {WordsMode}
     * @memberof Assessment
     */
    'immediateMemory'?: WordsMode;
    /**
     * 
     * @type {NeckExamMode}
     * @memberof Assessment
     */
    'neckExam'?: NeckExamMode;
    /**
     * 
     * @type {MonthsMode}
     * @memberof Assessment
     */
    'monthsBackwards'?: MonthsMode;
    /**
     * 
     * @type {NumbersMode}
     * @memberof Assessment
     */
    'numbersBackwards'?: NumbersMode;
    /**
     * 
     * @type {SymptomsMode}
     * @memberof Assessment
     */
    'symptoms'?: SymptomsMode;
    /**
     * 
     * @type {Hia1SymptomsMode}
     * @memberof Assessment
     */
    'hia1Symptoms'?: Hia1SymptomsMode;
    /**
     * 
     * @type {Hia1Criteria1Mode}
     * @memberof Assessment
     */
    'hia1Criteria1'?: Hia1Criteria1Mode;
    /**
     * 
     * @type {Hia1ClinicalSignsMode}
     * @memberof Assessment
     */
    'hia1ClincialSigns'?: Hia1ClinicalSignsMode;
    /**
     * 
     * @type {Hia1ClinicalSignsMode}
     * @memberof Assessment
     */
    'hia1ClinicalSigns'?: Hia1ClinicalSignsMode;
    /**
     * 
     * @type {Hia1MaddocksMode}
     * @memberof Assessment
     */
    'hia1Maddocks'?: Hia1MaddocksMode;
    /**
     * 
     * @type {Hia1ResultMode}
     * @memberof Assessment
     */
    'hia1Result'?: Hia1ResultMode;
    /**
     * 
     * @type {Hia1OffFieldMode}
     * @memberof Assessment
     */
    'hia1OffField'?: Hia1OffFieldMode;
    /**
     * 
     * @type {Hia2ResultMode}
     * @memberof Assessment
     */
    'hia2Result'?: Hia2ResultMode;
    /**
     * 
     * @type {Hia3AmnesiaMode}
     * @memberof Assessment
     */
    'hia3Amnesia'?: Hia3AmnesiaMode;
    /**
     * 
     * @type {Hia3ComputerCognitiveMode}
     * @memberof Assessment
     */
    'hia3ComputerCognitive'?: Hia3ComputerCognitiveMode;
    /**
     * 
     * @type {Hia3VideoReviewedMode}
     * @memberof Assessment
     */
    'hia3VideoReviewed'?: Hia3VideoReviewedMode;
    /**
     * 
     * @type {Hia3IncidentDetails}
     * @memberof Assessment
     */
    'hia3IncidentDetails'?: Hia3IncidentDetails;
    /**
     * 
     * @type {Hia3ResultMode}
     * @memberof Assessment
     */
    'hia3Result'?: Hia3ResultMode;
    /**
     * 
     * @type {Hia4ResultMode}
     * @memberof Assessment
     */
    'hia4Result'?: Hia4ResultMode;
    /**
     * pass in an array of detailed Symptoms
     * @type {Array<DetailedSymptom>}
     * @memberof Assessment
     */
    'detailedSymptoms'?: Array<DetailedSymptom>;
}

/**
    * @export
    * @enum {string}
    */
export enum AssessmentRequestedByEnum {
    Match_Doctor = 'Match Doctor',
    Physiotherapist = 'Physiotherapist',
    Referee = 'Referee',
    Team_Doctor = 'Team Doctor',
    Tournament_Doctor = 'Tournament Doctor'
}
/**
    * @export
    * @enum {string}
    */
export enum AssessmentCompletedByEnum {
    Match_Doctor = 'Match Doctor',
    Physiotherapist = 'Physiotherapist',
    Team_Doctor = 'Team Doctor',
    Assistant_Team_Doctor = 'Assistant Team Doctor',
    Tournament_Doctor = 'Tournament Doctor'
}

/**
 * When a baseline assessment does not meet the reference limits, modes are retested, these modes are stored against the original baseline assessment.
 * @export
 * @interface AssessmentMode
 */
export interface AssessmentMode {
    /**
     * 
     * @type {Assessment}
     * @memberof AssessmentMode
     */
    'assessment'?: Assessment;
    /**
     * 
     * @type {Mode}
     * @memberof AssessmentMode
     */
    'mode'?: Mode;
}
/**
 * Sum these value over all the teams / players that the currently logged in user can access for the last 31 days
 * @export
 * @interface AssessmentStatistics
 */
export interface AssessmentStatistics {
    /**
     * number of players who currently have hia 1 status today
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia1Active'?: number;
    /**
     * number of players who have had an hia 1 assessment this period
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia1Assessments'?: number;
    /**
     * number of players who currently have hia 2 status today
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia2Active'?: number;
    /**
     * number of players who have had an hia 2 assessment this period
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia2Assessments'?: number;
    /**
     * number of players who currently have hia 3 status todau
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia3Active'?: number;
    /**
     * number of players who have had an hia 3 assessment this period
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'hia3Assessments'?: number;
    /**
     * number of players who currently have a grtp stage status (currently recovering) today
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'grtpActive'?: number;
    /**
     * total number of players who have had any assessment for head injury this period (do not include baseline)
     * @type {number}
     * @memberof AssessmentStatistics
     */
    'playersAssessed'?: number;
}
/**
 * 
 * @export
 * @interface AssessmentType
 */
export interface AssessmentType {
    /**
     * 
     * @type {number}
     * @memberof AssessmentType
     */
    'id'?: number;
    /**
     * 
     * @type {AssessmentTypeName}
     * @memberof AssessmentType
     */
    'name'?: AssessmentTypeName;
    /**
     * Assessment Types may in the future be allocated to protocol, there is only one protocol for now
     * @type {Array<Protocol>}
     * @memberof AssessmentType
     */
    'protocols'?: Array<Protocol>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum AssessmentTypeName {
    Baseline = 'Baseline',
    Baseline_Retest = 'Baseline Retest',
    Baseline_2 = 'Baseline 2',
    HIA_1 = 'HIA 1',
    HIA_2 = 'HIA 2',
    HIA_3 = 'HIA 3',
    HIA_4 = 'HIA 4',
    Symptoms = 'Symptoms',
    Injury = 'Injury',
    HIA_2_Day_1 = 'HIA 2 Day 1',
    HIA_2_Day_2 = 'HIA 2 Day 2',
    AFL_Baseline_Full = 'AFL Baseline Full',
    AFL_Baseline_Annual = 'AFL Baseline Annual',
    AFL_HIA = 'AFL HIA',
    AFL_Symptoms = 'AFL Symptoms',
    AFL_SCAT = 'AFL SCAT',
    AFL_HIA_Close = 'AFL HIA Close',
    AFL_Neck_Close = 'AFL Neck Close'
}


/**
 * one page of assessments
 * @export
 * @interface AssessmentsOnPage
 */
export interface AssessmentsOnPage {
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof AssessmentsOnPage
     */
    'data'?: Array<Assessment>;
    /**
     * 
     * @type {Paginator}
     * @memberof AssessmentsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BaselineModesEnum {
    symptomsPresent = 'symptomsPresent',
    symptomsScore = 'symptomsScore',
    orientation = 'orientation',
    immediateMemory = 'immediateMemory',
    concentration = 'concentration',
    delayedRecall = 'delayedRecall',
    balanceSingle = 'balanceSingle',
    balanceTandem = 'balanceTandem'
}


/**
 * entities that have changed since the date specified
 * @export
 * @interface Changes
 */
export interface Changes {
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof Changes
     */
    'assessment'?: Array<Assessment>;
    /**
     * 
     * @type {Array<Org>}
     * @memberof Changes
     */
    'org'?: Array<Org>;
    /**
     * 
     * @type {Array<Player>}
     * @memberof Changes
     */
    'player'?: Array<Player>;
    /**
     * 
     * @type {Array<Team>}
     * @memberof Changes
     */
    'team'?: Array<Team>;
    /**
     * 
     * @type {Array<PlayerHistory>}
     * @memberof Changes
     */
    'status'?: Array<PlayerHistory>;
    /**
     * 
     * @type {ChangesLostAccessTo}
     * @memberof Changes
     */
    'lostAccessTo'?: ChangesLostAccessTo;
}
/**
 * if roles expire or are deleted, the user can no longer access some teams or orgs so we list them here
 * @export
 * @interface ChangesLostAccessTo
 */
export interface ChangesLostAccessTo {
    /**
     * team ids that the user can no longer see sinceTime
     * @type {Array<number>}
     * @memberof ChangesLostAccessTo
     */
    'teams'?: Array<number>;
    /**
     * org ids that the user can no longer see sinceTime
     * @type {Array<number>}
     * @memberof ChangesLostAccessTo
     */
    'orgs'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChangesLostAccessTo
     */
    'players'?: Array<number>;
}
/**
 * Cognitive Orientation
 * @export
 * @interface CogMode
 */
export interface CogMode {
    /**
     * 
     * @type {boolean}
     * @memberof CogMode
     */
    'cogMonth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CogMode
     */
    'cogDate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CogMode
     */
    'cogDay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CogMode
     */
    'cogYear'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CogMode
     */
    'cogTime'?: boolean;
}
/**
 * detailed assessment
 * @export
 * @interface ComprehensiveAssessment
 */
export interface ComprehensiveAssessment {
    /**
     * unique id
     * @type {number}
     * @memberof ComprehensiveAssessment
     */
    'id'?: number;
    /**
     * 
     * @type {Player}
     * @memberof ComprehensiveAssessment
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof ComprehensiveAssessment
     */
    'team'?: Team;
    /**
     * 
     * @type {User}
     * @memberof ComprehensiveAssessment
     */
    'assessor'?: User;
    /**
     * 
     * @type {User}
     * @memberof ComprehensiveAssessment
     */
    'reviewer'?: User;
    /**
     * 
     * @type {Event}
     * @memberof ComprehensiveAssessment
     */
    'event'?: Event;
    /**
     * 
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'reviewedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {ComprehensiveType}
     * @memberof ComprehensiveAssessment
     */
    'type'?: ComprehensiveType;
    /**
     * 
     * @type {ComprehensiveOutcome}
     * @memberof ComprehensiveAssessment
     */
    'outcome'?: ComprehensiveOutcome;
    /**
     * json encoded assessment data
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'assessmentJson'?: string;
    /**
     * the purchase order number entered by the Report Viewer
     * @type {string}
     * @memberof ComprehensiveAssessment
     */
    'purchaseOrder'?: string;
}


/**
 * one page of comprehensive assessments
 * @export
 * @interface ComprehensiveAssessmentsOnPage
 */
export interface ComprehensiveAssessmentsOnPage {
    /**
     * 
     * @type {Array<ComprehensiveAssessment>}
     * @memberof ComprehensiveAssessmentsOnPage
     */
    'data'?: Array<ComprehensiveAssessment>;
    /**
     * 
     * @type {Paginator}
     * @memberof ComprehensiveAssessmentsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * For an injury assessment, can the player return to play (green), or not (red), or needs a review (orange)
 * @export
 * @enum {string}
 */

export enum ComprehensiveOutcome {
    Green = 'Green',
    Orange = 'Orange',
    Red = 'Red'
}


/**
 * the kind of comprehensive assessment
 * @export
 * @enum {string}
 */

export enum ComprehensiveType {
    Baseline = 'Baseline',
    Injury = 'Injury',
    Rehab = 'Rehab'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ConcussionValue {
    Concussed = 'Concussed',
    Not_concussed = 'Not concussed',
    Unknown = 'Unknown'
}


/**
 * get a player, with most recent baseline and event. May not need some nested objects. Check with the mobile ui team for how we can reduce the size of the data sent over the wire
 * @export
 * @interface DashboardPlayers
 */
export interface DashboardPlayers {
    /**
     * 
     * @type {Player}
     * @memberof DashboardPlayers
     */
    'player'?: Player;
    /**
     * 
     * @type {Assessment}
     * @memberof DashboardPlayers
     */
    'baseline'?: Assessment;
    /**
     * 
     * @type {Event}
     * @memberof DashboardPlayers
     */
    'event'?: Event;
    /**
     * 
     * @type {Array<PlayerHistory>}
     * @memberof DashboardPlayers
     */
    'status'?: Array<PlayerHistory>;
}
/**
 * current players in a team
 * @export
 * @interface DashboardTeams
 */
export interface DashboardTeams {
    /**
     * 
     * @type {Team}
     * @memberof DashboardTeams
     */
    'team'?: Team;
    /**
     * 
     * @type {Array<DashboardPlayers>}
     * @memberof DashboardTeams
     */
    'player'?: Array<DashboardPlayers>;
}
/**
 * asked at least 5 minutes after the immediate memory test
 * @export
 * @interface DelayedRecallMode
 */
export interface DelayedRecallMode {
    /**
     * number of words remembered out of 10
     * @type {number}
     * @memberof DelayedRecallMode
     */
    'delayedRecallScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof DelayedRecallMode
     */
    'delayedRecallWords'?: string;
}
/**
 * One Assessment has many detailed symptoms. 1-22 including severity
 * @export
 * @interface DetailedSymptom
 */
export interface DetailedSymptom {
    /**
     * 
     * @type {number}
     * @memberof DetailedSymptom
     */
    'id'?: number;
    /**
     * 
     * @type {Symptom}
     * @memberof DetailedSymptom
     */
    'symptom'?: Symptom;
    /**
     * when you started to feel the symptom
     * @type {string}
     * @memberof DetailedSymptom
     */
    'presented'?: DetailedSymptomPresentedEnum;
    /**
     * how much? the maximum intensity of each symptom 1-2 = mild, 3-4 = moderate, 5-6 = severe
     * @type {number}
     * @memberof DetailedSymptom
     */
    'intensity'?: number;
    /**
     * 0 = gone, 1-2 = mild, 3-4 = moderate, 5-6 = severe
     * @type {number}
     * @memberof DetailedSymptom
     */
    'stillPresent'?: number;
    /**
     * 
     * @type {Duration}
     * @memberof DetailedSymptom
     */
    'duration'?: Duration;
    /**
     * If the symptom the player is reporting now is the same type as the one they reported during the baseline test
     * @type {boolean}
     * @memberof DetailedSymptom
     */
    'sameTypeAsBaseline'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum DetailedSymptomPresentedEnum {
    On_the_pitch = 'On the pitch',
    Post_match_Same_day = 'Post match, Same day',
    Post_match_days_after = 'Post match, days after'
}

/**
 * how long did the symtom last?
 * @export
 * @enum {string}
 */

export enum Duration {
    _0_15_minutes = '0-15 minutes',
    _15_minutes_1_hour = '15 minutes-1 hour',
    _1_hour_1st_night = '1 hour-1st night',
    _1st_night_2nd_night = '1st night-2nd night',
    beyond_second_night = 'beyond second night'
}


/**
 * stores a group of assessments that happen in a workflow order e.g. HIA1, HIA2, through to HIA4 (close event series)
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'name'?: string;
    /**
     * random notes added from the Admin UI
     * @type {string}
     * @memberof Event
     */
    'comments'?: string;
    /**
     * link to a video of the player gettign injured. Usually a 3-4 minute clip of all the action a player say in the game
     * @type {string}
     * @memberof Event
     */
    'videoUrl'?: string;
    /**
     * comma separated basenames of files attached to the event
     * @type {string}
     * @memberof Event
     */
    'attachedFiles'?: string;
    /**
     * 
     * @type {Player}
     * @memberof Event
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof Event
     */
    'team'?: Team;
    /**
     * 
     * @type {Fixture}
     * @memberof Event
     */
    'fixture'?: Fixture;
    /**
     * 
     * @type {EventType}
     * @memberof Event
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {Position}
     * @memberof Event
     */
    'position'?: Position;
    /**
     * 
     * @type {User}
     * @memberof Event
     */
    'createdBy'?: User;
    /**
     * 
     * @type {Protocol}
     * @memberof Event
     */
    'protocol'?: Protocol;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'closedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'injuryDate'?: string;
    /**
     * 
     * @type {ConcussionValue}
     * @memberof Event
     */
    'concussion'?: ConcussionValue;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'criteria1'?: boolean;
}


/**
 * if the fixture is not null, eventType should be Game. Otherwise, we need to know why it is null. If eventType is Game and fixture is null, this is shown on the admin for someone to fix later
 * @export
 * @enum {string}
 */

export enum EventType {
    Game = 'Game',
    Out_of_Competition = 'Out of Competition',
    Training = 'Training',
    Not_Rugby = 'Not Rugby'
}


/**
 * 
 * @export
 * @interface EventWithAssessments
 */
export interface EventWithAssessments {
    /**
     * 
     * @type {number}
     * @memberof EventWithAssessments
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessments
     */
    'name'?: string;
    /**
     * random notes added from the Admin UI
     * @type {string}
     * @memberof EventWithAssessments
     */
    'comments'?: string;
    /**
     * link to a video of the player gettign injured. Usually a 3-4 minute clip of all the action a player say in the game
     * @type {string}
     * @memberof EventWithAssessments
     */
    'videoUrl'?: string;
    /**
     * comma separated basenames of files attached to the event
     * @type {string}
     * @memberof EventWithAssessments
     */
    'attachedFiles'?: string;
    /**
     * 
     * @type {Player}
     * @memberof EventWithAssessments
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof EventWithAssessments
     */
    'team'?: Team;
    /**
     * 
     * @type {Fixture}
     * @memberof EventWithAssessments
     */
    'fixture'?: Fixture;
    /**
     * 
     * @type {EventType}
     * @memberof EventWithAssessments
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {Position}
     * @memberof EventWithAssessments
     */
    'position'?: Position;
    /**
     * 
     * @type {User}
     * @memberof EventWithAssessments
     */
    'createdBy'?: User;
    /**
     * 
     * @type {Protocol}
     * @memberof EventWithAssessments
     */
    'protocol'?: Protocol;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessments
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessments
     */
    'closedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessments
     */
    'injuryDate'?: string;
    /**
     * 
     * @type {ConcussionValue}
     * @memberof EventWithAssessments
     */
    'concussion'?: ConcussionValue;
    /**
     * 
     * @type {boolean}
     * @memberof EventWithAssessments
     */
    'criteria1'?: boolean;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof EventWithAssessments
     */
    'assessments'?: Array<Assessment>;
    /**
     * 
     * @type {Array<IMGAlert>}
     * @memberof EventWithAssessments
     */
    'iMGAlerts'?: Array<IMGAlert>;
}


/**
 * stores a group of assessments that happen in a workflow order e.g. HIA1, HIA2, through to HIA4 (close event series)
 * @export
 * @interface EventWithAssessmentsAllOf
 */
export interface EventWithAssessmentsAllOf {
    /**
     * 
     * @type {number}
     * @memberof EventWithAssessmentsAllOf
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'name'?: string;
    /**
     * random notes added from the Admin UI
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'comments'?: string;
    /**
     * link to a video of the player gettign injured. Usually a 3-4 minute clip of all the action a player say in the game
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'videoUrl'?: string;
    /**
     * comma separated basenames of files attached to the event
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'attachedFiles'?: string;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof EventWithAssessmentsAllOf
     */
    'assessments'?: Array<Assessment>;
    /**
     * 
     * @type {Array<IMGAlert>}
     * @memberof EventWithAssessmentsAllOf
     */
    'iMGAlerts'?: Array<IMGAlert>;
    /**
     * 
     * @type {Player}
     * @memberof EventWithAssessmentsAllOf
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof EventWithAssessmentsAllOf
     */
    'team'?: Team;
    /**
     * 
     * @type {Fixture}
     * @memberof EventWithAssessmentsAllOf
     */
    'fixture'?: Fixture;
    /**
     * 
     * @type {EventType}
     * @memberof EventWithAssessmentsAllOf
     */
    'eventType'?: EventType;
    /**
     * 
     * @type {Position}
     * @memberof EventWithAssessmentsAllOf
     */
    'position'?: Position;
    /**
     * 
     * @type {User}
     * @memberof EventWithAssessmentsAllOf
     */
    'createdBy'?: User;
    /**
     * 
     * @type {Protocol}
     * @memberof EventWithAssessmentsAllOf
     */
    'protocol'?: Protocol;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventWithAssessmentsAllOf
     */
    'closedAt'?: string;
}


/**
 * one page of events
 * @export
 * @interface EventsOnPage
 */
export interface EventsOnPage {
    /**
     * 
     * @type {Array<EventWithAssessments>}
     * @memberof EventsOnPage
     */
    'data'?: Array<EventWithAssessments>;
    /**
     * 
     * @type {Paginator}
     * @memberof EventsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * export lookup urls
 * @export
 * @interface ExportLookupURLs
 */
export interface ExportLookupURLs {
    /**
     * 
     * @type {object}
     * @memberof ExportLookupURLs
     */
    'gameevent'?: object;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'collision'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'contact'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'techniques'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'foulplay'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'presented'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'hia1result'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'hia2result'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'hia3result'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'hia1summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'hia2summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLookupURLs
     */
    'positions'?: string;
}
/**
 * 
 * @export
 * @interface ExportUnionData200Response
 */
export interface ExportUnionData200Response {
    /**
     * 
     * @type {ExportUnionURLs}
     * @memberof ExportUnionData200Response
     */
    'union'?: ExportUnionURLs;
    /**
     * 
     * @type {ExportLookupURLs}
     * @memberof ExportUnionData200Response
     */
    'lookup'?: ExportLookupURLs;
}
/**
 * export union urls
 * @export
 * @interface ExportUnionURLs
 */
export interface ExportUnionURLs {
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'players'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'assessments'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'playerAudits'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'events'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'teams'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'detailedSymptoms'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportUnionURLs
     */
    'unionLookupReference'?: string;
}
/**
 * 
 * @export
 * @interface ExternalConcussion
 */
export interface ExternalConcussion {
    /**
     * 
     * @type {number}
     * @memberof ExternalConcussion
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalConcussion
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalConcussion
     */
    'injuryDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalConcussion
     */
    'daysToRecover'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalConcussion
     */
    'historicExternalConcussion'?: boolean;
}
/**
 * one page of external concussions
 * @export
 * @interface ExternalConcussionsOnPage
 */
export interface ExternalConcussionsOnPage {
    /**
     * 
     * @type {Array<ExternalConcussion>}
     * @memberof ExternalConcussionsOnPage
     */
    'data'?: Array<ExternalConcussion>;
    /**
     * 
     * @type {Paginator}
     * @memberof ExternalConcussionsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * represents a scheduled rugby game, often in a tournament. Need to be aware of timezones e.g. kickOffTime will be the time zone of the venue
 * @export
 * @interface Fixture
 */
export interface Fixture {
    /**
     * 
     * @type {number}
     * @memberof Fixture
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Fixture
     */
    'title'?: string;
    /**
     * 
     * @type {User}
     * @memberof Fixture
     */
    'createdBy'?: User;
    /**
     * 
     * @type {string}
     * @memberof Fixture
     */
    'kickoffAt'?: string;
    /**
     * 
     * @type {Team}
     * @memberof Fixture
     */
    'homeTeam'?: Team;
    /**
     * 
     * @type {Team}
     * @memberof Fixture
     */
    'oppositionTeam'?: Team;
    /**
     * 
     * @type {TournamentOnly}
     * @memberof Fixture
     */
    'tournament'?: TournamentOnly;
    /**
     * 
     * @type {Venue}
     * @memberof Fixture
     */
    'venue'?: Venue;
    /**
     * 
     * @type {string}
     * @memberof Fixture
     */
    'round'?: string;
}
/**
 * one page of fixtures
 * @export
 * @interface FixturesOnPage
 */
export interface FixturesOnPage {
    /**
     * 
     * @type {Array<Fixture>}
     * @memberof FixturesOnPage
     */
    'data'?: Array<Fixture>;
    /**
     * 
     * @type {Paginator}
     * @memberof FixturesOnPage
     */
    'paginator'?: Paginator;
}
/**
 * user has lost their password. request the server to send an email with a reset link
 * @export
 * @interface ForgotPassword
 */
export interface ForgotPassword {
    /**
     * 
     * @type {string}
     * @memberof ForgotPassword
     */
    'email'?: string;
    /**
     * 
     * @type {Interface}
     * @memberof ForgotPassword
     */
    'interface'?: Interface;
}


/**
 * 
 * @export
 * @interface GetEventFile200Response
 */
export interface GetEventFile200Response {
    /**
     * the signed S3 url to download the file
     * @type {string}
     * @memberof GetEventFile200Response
     */
    'url'?: string;
}
/**
 * for the graphs on the home page. All values are a sum over the last week from now
 * @export
 * @interface GraphData
 */
export interface GraphData {
    /**
     * number of hia1 assessments done
     * @type {number}
     * @memberof GraphData
     */
    'hia1Count'?: number;
    /**
     * number of criteria1s done. All the rest are off field screens
     * @type {number}
     * @memberof GraphData
     */
    'hia1criteria1Count'?: number;
    /**
     * number of hia2 assessments done
     * @type {number}
     * @memberof GraphData
     */
    'hia2Count'?: number;
    /**
     * number of hia2 s where concussion was found
     * @type {number}
     * @memberof GraphData
     */
    'hia2Abnormal'?: number;
    /**
     * number of hia3 assessments done
     * @type {number}
     * @memberof GraphData
     */
    'hia3Count'?: number;
    /**
     * number of hia3 s which were abnormal
     * @type {number}
     * @memberof GraphData
     */
    'hia3Abnormal'?: number;
    /**
     * number of injury events
     * @type {number}
     * @memberof GraphData
     */
    'eventCount'?: number;
    /**
     * sum of criteria1 fail, hia2 is abnnormal, hia 3 abnormal, clinical suspicion at any stage over all assessments in the event
     * @type {number}
     * @memberof GraphData
     */
    'eventIsConcussion'?: number;
}
/**
 * section 2 page 2 of hia1 paper form
 * @export
 * @interface Hia1ClinicalSignsMode
 */
export interface Hia1ClinicalSignsMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia1ClinicalSignsMode
     */
    'emotional'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1ClinicalSignsMode
     */
    'poorConcentration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1ClinicalSignsMode
     */
    'doctorSuspectsConcussionDespiteNegativeHia'?: boolean;
}
/**
 * https://www.sketch.com/s/a46dfcc1-bd12-4aab-8df8-3d728f5df074/a/v80mRde
 * @export
 * @interface Hia1Criteria1Mode
 */
export interface Hia1Criteria1Mode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'tonicPosturing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'suspectedLossConsciousness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'confirmedLossConsciousness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'balanceDisturbanceAtaxia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'dazedOrDinged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'behaviouralChanges'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'oculomotorSigns'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'convulsions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'notOrientedInTimeAndSpace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'definiteConfusion'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'onFieldIndicationOfConcussion'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'u19RecogniseAndRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1Criteria1Mode
     */
    'other'?: boolean;
}
/**
 * 
 * @export
 * @interface Hia1MaddocksMode
 */
export interface Hia1MaddocksMode {
    /**
     * player knows the venue
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'venue'?: boolean;
    /**
     * player knows which half of the game they are playing
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'half'?: boolean;
    /**
     * player knows who scored last in this match
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'lastScored'?: boolean;
    /**
     * player knows which team they played last
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'lastTeamPlayed'?: boolean;
    /**
     * player knows who won their last game
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'lastGameWon'?: boolean;
    /**
     * maddocks does not apply
     * @type {boolean}
     * @memberof Hia1MaddocksMode
     */
    'notApplicable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hia1MaddocksMode
     */
    'notes'?: string;
}
/**
 * section 2 of form
 * @export
 * @interface Hia1OffFieldMode
 */
export interface Hia1OffFieldMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'headInjuryDiagnosisNotApparent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'possibleConfusion'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'subThresholdCriteriaSign'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'possibleBehaviourChanges'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'possibleConcussiveEvent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1OffFieldMode
     */
    'imgAlert'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hia1OffFieldMode
     */
    'other'?: string;
}
/**
 * from hia result lookup
 * @export
 * @enum {string}
 */

export enum Hia1Result {
    Yes_criteria_1_sign_or_symptom_confirmed = 'Yes, criteria 1 sign or symptom confirmed',
    Yes_off_field_HIA1_screen_abnormal = 'Yes, off field HIA1 screen abnormal',
    Yes_clinical_suspicion_despite_normal_off_field_HIA1_screen = 'Yes, clinical suspicion despite normal off field HIA1 screen',
    Yes_player_removed_for_another_injury = 'Yes, player removed for another injury',
    Yes_under_19_recognise_and_remove = 'Yes, under 19 recognise and remove',
    No_player_returned_after_off_field_HIA1_screen = 'No, player returned after off field HIA1 screen',
    No_clinical_judgement_overruled_abnormal_off_field_HIA1_screen = 'No, clinical judgement overruled abnormal off field HIA1 screen',
    No_game_finished___player_would_have_returned_to_play = 'No, game finished - player would have returned to play',
    No_game_finished___player_would_have_been_removed = 'No, game finished - player would have been removed'
}


/**
 * hia1 form page 3, hia2 form page 1 (top section) not sure if we need result, otherInjury, normalReturnPlay,
 * @export
 * @interface Hia1ResultMode
 */
export interface Hia1ResultMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia1ResultMode
     */
    'playerRemoved'?: boolean;
    /**
     * 
     * @type {Hia1Result}
     * @memberof Hia1ResultMode
     */
    'logicResult'?: Hia1Result;
    /**
     * 
     * @type {Hia1Result}
     * @memberof Hia1ResultMode
     */
    'doctorResult'?: Hia1Result;
    /**
     * hia1resultNotes
     * @type {string}
     * @memberof Hia1ResultMode
     */
    'notes'?: string;
    /**
     * player removed for other injury
     * @type {boolean}
     * @memberof Hia1ResultMode
     */
    'otherInjury'?: boolean;
    /**
     * what the other injury was or why they were removed
     * @type {string}
     * @memberof Hia1ResultMode
     */
    'otherInjuryDetail'?: string;
    /**
     * player renmoved because of abnormal hia result
     * @type {boolean}
     * @memberof Hia1ResultMode
     */
    'abnormalHIAResult'?: boolean;
    /**
     * player returned to play
     * @type {boolean}
     * @memberof Hia1ResultMode
     */
    'normalReturnToPlay'?: boolean;
}


/**
 * the end result of the hia 1, summarised for later hias
 * @export
 * @enum {string}
 */

export enum Hia1Summary {
    Yes_criteria_1_sign_or_symptom_confirmed = 'Yes, criteria 1 sign or symptom confirmed',
    Yes_off_field_HIA1_screen_abnormal = 'Yes, off field HIA1 screen abnormal',
    Yes_clinical_suspicion_despite_normal_off_field_HIA1_screen = 'Yes, clinical suspicion despite normal off field HIA1 screen',
    Yes_under_19_recognise_and_remove = 'Yes, under 19 recognise and remove',
    Yes_player_returned_after_off_field_HIA1_screen = 'Yes, player returned after off field HIA1 screen',
    Yes_player_removed_for_another_injury = 'Yes, player removed for another injury',
    Yes_clinical_judgement_overruled_abnormal_off_field_HIA1_screen = 'Yes, clinical judgement overruled abnormal off field HIA1 screen',
    Yes_game_finished___player_would_have_returned_to_play = 'Yes, game finished - player would have returned to play',
    Yes_game_finished___player_would_have_been_removed = 'Yes, game finished - player would have been removed',
    No_symptoms_appeared_after_completion_of_the_game = 'No, symptoms appeared after completion of the game',
    No_HIA1_off_field_screen_not_completed_despite_an_indication = 'No, HIA1 off field screen not completed despite an indication',
    No_suspicious_event_identified_by_video_or_direct_observation_after_the_game = 'No, suspicious event identified by video or direct observation after the game',
    No_player_removed_under_unrecorded_Criteria_1 = 'No, player removed under unrecorded Criteria 1',
    No_training_incident = 'No, training incident',
    No_training_injury___Criteria_1 = 'No, training injury - Criteria 1',
    No_player_injured_at_non_competition_game = 'No, player injured at non competition game',
    No_player_injured_at_non_competition_game___Criteria_1 = 'No, player injured at non competition game - Criteria 1',
    Yes_completed_but_not_available_at_time_of_HIA2 = 'Yes, completed but not available at time of HIA2',
    No_symptoms_appeared_24_48_hours_after_the_game = 'No, symptoms appeared 24-48 hours after the game',
    No_non_rugby_injury = 'No, non rugby injury',
    No_non_rugby_injury___Criteria_1 = 'No, non rugby injury - Criteria 1',
    iMG_Activated_Assessment___Delayed_Alert = 'iMG Activated Assessment - Delayed Alert'
}


/**
 * 
 * @export
 * @interface Hia1SymptomsMode
 */
export interface Hia1SymptomsMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'headache'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'dizziness'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'pressureInHead'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'nauseaOrVomiting'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'blurredVision'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'sensitivityToLightOrNoise'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'feelingSlowedDown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'foggy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia1SymptomsMode
     */
    'feelUnwell'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Hia2Result {
    Normal_concussion_not_confirmed = 'Normal, concussion not confirmed',
    Normal_but_clinical_suspicion_supports_a_concussion = 'Normal, but clinical suspicion supports a concussion',
    Abnormal_concussion_confirmed = 'Abnormal, concussion confirmed',
    Concussion_not_confirmed_doctors_clinical_judgement_overruled_abnormal_HIA2 = 'Concussion not confirmed; doctor\'s clinical judgement overruled abnormal HIA2',
    Abnormal_due_to_non_concussive_injury_or_illness = 'Abnormal, due to non-concussive injury or illness',
    Unable_to_do___clinical_judgement_of_no_concussion = 'Unable to do - clinical judgement of no concussion',
    Unable_to_do___clinical_suspicion_of_concussion = 'Unable to do - clinical suspicion of concussion',
    New_HIA_event_started_this_HIA_event_was_closed = 'New HIA event started, this HIA event was closed'
}


/**
 * 
 * @export
 * @interface Hia2ResultMode
 */
export interface Hia2ResultMode {
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'logicResult'?: Hia2Result;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'doctorResult'?: Hia2Result;
    /**
     * hia2doctorNotes
     * @type {string}
     * @memberof Hia2ResultMode
     */
    'notes'?: string;
    /**
     * 
     * @type {Hia1Result}
     * @memberof Hia2ResultMode
     */
    'hia1importedResult'?: Hia1Result;
    /**
     * 
     * @type {Hia1Summary}
     * @memberof Hia2ResultMode
     */
    'hia1doctorResult'?: Hia1Summary;
    /**
     * hia2hia1doctorNotes
     * @type {string}
     * @memberof Hia2ResultMode
     */
    'hia1notes'?: string;
    /**
     * diagnosis to date- if a concussion has been identified by criteria
     * @type {boolean}
     * @memberof Hia2ResultMode
     */
    'concussionIdentified'?: boolean;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'day1logicResult'?: Hia2Result;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'day1doctorResult'?: Hia2Result;
    /**
     * hia2day1doctorNotes
     * @type {string}
     * @memberof Hia2ResultMode
     */
    'day1doctorNotes'?: string;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'day2hia2day1importedResult'?: Hia2Result;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia2ResultMode
     */
    'day2hia2day1doctorResult'?: Hia2Summary;
    /**
     * hia2day2hia2day1doctorNotes
     * @type {string}
     * @memberof Hia2ResultMode
     */
    'day2hia2day1doctorNotes'?: string;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'day2logicResult'?: Hia2Result;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia2ResultMode
     */
    'day2doctorResult'?: Hia2Result;
    /**
     * hia2day2doctorNotes
     * @type {string}
     * @memberof Hia2ResultMode
     */
    'day2doctorNotes'?: string;
    /**
     * 
     * @type {Hia1Summary}
     * @memberof Hia2ResultMode
     */
    'day2hia1importedResult'?: Hia1Summary;
}


/**
 * the end result of the hia 2, summarised for later hias
 * @export
 * @enum {string}
 */

export enum Hia2Summary {
    Yes_normal_concussion_not_confirmed = 'Yes, normal, concussion not confirmed',
    Yes_normal_but_clinical_suspicion_supports_a_concussion = 'Yes, normal, but clinical suspicion supports a concussion',
    Yes_abnormal_concussion_confirmed = 'Yes, abnormal, concussion confirmed',
    Yes_concussion_not_confirmed_doctors_clinical_judgement_overruled_abnormal_HIA_2 = 'Yes, concussion not confirmed; doctor\'s clinical judgement overruled abnormal HIA 2',
    Yes_abnormal_due_to_non_concussive_injury_or_illness = 'Yes, abnormal due to non-concussive injury or illness',
    No_HIA2_off_field_screen_not_completed_despite_an_indication = 'No, HIA2 off field screen not completed despite an indication',
    No_symptoms_appeared_more_than_3_hours_after_injury = 'No, symptoms appeared more than 3 hours after injury',
    No_suspicious_event_identified_by_video_or_direct_observation_after_the_game = 'No, suspicious event identified by video or direct observation after the game',
    No_training_incident = 'No, training incident',
    No_unable_to_do___clinical_judgement_of_no_concussion = 'No, unable to do - clinical judgement of no concussion',
    No_unable_to_do___clinical_suspicion_of_concussion = 'No, unable to do - clinical suspicion of concussion',
    No_New_HIA_event_started_this_HIA_event_was_closed = 'No, New HIA event started, this HIA event was closed',
    No_training_injury___Criteria_1 = 'No, training injury - Criteria 1',
    No_symptoms_appeared_24_48_hours_after_the_game = 'No, symptoms appeared 24-48 hours after the game',
    No_non_rugby_injury = 'No, non rugby injury',
    No_player_injured_at_non_competition_game = 'No, player injured at non competition game',
    iMG_Activated_Assessment___Delayed_Alert = 'iMG Activated Assessment - Delayed Alert'
}


/**
 * 
 * @export
 * @interface Hia3AmnesiaMode
 */
export interface Hia3AmnesiaMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia3AmnesiaMode
     */
    'anterograde'?: boolean;
    /**
     * 
     * @type {Duration}
     * @memberof Hia3AmnesiaMode
     */
    'anterogradeDuration'?: Duration;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3AmnesiaMode
     */
    'retrograde'?: boolean;
    /**
     * 
     * @type {Duration}
     * @memberof Hia3AmnesiaMode
     */
    'retrogradeDuration'?: Duration;
}


/**
 * computer cognitive assessment result (if used)
 * @export
 * @interface Hia3ComputerCognitiveMode
 */
export interface Hia3ComputerCognitiveMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ComputerCognitiveMode
     */
    'signsOfConcussion'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hia3ComputerCognitiveMode
     */
    'signsOfConcussionNotes'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ComputerCognitiveMode
     */
    'cogSport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ComputerCognitiveMode
     */
    'headMinder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ComputerCognitiveMode
     */
    'impact'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Hia3ComputerCognitiveMode
     */
    'otherDetail'?: string;
}
/**
 * incident details
 * @export
 * @interface Hia3IncidentDetails
 */
export interface Hia3IncidentDetails {
    /**
     * 
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'gameEvent'?: Hia3IncidentDetailsGameEventEnum;
    /**
     * if Other is selected for gameEvent
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'gameEventOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'collisionWith'?: Hia3IncidentDetailsCollisionWithEnum;
    /**
     * if Other is selected for collisionWith
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'collisionOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'contactWith'?: Hia3IncidentDetailsContactWithEnum;
    /**
     * if Other is selected for contactWith
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'contactOther'?: string;
    /**
     * todo is this needed? duplicate of contactOther
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'contactOtherDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'playerTechnique'?: Hia3IncidentDetailsPlayerTechniqueEnum;
    /**
     * if Other is selected for playerTechnique
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'playerTechniqueOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hia3IncidentDetails
     */
    'foulPlay'?: Hia3IncidentDetailsFoulPlayEnum;
    /**
     * valid range is 1,2,3,4 or not applicable (null))
     * @type {number}
     * @memberof Hia3IncidentDetails
     */
    'quarter'?: number;
    /**
     * valid values are yes, no, not relevant (null)
     * @type {boolean}
     * @memberof Hia3IncidentDetails
     */
    'incidentPrecipitatedHIAProcessPostGame'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum Hia3IncidentDetailsGameEventEnum {
    Tackling = 'Tackling',
    Being_Tackled = 'Being Tackled',
    Ruck_maul = 'Ruck/maul',
    Scrum = 'Scrum',
    Accidental_Collision = 'Accidental Collision',
    Unknown = 'Unknown',
    Other = 'Other'
}
/**
    * @export
    * @enum {string}
    */
export enum Hia3IncidentDetailsCollisionWithEnum {
    Opponent = 'Opponent',
    Co_player = 'Co-player',
    Ground = 'Ground',
    Unknown = 'Unknown',
    Other = 'Other'
}
/**
    * @export
    * @enum {string}
    */
export enum Hia3IncidentDetailsContactWithEnum {
    Head_with_head = 'Head with head',
    Head_with_shoulder = 'Head with shoulder',
    Head_with_upper_limb = 'Head with upper limb',
    Head_with_knee_or_hip = 'Head with knee or hip',
    Head_with_foot___lower_leg = 'Head with foot / lower leg',
    Head_with_ground = 'Head with ground',
    Indirect_transmission_of_force_to_head = 'Indirect transmission of force to head',
    Unknown = 'Unknown',
    Other = 'Other'
}
/**
    * @export
    * @enum {string}
    */
export enum Hia3IncidentDetailsPlayerTechniqueEnum {
    Correct_technique = 'Correct technique',
    Incorrect_head_position = 'Incorrect head position',
    Other_incorrect_technique = 'Other incorrect technique',
    Unknown = 'Unknown',
    Not_applicable = 'Not applicable',
    Other = 'Other'
}
/**
    * @export
    * @enum {string}
    */
export enum Hia3IncidentDetailsFoulPlayEnum {
    Sanction_given_to_tackler = 'Sanction given to tackler',
    Sanction_given_to_ball_carrier = 'Sanction given to ball carrier',
    Not_applicable = 'Not applicable'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum Hia3Result {
    Normal_concussion_not_confirmed = 'Normal, concussion not confirmed',
    Normal_but_clinical_suspicion_supports_a_concussion = 'Normal, but clinical suspicion supports a concussion',
    Abnormal_concussion_confirmed = 'Abnormal, concussion confirmed',
    Concussion_not_confirmed_doctors_clinical_judgement_overruled_abnormal_HIA3 = 'Concussion not confirmed; doctor\'s clinical judgement overruled abnormal HIA3',
    Abnormal_due_to_non_concussive_injury_or_illness = 'Abnormal, due to non-concussive injury or illness',
    Unable_to_do___clinical_judgement_of_no_concussion = 'Unable to do - clinical judgement of no concussion',
    Unable_to_do___clinical_suspicion_of_concussion = 'Unable to do - clinical suspicion of concussion',
    New_HIA_event_started_this_HIA_event_was_closed = 'New HIA event started, this HIA event was closed'
}


/**
 * 
 * @export
 * @interface Hia3ResultMode
 */
export interface Hia3ResultMode {
    /**
     * 
     * @type {Hia3Result}
     * @memberof Hia3ResultMode
     */
    'logicResult'?: Hia3Result;
    /**
     * 
     * @type {Hia3Result}
     * @memberof Hia3ResultMode
     */
    'doctorResult'?: Hia3Result;
    /**
     * hia3doctorNotes
     * @type {string}
     * @memberof Hia3ResultMode
     */
    'notes'?: string;
    /**
     * 
     * @type {Hia1Summary}
     * @memberof Hia3ResultMode
     */
    'hia1importedResult'?: Hia1Summary;
    /**
     * 
     * @type {Hia1Summary}
     * @memberof Hia3ResultMode
     */
    'hia1doctorResult'?: Hia1Summary;
    /**
     * hia3hia1doctorNotes
     * @type {string}
     * @memberof Hia3ResultMode
     */
    'hia1notes'?: string;
    /**
     * 
     * @type {Hia2Result}
     * @memberof Hia3ResultMode
     */
    'hia2importedResult'?: Hia2Result;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia3ResultMode
     */
    'hia2doctorResult'?: Hia2Summary;
    /**
     * hia3hia2doctorNotes
     * @type {string}
     * @memberof Hia3ResultMode
     */
    'hia2notes'?: string;
    /**
     * diagnosis to date- if a concussion has been identified by criteria
     * @type {boolean}
     * @memberof Hia3ResultMode
     */
    'concussionIdentified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ResultMode
     */
    'criteria1Identified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ResultMode
     */
    'hia2Abnormal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ResultMode
     */
    'hia3Abnormal'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3ResultMode
     */
    'clinicalSuspicion'?: boolean;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia3ResultMode
     */
    'hia2day1importedResult'?: Hia2Summary;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia3ResultMode
     */
    'hia2day1doctorResult'?: Hia2Summary;
    /**
     * 
     * @type {string}
     * @memberof Hia3ResultMode
     */
    'hia2day1notes'?: string;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia3ResultMode
     */
    'hia2day2importedResult'?: Hia2Summary;
    /**
     * 
     * @type {Hia2Summary}
     * @memberof Hia3ResultMode
     */
    'hia2day2doctorResult'?: Hia2Summary;
    /**
     * 
     * @type {string}
     * @memberof Hia3ResultMode
     */
    'hia2day2notes'?: string;
}


/**
 * todo these all need descriptions. They are not on the paper form from Ed
 * @export
 * @interface Hia3VideoReviewedMode
 */
export interface Hia3VideoReviewedMode {
    /**
     * 
     * @type {boolean}
     * @memberof Hia3VideoReviewedMode
     */
    'performed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3VideoReviewedMode
     */
    'influencedRequest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Hia3VideoReviewedMode
     */
    'influencedDecision'?: boolean;
}
/**
 * 
 * @export
 * @interface Hia4ResultMode
 */
export interface Hia4ResultMode {
    /**
     * 
     * @type {string}
     * @memberof Hia4ResultMode
     */
    'returnToPlayDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hia4ResultMode
     */
    'completedFullRtpProcess'?: boolean;
    /**
     * reason for not completing full RTP process
     * @type {string}
     * @memberof Hia4ResultMode
     */
    'noRtpReason'?: string;
}
/**
 * the content of the ICC review
 * @export
 * @interface ICCReview
 */
export interface ICCReview {
    /**
     * primary key unique id
     * @type {number}
     * @memberof ICCReview
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerHasPreviousConcussionWithin3Months'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerHasHad3ConcussionsInThePast12Months'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'reducedImpactThreshold'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'concussionComplicatedByPsychologicalIssues'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'previousConcussionGreaterThan21Days'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'returnToPlaySafeWithin10Days'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerHasHad5OrMoreEliteConcussions'?: boolean;
    /**
     * what the doctor suggests the palyer should do
     * @type {string}
     * @memberof ICCReview
     */
    'dateOfProposedNextGame'?: string;
    /**
     * what the ICC reviewer allows after the review
     * @type {string}
     * @memberof ICCReview
     */
    'dateAllowedToReturn'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'allowedToReturn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICCReview
     */
    'dateOfProposedContactTraining'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICCReview
     */
    'dateOfAllowedContactTraining'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'allowedReturnToImmediateContactTraining'?: boolean;
    /**
     * during the consultation
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerPresent'?: boolean;
    /**
     * why the player was not present
     * @type {string}
     * @memberof ICCReview
     */
    'playerNotPresentReason'?: string;
    /**
     * during the consultation
     * @type {boolean}
     * @memberof ICCReview
     */
    'doctorPresent'?: boolean;
    /**
     * why the doctor was not present
     * @type {string}
     * @memberof ICCReview
     */
    'doctorNotPresentReason'?: string;
    /**
     * ICC had a private conversation with player
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerConversation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICCReview
     */
    'playerConversationNotes'?: string;
    /**
     * ICC had a private conversation with team doctor
     * @type {boolean}
     * @memberof ICCReview
     */
    'doctorConversation'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICCReview
     */
    'doctorConversationNotes'?: string;
    /**
     * player withdrew themself during consulation
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerWithdrew'?: boolean;
    /**
     * with final decision
     * @type {boolean}
     * @memberof ICCReview
     */
    'playerAgrees'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReview
     */
    'teamDoctorAgrees'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICCReview
     */
    'furtherInvestigationsNeeded'?: string;
    /**
     * not all the required information was present. List what was missing
     * @type {string}
     * @memberof ICCReview
     */
    'missingInformation'?: string;
    /**
     * other notes from the requesting doctor
     * @type {string}
     * @memberof ICCReview
     */
    'requestNotes'?: string;
    /**
     * other notes from the reviewing doctor
     * @type {string}
     * @memberof ICCReview
     */
    'reviewNotes'?: string;
    /**
     * when this was requested by the referring doctor (requestedBy user)
     * @type {string}
     * @memberof ICCReview
     */
    'createdAt'?: string;
    /**
     * when this was completed by the ICC
     * @type {string}
     * @memberof ICCReview
     */
    'completedAt'?: string;
    /**
     * the purchase order number entered by the Report Viewer
     * @type {string}
     * @memberof ICCReview
     */
    'purchaseOrder'?: string;
    /**
     * 
     * @type {Event}
     * @memberof ICCReview
     */
    'event'?: Event;
    /**
     * 
     * @type {User}
     * @memberof ICCReview
     */
    'requestedBy'?: User;
    /**
     * 
     * @type {User}
     * @memberof ICCReview
     */
    'assignedTo'?: User;
    /**
     * 
     * @type {User}
     * @memberof ICCReview
     */
    'completedBy'?: User;
}
/**
 * ask an ICC to review a player
 * @export
 * @interface ICCReviewRequest
 */
export interface ICCReviewRequest {
    /**
     * the event to review
     * @type {number}
     * @memberof ICCReviewRequest
     */
    'eventId'?: number;
    /**
     * The ICC reviewer
     * @type {number}
     * @memberof ICCReviewRequest
     */
    'assignedToId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ICCReviewRequest
     */
    'other'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICCReviewRequest
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'playerHasPreviousConcussionWithin3Months'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'playerHasHad3ConcussionsInThePast12Months'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'reducedImpactThreshold'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'concussionComplicatedByPsychologicalIssues'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'previousConcussionGreaterThan21Days'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'returnToPlaySafeWithin10Days'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICCReviewRequest
     */
    'playerHasHad5OrMoreEliteConcussions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICCReviewRequest
     */
    'dateOfProposedNextGame'?: string;
    /**
     * 
     * @type {string}
     * @memberof ICCReviewRequest
     */
    'dateOfProposedReturnToContact'?: string;
}
/**
 * one page of icc reviews. if showCompleted == 0, reviews should be sorted in ascending date order (oldest at the top, newest at the bottom) so the user can see overdue ones easily. If showCompleted > 0, reviews should be sorted in descending date order (newest at the top) so the use does not have to wade through pages of reviews to get to the ones that are most interesting
 * @export
 * @interface ICCReviewsOnPage
 */
export interface ICCReviewsOnPage {
    /**
     * 
     * @type {Array<ICCReview>}
     * @memberof ICCReviewsOnPage
     */
    'data'?: Array<ICCReview>;
    /**
     * 
     * @type {Paginator}
     * @memberof ICCReviewsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * Instrumented MouthGuard Alert
 * @export
 * @interface IMGAlert
 */
export interface IMGAlert {
    /**
     * 
     * @type {number}
     * @memberof IMGAlert
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IMGAlert
     */
    'dateTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof IMGAlert
     */
    'PLA'?: number;
    /**
     * 
     * @type {number}
     * @memberof IMGAlert
     */
    'PAA'?: number;
    /**
     * 
     * @type {number}
     * @memberof IMGAlert
     */
    'workload'?: number;
    /**
     * 
     * @type {string}
     * @memberof IMGAlert
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof IMGAlert
     */
    'displayId'?: string;
    /**
     * 
     * @type {IMGAlertImgProvider}
     * @memberof IMGAlert
     */
    'imgProvider': IMGAlertImgProvider;
    /**
     * 
     * @type {boolean}
     * @memberof IMGAlert
     */
    'void'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IMGAlert
     */
    'informationalJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof IMGAlert
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface IMGAlertImgProvider
 */
export interface IMGAlertImgProvider {
    /**
     * 
     * @type {string}
     * @memberof IMGAlertImgProvider
     */
    'shortName'?: string;
}
/**
 * for /event/id/ignore
 * @export
 * @interface IgnoreEventConfirmationInfo
 */
export interface IgnoreEventConfirmationInfo {
    /**
     * 
     * @type {IgnoreEventConfirmationInfoPreviousEventToReopen}
     * @memberof IgnoreEventConfirmationInfo
     */
    'previousEventToReopen': IgnoreEventConfirmationInfoPreviousEventToReopen | null;
}
/**
 * Details of previous event user should be prompted to reopen, or null if no such event exists
 * @export
 * @interface IgnoreEventConfirmationInfoPreviousEventToReopen
 */
export interface IgnoreEventConfirmationInfoPreviousEventToReopen {
    /**
     * 
     * @type {number}
     * @memberof IgnoreEventConfirmationInfoPreviousEventToReopen
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof IgnoreEventConfirmationInfoPreviousEventToReopen
     */
    'prompt': string;
}
/**
 * for /event/id/ignore
 * @export
 * @interface IgnoreEventOptions
 */
export interface IgnoreEventOptions {
    /**
     * Whether user has confirmed
     * @type {boolean}
     * @memberof IgnoreEventOptions
     */
    'confirm'?: boolean;
    /**
     * Id of previous event to reopen
     * @type {number}
     * @memberof IgnoreEventOptions
     */
    'reopenEventId'?: number | null;
}
/**
 * the server may send a different link for the admin interface vs the phone app
 * @export
 * @enum {string}
 */

export enum Interface {
    admin = 'admin',
    mobile = 'mobile'
}


/**
 * 
 * @export
 * @interface Login
 */
export interface Login {
    /**
     * 
     * @type {string}
     * @memberof Login
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Login
     */
    'password'?: string;
    /**
     * 
     * @type {Interface}
     * @memberof Login
     */
    'interface'?: Interface;
}


/**
 * sent when the user is logging out
 * @export
 * @interface Logout
 */
export interface Logout {
    /**
     * 
     * @type {string}
     * @memberof Logout
     */
    'authToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Logout
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {Interface}
     * @memberof Logout
     */
    'interface'?: Interface;
}


/**
 * 
 * @export
 * @interface LookupString
 */
export interface LookupString {
    /**
     * 
     * @type {number}
     * @memberof LookupString
     */
    'id'?: number;
    /**
     * what kind of value this is eg hiaresult, technique, player status
     * @type {string}
     * @memberof LookupString
     */
    'type'?: string;
    /**
     * the actual value
     * @type {string}
     * @memberof LookupString
     */
    'value'?: string;
}
/**
 * all the lookups inthe database
 * @export
 * @interface Lookups
 */
export interface Lookups {
    /**
     * 
     * @type {Array<LookupString>}
     * @memberof Lookups
     */
    'data'?: Array<LookupString>;
}
/**
 * sent by /auth/login if multi factor authentication is needed
 * @export
 * @interface MFAChallenge
 */
export interface MFAChallenge {
    /**
     * always true
     * @type {boolean}
     * @memberof MFAChallenge
     */
    'mfaRequired'?: boolean;
    /**
     * 96+ character random string which must be returned in the /auth/mfa POST
     * @type {string}
     * @memberof MFAChallenge
     */
    'token'?: string;
    /**
     * what device the user should look on for their 6 digit code eg email or phone or otp app
     * @type {string}
     * @memberof MFAChallenge
     */
    'device'?: string;
    /**
     * a human friendly list of which alternate devices a user could request their mfa code to resend via. The device parameter above must match exactly one of the items in this list. List must have one or more item
     * @type {Array<string>}
     * @memberof MFAChallenge
     */
    'devicesAvailable'?: Array<string>;
}
/**
 * POST this to /auth/mfa. If the mfaCode is blank/missing, then resend the code to the specified device (which must be from the list in MFAChallenge.devicesAvailable) and reply with a new MFAChallenge
 * @export
 * @interface MFAResponse
 */
export interface MFAResponse {
    /**
     * 96+ character random string from the MFACHallenge
     * @type {string}
     * @memberof MFAResponse
     */
    'token'?: string;
    /**
     * the device from the MFAChallenge
     * @type {string}
     * @memberof MFAResponse
     */
    'device'?: string;
    /**
     * the 6 digit passcode generated by the mfa device. If blank/missing, resend the MFAChallenge to the requested device
     * @type {number}
     * @memberof MFAResponse
     */
    'mfaCode'?: number;
}
/**
 * for /player/id/mergeFrom
 * @export
 * @interface MergePlayer
 */
export interface MergePlayer {
    /**
     * array of Player field names to copy from the fromPlayer into the destination player
     * @type {Array<string>}
     * @memberof MergePlayer
     */
    'fieldsToCopy'?: Array<string>;
}
/**
 * write the message and content to the api logs, along with device info if provided and the currently logged in user
 * @export
 * @interface MessageToLog
 */
export interface MessageToLog {
    /**
     * a brief summary of what went wrong (human readable). For critical errors, this may be sent to a human via SMS
     * @type {string}
     * @memberof MessageToLog
     */
    'message'?: string;
    /**
     * how bad is it really? Critical means Wake up a Human because the world is burning.
     * @type {string}
     * @memberof MessageToLog
     */
    'severity'?: MessageToLogSeverityEnum;
    /**
     * a json blob with extra information or context so we can figure out what went wrong
     * @type {string}
     * @memberof MessageToLog
     */
    'content'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MessageToLogSeverityEnum {
    Debug = 'Debug',
    Warning = 'Warning',
    Error = 'Error',
    Critical = 'Critical'
}

/**
 * 
 * @export
 * @interface Mode
 */
export interface Mode {
    /**
     * 
     * @type {number}
     * @memberof Mode
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Mode
     */
    'name'?: ModeNameEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ModeNameEnum {
    balanceSingleLeg = 'balanceSingleLeg',
    balanceTandem = 'balanceTandem',
    cog = 'cog',
    delayedRecall = 'delayedRecall',
    immediateMemory = 'immediateMemory',
    symptoms = 'symptoms',
    neckExam = 'neckExam',
    numbersBackwards = 'numbersBackwards',
    monthsBackwards = 'monthsBackwards',
    criteria1 = 'criteria1',
    hiaSymptoms = 'hiaSymptoms',
    playerRemoved = 'playerRemoved',
    completedBy = 'completedBy',
    offField = 'offField',
    maddocks = 'maddocks',
    bailOut = 'bailOut',
    hia1Result = 'hia1Result',
    hia2Result = 'hia2Result',
    hia2HiaDiagnosisToDate = 'hia2HiaDiagnosisToDate',
    hia3DetailedSymtoms = 'hia3DetailedSymtoms',
    hia3InjuryGameDetails = 'hia3InjuryGameDetails',
    hia3Amensia = 'hia3Amensia',
    hia3ComputerCognitive = 'hia3ComputerCognitive',
    hia3Result = 'hia3Result',
    hia3OverallHiaResult = 'hia3OverallHiaResult'
}

/**
 * 
 * @export
 * @interface MonthsMode
 */
export interface MonthsMode {
    /**
     * number of months they got correct when reciting months backwards
     * @type {number}
     * @memberof MonthsMode
     */
    'monthResult'?: number;
}
/**
 * 
 * @export
 * @interface NeckExamMode
 */
export interface NeckExamMode {
    /**
     * 
     * @type {string}
     * @memberof NeckExamMode
     */
    'neckExamComment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NeckExamMode
     */
    'neckExamNotApplicable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NeckExamMode
     */
    'neckExamPainFreeCervicalSpineMovement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NeckExamMode
     */
    'neckExamPainFreeAtRest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NeckExamMode
     */
    'neckExamPainFreeMovement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NeckExamMode
     */
    'neckExamLimbStrengthAndSensationNormal'?: boolean;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    'id'?: number;
    /**
     * userId that owns this notification
     * @type {number}
     * @memberof Notification
     */
    'userId'?: number;
    /**
     * a summary of the notification
     * @type {string}
     * @memberof Notification
     */
    'title'?: string;
    /**
     * the notification message body
     * @type {string}
     * @memberof Notification
     */
    'body'?: string;
    /**
     * json data attribute content (metadata) used by the mobile app
     * @type {object}
     * @memberof Notification
     */
    'data'?: object;
    /**
     * (Optional) json content message payload sent to Firebase
     * @type {object}
     * @memberof Notification
     */
    'payload'?: object;
    /**
     * (Optional) Array json content response from Firebase for each user\'s device
     * @type {Array<string>}
     * @memberof Notification
     */
    'response'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface NotificationReadAt
 */
export interface NotificationReadAt {
    /**
     * 
     * @type {number}
     * @memberof NotificationReadAt
     */
    'id'?: number;
    /**
     * Indicates when the user has read the notification
     * @type {string}
     * @memberof NotificationReadAt
     */
    'readAt'?: string;
}
/**
 * 
 * @export
 * @interface NotificationReadAtResponse
 */
export interface NotificationReadAtResponse {
    /**
     * 
     * @type {number}
     * @memberof NotificationReadAtResponse
     */
    'id'?: number;
    /**
     * Indicates if the notification has been updated
     * @type {boolean}
     * @memberof NotificationReadAtResponse
     */
    'sucess'?: boolean;
}
/**
 * one page of notifications
 * @export
 * @interface NotificationsOnPage
 */
export interface NotificationsOnPage {
    /**
     * 
     * @type {Array<Notification>}
     * @memberof NotificationsOnPage
     */
    'data'?: Array<Notification>;
    /**
     * 
     * @type {Paginator}
     * @memberof NotificationsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * numbers backwards
 * @export
 * @interface NumbersMode
 */
export interface NumbersMode {
    /**
     * 
     * @type {NumbersModeResult}
     * @memberof NumbersMode
     */
    'list1'?: NumbersModeResult;
    /**
     * 
     * @type {NumbersModeResult}
     * @memberof NumbersMode
     */
    'list2'?: NumbersModeResult;
    /**
     * 
     * @type {NumbersModeResult}
     * @memberof NumbersMode
     */
    'list3'?: NumbersModeResult;
    /**
     * 
     * @type {NumbersModeResult}
     * @memberof NumbersMode
     */
    'list4'?: NumbersModeResult;
    /**
     * List A, B, C, D, E, F. todo we dont know what this is for
     * @type {string}
     * @memberof NumbersMode
     */
    'numbersList'?: string;
}
/**
 * 
 * @export
 * @interface NumbersModeResult
 */
export interface NumbersModeResult {
    /**
     * they got the list correct first try
     * @type {boolean}
     * @memberof NumbersModeResult
     */
    'trial1Result'?: boolean;
    /**
     * they got the list correct second try
     * @type {boolean}
     * @memberof NumbersModeResult
     */
    'trial2Result'?: boolean;
    /**
     * the list of numbers they used
     * @type {string}
     * @memberof NumbersModeResult
     */
    'list'?: string;
}
/**
 * orgs are rugby unions e.g. New Zealand Rugby Union
 * @export
 * @interface Org
 */
export interface Org {
    /**
     * 
     * @type {number}
     * @memberof Org
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Org
     */
    'deletedAt'?: string;
    /**
     * link to url to display image
     * @type {string}
     * @memberof Org
     */
    'image'?: string;
}
/**
 * one page of organisations / unions
 * @export
 * @interface OrgsOnPage
 */
export interface OrgsOnPage {
    /**
     * 
     * @type {Array<Org>}
     * @memberof OrgsOnPage
     */
    'data'?: Array<Org>;
    /**
     * 
     * @type {Paginator}
     * @memberof OrgsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * someone was supposed to do this assessment but it has not been done yet. Calculate this via a database query that looks at the most recent assessment for each player and determines if it is still ok to wait. Assessment timeouts vary. hia2 has to be done within 24(?) hours of hia1, hia3 within 36 hours (or two(?) sleep periods in the time zone of the player)
 * @export
 * @interface OverdueAssessment
 */
export interface OverdueAssessment {
    /**
     * why the assessment is missing or overdue
     * @type {string}
     * @memberof OverdueAssessment
     */
    'reason'?: string;
    /**
     * 
     * @type {AssessmentType}
     * @memberof OverdueAssessment
     */
    'assessmentType'?: AssessmentType;
    /**
     * 
     * @type {Player}
     * @memberof OverdueAssessment
     */
    'player'?: Player;
    /**
     * 
     * @type {Team}
     * @memberof OverdueAssessment
     */
    'team'?: Team;
    /**
     * 
     * @type {Event}
     * @memberof OverdueAssessment
     */
    'event'?: Event;
    /**
     * 
     * @type {string}
     * @memberof OverdueAssessment
     */
    'dateDue'?: string;
}
/**
 * one page of overdue assessments
 * @export
 * @interface OverdueAssessmentsOnPage
 */
export interface OverdueAssessmentsOnPage {
    /**
     * 
     * @type {Array<OverdueAssessment>}
     * @memberof OverdueAssessmentsOnPage
     */
    'data'?: Array<OverdueAssessment>;
    /**
     * 
     * @type {Paginator}
     * @memberof OverdueAssessmentsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * returns a signed URL for S3 so we can download a pdf report
 * @export
 * @interface PDFUrl
 */
export interface PDFUrl {
    /**
     * may need to poll because the file is generated on first use which may take 5-10 seconds
     * @type {string}
     * @memberof PDFUrl
     */
    'url'?: string;
}
/**
 * information about the number of items on this page and in the whole data set
 * @export
 * @interface Paginator
 */
export interface Paginator {
    /**
     * expected number of items on a full page
     * @type {number}
     * @memberof Paginator
     */
    'pageSize'?: number;
    /**
     * total number of pages in the whole data set
     * @type {number}
     * @memberof Paginator
     */
    'pageCount'?: number;
    /**
     * 1..pageCount. This is the nth page of the full data set
     * @type {number}
     * @memberof Paginator
     */
    'pageNumber'?: number;
    /**
     * total number of items in the whole data set
     * @type {number}
     * @memberof Paginator
     */
    'itemCount'?: number;
}
/**
 * 
 * @export
 * @interface PermissionChanges
 */
export interface PermissionChanges {
    /**
     * 
     * @type {PermissionChangesDeletes}
     * @memberof PermissionChanges
     */
    'deletes'?: PermissionChangesDeletes;
    /**
     * 
     * @type {PermissionChangesDeletes}
     * @memberof PermissionChanges
     */
    'creates'?: PermissionChangesDeletes;
}
/**
 * 
 * @export
 * @interface PermissionChangesDeletes
 */
export interface PermissionChangesDeletes {
    /**
     * 
     * @type {Array<number>}
     * @memberof PermissionChangesDeletes
     */
    'teams'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PermissionChangesDeletes
     */
    'players'?: Array<number>;
}
/**
 * status is calculated from the most recent status in PlayerHistory
 * @export
 * @interface Player
 */
export interface Player {
    /**
     * 
     * @type {number}
     * @memberof Player
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'ethnicity'?: string;
    /**
     * centimetres
     * @type {number}
     * @memberof Player
     */
    'height'?: number;
    /**
     * kilograms
     * @type {number}
     * @memberof Player
     */
    'weight'?: number;
    /**
     * 
     * @type {number}
     * @memberof Player
     */
    'yearStarted'?: number;
    /**
     * 
     * @type {number}
     * @memberof Player
     */
    'yearTurnedPro'?: number;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'dominantFoot'?: PlayerDominantFootEnum;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'dominantHand'?: PlayerDominantHandEnum;
    /**
     * has agreed to the terms and conditions for their union to allow their data in the database
     * @type {boolean}
     * @memberof Player
     */
    'legalConsent'?: boolean;
    /**
     * 
     * @type {PlayerStatus}
     * @memberof Player
     */
    'status'?: PlayerStatus;
    /**
     * this was obsoleted by Ed 26 Jul 2022. Use highestEduction instead
     * @type {number}
     * @memberof Player
     */
    'educationYear'?: number;
    /**
     * highest level of education
     * @type {string}
     * @memberof Player
     */
    'highestEducation'?: PlayerHighestEducationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'hospitalizedForHeadInjury'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'diagnosedHeadachesMigraines'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'diagnosedLearningDisorderDyslexia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'diagnosedAddOrAdhd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'diagnosedDepressionAnxietyPsycDisorder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'diagnosedChronicPain'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Player
     */
    'prescribedAntiCoagulants'?: boolean;
    /**
     * number of concussions that are not recorded in this system eg because they are not rugby related
     * @type {number}
     * @memberof Player
     */
    'externalConcussionCount'?: number;
    /**
     * calculated from the number of events where a concussion was diagnosed
     * @type {number}
     * @memberof Player
     */
    'worldRugbyConcussionCount'?: number;
    /**
     * calculated from the number of events where a concussion was diagnosed
     * @type {number}
     * @memberof Player
     */
    'twelveMonthConcussionCount'?: number;
    /**
     * true if the player had a concussion in the last three months. This can also be calculated from mostRecentConcussionDate. Dont ask.
     * @type {boolean}
     * @memberof Player
     */
    'concussionInLastThreeMonths'?: boolean;
    /**
     * calculated from the last event where a concussion was diagnosed
     * @type {string}
     * @memberof Player
     */
    'mostRecentConcussionDate'?: string;
    /**
     * how many days it took before return to play. calculated from the last event where a concussion was diagnosed
     * @type {number}
     * @memberof Player
     */
    'mostRecentConcussionDaysToRecover'?: number;
    /**
     * it took more than 21 days to recover from any concussion in our data set
     * @type {boolean}
     * @memberof Player
     */
    'recoveryMoreThan21Days'?: boolean;
    /**
     * set by a doctor if this is observed
     * @type {boolean}
     * @memberof Player
     */
    'reducedImpactThreshold'?: boolean;
    /**
     * last recovery was complicated by psych issues
     * @type {boolean}
     * @memberof Player
     */
    'complicatedByPsychIssues'?: boolean;
    /**
     * json encoded data for comprehensive assessments
     * @type {string}
     * @memberof Player
     */
    'comprehensiveJson'?: string;
    /**
     * 
     * @type {Array<PlayerTeam>}
     * @memberof Player
     */
    'playerTeams'?: Array<PlayerTeam>;
    /**
     * player is integrated mouth guard compliant
     * @type {boolean}
     * @memberof Player
     */
    'iMGCompliant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    'deletedAt'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PlayerDominantFootEnum {
    empty = '',
    Left = 'Left',
    Right = 'Right',
    Ambidextrous = 'Ambidextrous'
}
/**
    * @export
    * @enum {string}
    */
export enum PlayerDominantHandEnum {
    empty = '',
    Left = 'Left',
    Right = 'Right',
    Ambidextrous = 'Ambidextrous'
}
/**
    * @export
    * @enum {string}
    */
export enum PlayerHighestEducationEnum {
    Doctoral_or_equivalent = 'Doctoral or equivalent',
    Masters_or_equivalent = 'Masters or equivalent',
    Bachelor_or_equivalent = 'Bachelor or equivalent',
    Diploma_or_equivalent = 'Diploma or equivalent',
    Trade_qualification = 'Trade qualification',
    Secondary___High_school = 'Secondary / High school',
    Intermediate___Middle_school = 'Intermediate / Middle school',
    Primary_school = 'Primary school'
}

/**
 * admin ui needs id, but none of the other deep objects inside event.
 * @export
 * @interface PlayerHistory
 */
export interface PlayerHistory {
    /**
     * 
     * @type {number}
     * @memberof PlayerHistory
     */
    'id'?: number;
    /**
     * doctor comments
     * @type {string}
     * @memberof PlayerHistory
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerHistory
     */
    'createdAt'?: string;
    /**
     * 
     * @type {PlayerStatus}
     * @memberof PlayerHistory
     */
    'status': PlayerStatus;
    /**
     * 
     * @type {Assessment}
     * @memberof PlayerHistory
     */
    'assessment'?: Assessment;
    /**
     * 
     * @type {Event}
     * @memberof PlayerHistory
     */
    'event'?: Event;
    /**
     * 
     * @type {User}
     * @memberof PlayerHistory
     */
    'user'?: User;
}


/**
 * one page of player history records
 * @export
 * @interface PlayerHistoryOnPage
 */
export interface PlayerHistoryOnPage {
    /**
     * 
     * @type {Array<PlayerHistory>}
     * @memberof PlayerHistoryOnPage
     */
    'data'?: Array<PlayerHistory>;
    /**
     * 
     * @type {Paginator}
     * @memberof PlayerHistoryOnPage
     */
    'paginator'?: Paginator;
}
/**
 * describes where someone is in the HIA process. InPlay is normal/usual. StageN is graduated return to play. When you finish the last stage you go back to InPlay
 * @export
 * @enum {string}
 */

export enum PlayerStatus {
    Active = 'Active',
    HIA_1 = 'HIA 1',
    HIA_2 = 'HIA 2',
    HIA_3 = 'HIA 3',
    HIA_4 = 'HIA 4',
    Stage_1 = 'Stage 1',
    Stage_2 = 'Stage 2',
    Stage_3 = 'Stage 3',
    Stage_4 = 'Stage 4',
    Stage_5 = 'Stage 5',
    Stage_6 = 'Stage 6',
    Retired = 'Retired',
    HIA_1_Out_of_Tournament = 'HIA 1 Out of Tournament',
    HIA_2_Day_1 = 'HIA 2 Day 1',
    HIA_2_Day_2 = 'HIA 2 Day 2',
    HIA_2_Day_1_Out_of_Tournament = 'HIA 2 Day 1 Out of Tournament',
    HIA_2_Day_2_Out_of_Tournament = 'HIA 2 Day 2 Out of Tournament',
    HIA_3_Non_Compliant = 'HIA 3 Non-Compliant'
}


/**
 * record of player playing for a team, and the position, team image and union
 * @export
 * @interface PlayerTeam
 */
export interface PlayerTeam {
    /**
     * 
     * @type {Team}
     * @memberof PlayerTeam
     */
    'team'?: Team;
    /**
     * 
     * @type {Org}
     * @memberof PlayerTeam
     */
    'org'?: Org;
    /**
     * 
     * @type {Position}
     * @memberof PlayerTeam
     */
    'position'?: Position;
    /**
     * players can have multiple images with different jerserys. this is the full url to download the image
     * @type {string}
     * @memberof PlayerTeam
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTeam
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTeam
     */
    'endedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTeam
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTeam
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerTeam
     */
    'deletedAt'?: string;
}
/**
 * one page of players
 * @export
 * @interface PlayersOnPage
 */
export interface PlayersOnPage {
    /**
     * 
     * @type {Array<Player>}
     * @memberof PlayersOnPage
     */
    'data'?: Array<Player>;
    /**
     * 
     * @type {Paginator}
     * @memberof PlayersOnPage
     */
    'paginator'?: Paginator;
}
/**
 * rugby position, a player plays position on a team
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'name'?: string;
    /**
     * usually numeric?
     * @type {string}
     * @memberof Position
     */
    'jerseyNumber'?: string;
}
/**
 * there are only two protocols at this stage
 * @export
 * @interface Protocol
 */
export interface Protocol {
    /**
     * 
     * @type {number}
     * @memberof Protocol
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Protocol
     */
    'name'?: ProtocolNameEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProtocolNameEnum {
    worldRugbyHiaProtocol = 'worldRugbyHiaProtocol',
    worldRugbySevensHiaProtocol = 'worldRugbySevensHiaProtocol',
    aflProtocol = 'aflProtocol'
}

/**
 * PushNotification object that is sent to Firebase to deliver for the devices
 * @export
 * @interface PushNotification
 */
export interface PushNotification {
    /**
     * Device Token Id determined by the Firebase client library
     * @type {string}
     * @memberof PushNotification
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushNotification
     */
    'collapseKey'?: string;
    /**
     * 
     * @type {PushNotificationNotification}
     * @memberof PushNotification
     */
    'notification'?: PushNotificationNotification;
    /**
     * 
     * @type {PushNotificationData}
     * @memberof PushNotification
     */
    'data'?: PushNotificationData;
}
/**
 * 
 * @export
 * @interface PushNotificationData
 */
export interface PushNotificationData {
    /**
     * 
     * @type {number}
     * @memberof PushNotificationData
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationData
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationData
     */
    'id'?: PushNotificationDataIdEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PushNotificationDataIdEnum {
    authMfaNew = 'authMfaNew',
    authMfaExpired = 'authMfaExpired',
    authUserNew = 'authUserNew',
    authUserForgot = 'authUserForgot',
    comprehensiveIsOrange = 'comprehensiveIsOrange',
    iccReviewRequest = 'iccReviewRequest',
    iccReviewDone = 'iccReviewDone',
    iccReturnToPlayDate = 'iccReturnToPlayDate',
    iccNoConcussion = 'iccNoConcussion',
    iccReturnToPlayToday = 'iccReturnToPlayToday',
    playerConcussion = 'playerConcussion',
    playerBaselineNeeded = 'playerBaselineNeeded',
    playerBaselineAbnormal = 'playerBaselineAbnormal',
    playerBaseline2Needed = 'playerBaseline2Needed',
    playerHia1Done = 'playerHia1Done',
    playerHia2Overdue = 'playerHia2Overdue',
    playerHia3Overdue = 'playerHia3Overdue',
    systemSync = 'systemSync',
    systemAppUpdateAvailable = 'systemAppUpdateAvailable',
    systemUnreadNotifications = 'systemUnreadNotifications',
    playerHia3ReturnToPlayDate = 'playerHia3ReturnToPlayDate',
    playerShouldBePlaying = 'playerShouldBePlaying'
}

/**
 * 
 * @export
 * @interface PushNotificationNotification
 */
export interface PushNotificationNotification {
    /**
     * 
     * @type {string}
     * @memberof PushNotificationNotification
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushNotificationNotification
     */
    'title'?: string;
}
/**
 * PushNotification Response object that is sent from Firebase
 * @export
 * @interface PushNotificationResponse
 */
export interface PushNotificationResponse {
    /**
     * Unique ID (number) identifying the multicast message.
     * @type {number}
     * @memberof PushNotificationResponse
     */
    'multicastId'?: number;
    /**
     * Number of messages that were processed without an error.
     * @type {number}
     * @memberof PushNotificationResponse
     */
    'success'?: number;
    /**
     * Number of messages that could not be processed.
     * @type {number}
     * @memberof PushNotificationResponse
     */
    'failure'?: number;
    /**
     * 
     * @type {Array<PushNotificationResponseResultsInner>}
     * @memberof PushNotificationResponse
     */
    'results'?: Array<PushNotificationResponseResultsInner>;
}
/**
 * 
 * @export
 * @interface PushNotificationResponseResultsInner
 */
export interface PushNotificationResponseResultsInner {
    /**
     * A String specifying a unique ID for each successfully processed message.
     * @type {string}
     * @memberof PushNotificationResponseResultsInner
     */
    'messageId'?: string;
    /**
     * String specifying the error that occurred when processing the message for the recipient. The possible values can be found on https://firebase.google.com/docs/cloud-messaging/http-server-ref#table9
     * @type {string}
     * @memberof PushNotificationResponseResultsInner
     */
    'error'?: string;
}
/**
 * set a new password for the user who has the attached email
 * @export
 * @interface ResetPassword
 */
export interface ResetPassword {
    /**
     * 
     * @type {string}
     * @memberof ResetPassword
     */
    'email'?: string;
    /**
     * the new password to set
     * @type {string}
     * @memberof ResetPassword
     */
    'password'?: string;
    /**
     * the password reset token sent in the email to the user who has forgotten their password
     * @type {string}
     * @memberof ResetPassword
     */
    'token'?: string;
}
/**
 * roles are applied at orgs level (OrgsUsers) e.g. a user has a org.admin role and at the teams level (TeamsUsers) level e.g. user is \'\'team.doctor\'\'  admin World Rugby Org super user \'\'portal\'\' access to admin portal all teams research World Rugby Research manage access via the BI tool org.admin is the \"Union\" Admin has \'\'portal\'\' access to teams/players within the org, can login to the portal team.admin is the team doctor with access to \'\'portal\'\' and \'\'mobile\'\' via the mobile to all players in the team day.doctor is the Match Day Doctor \'\'mobile\'\' View players and add assessment.  Can not view player history team.user \'\'mobile\'\' icc \'\'portal\'\'\'
 * @export
 * @enum {string}
 */

export enum Role {
    Admin = 'Admin',
    Researcher = 'Researcher',
    Union_Admin = 'Union Admin',
    Union_Researcher = 'Union Researcher',
    Team_Admin = 'Team Admin',
    Team_User = 'Team User',
    Match_Day_Doctor = 'Match Day Doctor',
    Medical_Reviewer = 'Medical Reviewer',
    Tournament_Admin = 'Tournament Admin',
    ICC = 'ICC',
    Comprehensive_Assessor = 'Comprehensive Assessor',
    Comprehensive_Reviewer = 'Comprehensive Reviewer',
    Report_Viewer = 'Report Viewer'
}


/**
 * when uploading a file, the upload endpoint returns this structure which is the info needed to upload the image direct to s3
 * @export
 * @interface S3FileUpload
 */
export interface S3FileUpload {
    /**
     * s3 url to bucket name
     * @type {string}
     * @memberof S3FileUpload
     */
    'url'?: string;
    /**
     * 
     * @type {S3FileUploadFields}
     * @memberof S3FileUpload
     */
    'fields'?: S3FileUploadFields;
}
/**
 * a number of additional fields are returned. Include them all in the post to s3. The ones below are an example only
 * @export
 * @interface S3FileUploadFields
 */
export interface S3FileUploadFields {
    /**
     * 
     * @type {string}
     * @memberof S3FileUploadFields
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof S3FileUploadFields
     */
    'bucket'?: string;
    /**
     * 
     * @type {string}
     * @memberof S3FileUploadFields
     */
    'Policy'?: string;
}
/**
 * what type of entity would you like in your search results, or what type is the attached value in SearchResultItem
 * @export
 * @enum {string}
 */

export enum SearchItemType {
    User = 'User',
    Org = 'Org',
    Team = 'Team',
    Player = 'Player',
    Venue = 'Venue',
    Tournament = 'Tournament'
}


/**
 * results of a gloabl search
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {Array<SearchResultItem>}
     * @memberof SearchResult
     */
    'data'?: Array<SearchResultItem>;
    /**
     * 
     * @type {Paginator}
     * @memberof SearchResult
     */
    'paginator'?: Paginator;
}
/**
 * one entity that matches the search term
 * @export
 * @interface SearchResultItem
 */
export interface SearchResultItem {
    /**
     * 
     * @type {SearchItemType}
     * @memberof SearchResultItem
     */
    'type'?: SearchItemType;
    /**
     * 
     * @type {SearchResultItemValue}
     * @memberof SearchResultItem
     */
    'value'?: SearchResultItemValue;
}


/**
 * @type SearchResultItemValue
 * @export
 */
export type SearchResultItemValue = Org | Player | Team | TournamentOnly | User | Venue;

/**
 * Lookup table for the 22+ symptoms
 * @export
 * @interface Symptom
 */
export interface Symptom {
    /**
     * 
     * @type {number}
     * @memberof Symptom
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Symptom
     */
    'name'?: SymptomNameEnum;
    /**
     * 
     * @type {string}
     * @memberof Symptom
     */
    'question'?: string;
    /**
     * 
     * @type {string}
     * @memberof Symptom
     */
    'symptomGroup'?: SymptomSymptomGroupEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum SymptomNameEnum {
    Headache = 'Headache',
    Pressure_In_Head = 'Pressure In Head',
    Neck_Pain = 'Neck Pain',
    Nausea_Or_Vomiting = 'Nausea Or Vomiting',
    Dizziness = 'Dizziness',
    Blurred_Vision = 'Blurred Vision',
    Balance_Problems = 'Balance Problems',
    Sensitivity_To_Light = 'Sensitivity To Light',
    Sensitivity_To_Noise = 'Sensitivity To Noise',
    Feeling_Slowed_Down = 'Feeling Slowed Down',
    Feeling_Like_In_Fog = 'Feeling Like In Fog',
    Dont_Feel_Right = 'Dont Feel Right',
    Difficulty_Concentrating = 'Difficulty Concentrating',
    Difficulty_Remembering = 'Difficulty Remembering',
    Fatigue_Or_Low_Energy = 'Fatigue Or Low Energy',
    Confusion = 'Confusion',
    Drowsiness = 'Drowsiness',
    Trouble_Sleeping = 'Trouble Sleeping',
    More_Emotional = 'More Emotional',
    Irritability = 'Irritability',
    Sadness = 'Sadness',
    Nervous_Anxious = 'Nervous Anxious',
    Feel_Unwell = 'Feel Unwell',
    Sensitivity_To_Light_Or_Noise = 'Sensitivity To Light Or Noise'
}
/**
    * @export
    * @enum {string}
    */
export enum SymptomSymptomGroupEnum {
    P = 'P',
    VO = 'VO',
    C = 'C',
    PSY = 'PSY'
}

/**
 * all these are intensity values from 0 = none, 1 = mild, 6 = severe
 * @export
 * @interface SymptomsMode
 */
export interface SymptomsMode {
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'headache'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'dizziness'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'pressureInHead'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'nauseaOrVomiting'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'blurredVision'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'sensitivityToLight'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'sensitivityToNoise'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'feelingSlowedDown'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'feelingLikeInFog'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'neckPain'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'balanceProblems'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'dontFeelRight'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'difficultyConcentrating'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'difficultyRemembering'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'fatigueOrLowEnergy'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'confusion'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'drowsiness'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'troubleSleeping'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'moreEmotional'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'irritability'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'sadness'?: number;
    /**
     * 
     * @type {number}
     * @memberof SymptomsMode
     */
    'nervousAnxious'?: number;
}
/**
 * A rugby team eg all blacks
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {number}
     * @memberof Team
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {Protocol}
     * @memberof Team
     */
    'protocol'?: Protocol;
    /**
     * link to the view team logo
     * @type {string}
     * @memberof Team
     */
    'logoUrl'?: string;
    /**
     * display this when a player has no image.
     * @type {string}
     * @memberof Team
     */
    'playerImageUrl'?: string;
    /**
     * the org.id that this team belongs to. Helps with permissions
     * @type {number}
     * @memberof Team
     */
    'orgId'?: number;
    /**
     * 
     * @type {Org}
     * @memberof Team
     */
    'org'?: Org;
}
/**
 * record of player playing for a team, and the position, team image
 * @export
 * @interface TeamPlayer
 */
export interface TeamPlayer {
    /**
     * 
     * @type {Player}
     * @memberof TeamPlayer
     */
    'player'?: Player;
    /**
     * 
     * @type {Position}
     * @memberof TeamPlayer
     */
    'position'?: Position;
    /**
     * players can have multiple images with different jerserys. this is the full url to download the image
     * @type {string}
     * @memberof TeamPlayer
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPlayer
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPlayer
     */
    'endedAt'?: string;
}
/**
 * allow a doctor or admin to suggest changes to the players in a team, which is later reviewed by an admin and accepted / declined
 * @export
 * @interface TeamPlayerReview
 */
export interface TeamPlayerReview {
    /**
     * the team id that this review is for
     * @type {number}
     * @memberof TeamPlayerReview
     */
    'id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TeamPlayerReview
     */
    'addPlayers'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TeamPlayerReview
     */
    'deletePlayers'?: Array<number>;
    /**
     * names of new players to create
     * @type {Array<TeamPlayerReviewNewPlayersInner>}
     * @memberof TeamPlayerReview
     */
    'newPlayers'?: Array<TeamPlayerReviewNewPlayersInner>;
    /**
     * 
     * @type {string}
     * @memberof TeamPlayerReview
     */
    'createdAt'?: string;
    /**
     * when the team doctor finishes adding and deleting players
     * @type {string}
     * @memberof TeamPlayerReview
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPlayerReview
     */
    'approvedAt'?: string;
}
/**
 * create a new review for the teamId. send a notification (email?) to the userIds to ask them to complete the review
 * @export
 * @interface TeamPlayerReviewCreate
 */
export interface TeamPlayerReviewCreate {
    /**
     * 
     * @type {number}
     * @memberof TeamPlayerReviewCreate
     */
    'teamId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TeamPlayerReviewCreate
     */
    'userIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface TeamPlayerReviewNewPlayersInner
 */
export interface TeamPlayerReviewNewPlayersInner {
    /**
     * 
     * @type {string}
     * @memberof TeamPlayerReviewNewPlayersInner
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPlayerReviewNewPlayersInner
     */
    'lastName'?: string;
}
/**
 * one page of teams
 * @export
 * @interface TeamPlayerReviewsOnPage
 */
export interface TeamPlayerReviewsOnPage {
    /**
     * 
     * @type {Array<TeamPlayerReview>}
     * @memberof TeamPlayerReviewsOnPage
     */
    'data'?: Array<TeamPlayerReview>;
    /**
     * 
     * @type {Paginator}
     * @memberof TeamPlayerReviewsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * one page of teams
 * @export
 * @interface TeamsOnPage
 */
export interface TeamsOnPage {
    /**
     * 
     * @type {Array<Team>}
     * @memberof TeamsOnPage
     */
    'data'?: Array<Team>;
    /**
     * 
     * @type {Paginator}
     * @memberof TeamsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * terms and conditions user must agree to
 * @export
 * @interface Terms
 */
export interface Terms {
    /**
     * incremented each time the terms change
     * @type {number}
     * @memberof Terms
     */
    'id'?: number;
    /**
     * the plain text content of the terms and conditions
     * @type {string}
     * @memberof Terms
     */
    'content'?: string;
    /**
     * when it was modified
     * @type {string}
     * @memberof Terms
     */
    'updatedAt'?: string;
}
/**
 * terms and conditions user has agreed to
 * @export
 * @interface TermsAccepted
 */
export interface TermsAccepted {
    /**
     * which version the user agreed to
     * @type {number}
     * @memberof TermsAccepted
     */
    'termsId'?: number;
    /**
     * date the user agreed to them
     * @type {string}
     * @memberof TermsAccepted
     */
    'createdAt'?: string;
}
/**
 * a single timezone
 * @export
 * @interface Timezone
 */
export interface Timezone {
    /**
     * 
     * @type {string}
     * @memberof Timezone
     */
    'name': string;
    /**
     * current offset from UTC
     * @type {string}
     * @memberof Timezone
     */
    'offset': string;
}
/**
 * list of timesoznes for venues
 * @export
 * @interface Timezones
 */
export interface Timezones {
    /**
     * 
     * @type {Array<Timezone>}
     * @memberof Timezones
     */
    'zones': Array<Timezone>;
}
/**
 * @type TokenOrMFAChallenge
 * returned by login or mfa response if a new mfa is needed
 * @export
 */
export type TokenOrMFAChallenge = MFAChallenge | TokenResponse;

/**
 * sent by /auth/login and /auth/refresh when a new token is offered by the server
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * JWT. Use this as a Bearer token on every header
     * @type {string}
     * @memberof TokenResponse
     */
    'accessToken'?: string;
    /**
     * unixtime that the access token expires
     * @type {number}
     * @memberof TokenResponse
     */
    'accessTokenExpires'?: number;
    /**
     * JWT. Use this to get a new Access token when the access token expires
     * @type {string}
     * @memberof TokenResponse
     */
    'refreshToken'?: string;
    /**
     * unixtime that the refresh token expires. This is usually much longer than the access token
     * @type {number}
     * @memberof TokenResponse
     */
    'refreshTokenExpires'?: number;
    /**
     * 
     * @type {User}
     * @memberof TokenResponse
     */
    'user'?: User;
}
/**
 * a tournament with nested objects
 * @export
 * @interface Tournament
 */
export interface Tournament {
    /**
     * 
     * @type {number}
     * @memberof Tournament
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    'name'?: string;
    /**
     * roughly when the tournament starts. This may change as tournaments re-run on a regular cycle
     * @type {string}
     * @memberof Tournament
     */
    'startsAt'?: string;
    /**
     * roughly when the tournament ends. Delays in fixtures mean these dates are not absolute
     * @type {string}
     * @memberof Tournament
     */
    'endsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tournament
     */
    'deletedAt'?: string;
    /**
     * link to the S3 bucket for image display
     * @type {string}
     * @memberof Tournament
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<Team>}
     * @memberof Tournament
     */
    'teams'?: Array<Team>;
    /**
     * 
     * @type {Array<Venue>}
     * @memberof Tournament
     */
    'venues'?: Array<Venue>;
    /**
     * 
     * @type {Array<Fixture>}
     * @memberof Tournament
     */
    'fixtures'?: Array<Fixture>;
}
/**
 * just the top level of the tournament. No need for all the nested objects
 * @export
 * @interface TournamentOnly
 */
export interface TournamentOnly {
    /**
     * 
     * @type {number}
     * @memberof TournamentOnly
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentOnly
     */
    'name'?: string;
    /**
     * roughly when the tournament starts. This may change as tournaments re-run on a regular cycle
     * @type {string}
     * @memberof TournamentOnly
     */
    'startsAt'?: string;
    /**
     * roughly when the tournament ends. Delays in fixtures mean these dates are not absolute
     * @type {string}
     * @memberof TournamentOnly
     */
    'endsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentOnly
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentOnly
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentOnly
     */
    'deletedAt'?: string;
    /**
     * link to the S3 bucket for image display
     * @type {string}
     * @memberof TournamentOnly
     */
    'imageUrl'?: string;
}
/**
 * one page of tournaments
 * @export
 * @interface TournamentsOnPage
 */
export interface TournamentsOnPage {
    /**
     * 
     * @type {Array<Tournament>}
     * @memberof TournamentsOnPage
     */
    'data'?: Array<Tournament>;
    /**
     * 
     * @type {Paginator}
     * @memberof TournamentsOnPage
     */
    'paginator'?: Paginator;
}
/**
 * Reason doctor is/was unable to complete HIA 2/3
 * @export
 * @enum {string}
 */

export enum UnableToCompleteReason {
    Player_taken_to_hospital = 'Player taken to hospital',
    Player_not_in_appropriate_condition = 'Player not in appropriate condition',
    Player_unavailable_for_other_reason = 'Player unavailable for other reason',
    Result_entered_by_Administrator = 'Result entered by Administrator'
}


/**
 * a user who can log in to the mobile app or the admin portal. This is not the same as a Player (who cannot log in)
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * where you live
     * @type {string}
     * @memberof User
     */
    'country'?: string;
    /**
     * the languages you speak
     * @type {string}
     * @memberof User
     */
    'languages'?: string;
    /**
     * should never be sent in a response. only used in a request where if non blank this is the new password
     * @type {string}
     * @memberof User
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone'?: string;
    /**
     * true if the user opted in to MFA via SMS
     * @type {boolean}
     * @memberof User
     */
    'allowSmsMfa'?: boolean;
    /**
     * a json string containing stuff needed for the mobile app
     * @type {string}
     * @memberof User
     */
    'preferences'?: string;
    /**
     * when the user has agreed to updated terms and conditions.
     * @type {Array<TermsAccepted>}
     * @memberof User
     */
    'terms'?: Array<TermsAccepted>;
    /**
     * true if the user failed to log in 10 or more times
     * @type {boolean}
     * @memberof User
     */
    'isLocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLoginAt'?: string;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof User
     */
    'roles'?: Array<UserRole>;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'mfaDueAt'?: number;
}
/**
 * Structure of Post request to get s3 upload url for user report
 * @export
 * @interface UserDataReportUrlParameters
 */
export interface UserDataReportUrlParameters {
    /**
     * 
     * @type {string}
     * @memberof UserDataReportUrlParameters
     */
    'encryption_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDataReportUrlParameters
     */
    'device_id'?: string;
}
/**
 * userDevice object to un/register devices for Push Notification
 * @export
 * @interface UserDevice
 */
export interface UserDevice {
    /**
     * 
     * @type {string}
     * @memberof UserDevice
     */
    'deviceToken'?: string;
}
/**
 * UserDevice Response to un/register devices for Push Notification
 * @export
 * @interface UserDeviceResponse
 */
export interface UserDeviceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserDeviceResponse
     */
    'success'?: boolean;
}
/**
 * A user just successfully registered (which implies they accepted the terms)
 * @export
 * @interface UserRegistered
 */
export interface UserRegistered {
    /**
     * 
     * @type {number}
     * @memberof UserRegistered
     */
    'id'?: number;
    /**
     * true if the user can access the admin portal
     * @type {boolean}
     * @memberof UserRegistered
     */
    'hasAdminAccess'?: boolean;
}
/**
 * access for a user to an org
 * @export
 * @interface UserRole
 */
export interface UserRole {
    /**
     * the database id of the user role, to help sync when updating many roles for a user
     * @type {number}
     * @memberof UserRole
     */
    'id'?: number;
    /**
     * 
     * @type {Role}
     * @memberof UserRole
     */
    'role'?: Role;
    /**
     * 
     * @type {Org}
     * @memberof UserRole
     */
    'org'?: Org;
    /**
     * 
     * @type {Team}
     * @memberof UserRole
     */
    'team'?: Team;
    /**
     * 
     * @type {TournamentOnly}
     * @memberof UserRole
     */
    'tournament'?: TournamentOnly;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRole
     */
    'endsAt'?: string;
}


/**
 * one page of users
 * @export
 * @interface UsersOnPage
 */
export interface UsersOnPage {
    /**
     * 
     * @type {Array<User>}
     * @memberof UsersOnPage
     */
    'data'?: Array<User>;
    /**
     * 
     * @type {Paginator}
     * @memberof UsersOnPage
     */
    'paginator'?: Paginator;
}
/**
 * stadium or place to hold game/fixture
 * @export
 * @interface Venue
 */
export interface Venue {
    /**
     * 
     * @type {number}
     * @memberof Venue
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    'name'?: string;
    /**
     * a standard timezone string for the venue
     * @type {string}
     * @memberof Venue
     */
    'timezone'?: string;
}
/**
 * one page of venues
 * @export
 * @interface VenuesOnPage
 */
export interface VenuesOnPage {
    /**
     * 
     * @type {Array<Venue>}
     * @memberof VenuesOnPage
     */
    'data'?: Array<Venue>;
    /**
     * 
     * @type {Paginator}
     * @memberof VenuesOnPage
     */
    'paginator'?: Paginator;
}
/**
 * immediate memory
 * @export
 * @interface WordsMode
 */
export interface WordsMode {
    /**
     * 
     * @type {string}
     * @memberof WordsMode
     */
    'words'?: string;
    /**
     * 
     * @type {number}
     * @memberof WordsMode
     */
    'result1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WordsMode
     */
    'result2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WordsMode
     */
    'result3'?: number;
}

/**
 * AssessmentsApi - axios parameter creator
 * @export
 */
export const AssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment: async (Assessment: Assessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Assessment' is not null or undefined
            assertParamExists('addAssessment', 'Assessment', Assessment)
            const localVarPath = `/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Assessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an Assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessment: async (assessmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('deleteAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/assessments/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById: async (assessmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getAssessmentById', 'assessmentId', assessmentId)
            const localVarPath = `/assessments/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get assessment statistics for home page graphs on admin ui. Calculate them for all the teams / orgs / players that the currently logged in user is allowed to see
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assessments/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessments: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List overdue assessments, paginated and filtered, sorted most overdue first
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsOverdue: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<AssessmentTypeName>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assessments/overdue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf: async (assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assessment) {
                localVarQueryParameter['assessment'] = assessment;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (iccreview) {
                localVarQueryParameter['iccreview'] = iccreview;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * review an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Review assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewAssessment: async (assessmentId: number, Assessment: Assessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('reviewAssessment', 'assessmentId', assessmentId)
            // verify required parameter 'Assessment' is not null or undefined
            assertParamExists('reviewAssessment', 'Assessment', Assessment)
            const localVarPath = `/assessments/{assessmentId}/review`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Assessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessment: async (assessmentId: number, Assessment: Assessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('updateAssessment', 'assessmentId', assessmentId)
            // verify required parameter 'Assessment' is not null or undefined
            assertParamExists('updateAssessment', 'Assessment', Assessment)
            const localVarPath = `/assessments/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Assessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentsApi - functional programming interface
 * @export
 */
export const AssessmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAssessment(Assessment: Assessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAssessment(Assessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an Assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssessment(assessmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssessment(assessmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentById(assessmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentById(assessmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get assessment statistics for home page graphs on admin ui. Calculate them for all the teams / orgs / players that the currently logged in user is allowed to see
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List overdue assessments, paginated and filtered, sorted most overdue first
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentsOverdue(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<AssessmentTypeName>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverdueAssessmentsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentsOverdue(page, pageSize, org, team, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdf(assessment, event, iccreview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * review an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Review assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewAssessment(assessmentId, Assessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssessment(assessmentId, Assessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssessmentsApi - factory interface
 * @export
 */
export const AssessmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentsApiFp(configuration)
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment(Assessment: Assessment, options?: any): AxiosPromise<Assessment> {
            return localVarFp.addAssessment(Assessment, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an Assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessment(assessmentId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteAssessment(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById(assessmentId: number, options?: any): AxiosPromise<Assessment> {
            return localVarFp.getAssessmentById(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get assessment statistics for home page graphs on admin ui. Calculate them for all the teams / orgs / players that the currently logged in user is allowed to see
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentStatistics(options?: any): AxiosPromise<AssessmentStatistics> {
            return localVarFp.getAssessmentStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: any): AxiosPromise<AssessmentsOnPage> {
            return localVarFp.getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * List overdue assessments, paginated and filtered, sorted most overdue first
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsOverdue(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<AssessmentTypeName>, options?: any): AxiosPromise<OverdueAssessmentsOnPage> {
            return localVarFp.getAssessmentsOverdue(page, pageSize, org, team, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: any): AxiosPromise<PDFUrl> {
            return localVarFp.getPdf(assessment, event, iccreview, options).then((request) => request(axios, basePath));
        },
        /**
         * review an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Review assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewAssessment(assessmentId: number, Assessment: Assessment, options?: any): AxiosPromise<Assessment> {
            return localVarFp.reviewAssessment(assessmentId, Assessment, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessment(assessmentId: number, Assessment: Assessment, options?: any): AxiosPromise<Assessment> {
            return localVarFp.updateAssessment(assessmentId, Assessment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentsApi - object-oriented interface
 * @export
 * @class AssessmentsApi
 * @extends {BaseAPI}
 */
export class AssessmentsApi extends BaseAPI {
    /**
     * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
     * @param {Assessment} Assessment Assessment to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public addAssessment(Assessment: Assessment, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).addAssessment(Assessment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an Assessment
     * @param {number} assessmentId ID of the assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public deleteAssessment(assessmentId: number, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).deleteAssessment(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find Assessment by ID. Returns an assessment
     * @param {number} assessmentId ID of the assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessmentById(assessmentId: number, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessmentById(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get assessment statistics for home page graphs on admin ui. Calculate them for all the teams / orgs / players that the currently logged in user is allowed to see
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessmentStatistics(options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessmentStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List overdue assessments, paginated and filtered, sorted most overdue first
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessmentsOverdue(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<AssessmentTypeName>, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessmentsOverdue(page, pageSize, org, team, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a url to download a pdf report from
     * @param {Array<number>} [assessment] comma separated list of integer assessment ids
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getPdf(assessment, event, iccreview, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * review an existing assessment
     * @param {number} assessmentId ID of the assessment
     * @param {Assessment} Assessment Review assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public reviewAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).reviewAssessment(assessmentId, Assessment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing assessment
     * @param {number} assessmentId ID of the assessment
     * @param {Assessment} Assessment Update assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public updateAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).updateAssessment(assessmentId, Assessment, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginUser: async (Login: Login, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Login' is not null or undefined
            assertParamExists('authLoginUser', 'Login', Login)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Login, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutUser: async (Logout: Logout, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Logout' is not null or undefined
            assertParamExists('authLogoutUser', 'Logout', Logout)
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Logout, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMfa: async (MFAResponse: MFAResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'MFAResponse' is not null or undefined
            assertParamExists('authMfa', 'MFAResponse', MFAResponse)
            const localVarPath = `/auth/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(MFAResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR. UI wants to check the token is valid and get their name and phone so the user can correct them if necessary
         * @param {number} id user id
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPreRegister: async (id: number, expires: number, token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authPreRegister', 'id', id)
            // verify required parameter 'expires' is not null or undefined
            assertParamExists('authPreRegister', 'expires', expires)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authPreRegister', 'token', token)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR and filled out their details and clicked submit
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {User} User User to update name, phone, password only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegister: async (expires: number, token: string, User: User, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expires' is not null or undefined
            assertParamExists('authRegister', 'expires', expires)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authRegister', 'token', token)
            // verify required parameter 'User' is not null or undefined
            assertParamExists('authRegister', 'User', User)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expires !== undefined) {
                localVarQueryParameter['expires'] = expires;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(User, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User has clicked the Forgot Password link. Change their old password to a new one
         * @param {ResetPassword} ResetPassword Reset Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authResetPassword: async (ResetPassword: ResetPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ResetPassword' is not null or undefined
            assertParamExists('authResetPassword', 'ResetPassword', ResetPassword)
            const localVarPath = `/auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ResetPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (ForgotPassword: ForgotPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ForgotPassword' is not null or undefined
            assertParamExists('forgotPassword', 'ForgotPassword', ForgotPassword)
            const localVarPath = `/auth/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ForgotPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLoginUser(Login: Login, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenOrMFAChallenge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginUser(Login, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogoutUser(Logout: Logout, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutUser(Logout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authMfa(MFAResponse: MFAResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenOrMFAChallenge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authMfa(MFAResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR. UI wants to check the token is valid and get their name and phone so the user can correct them if necessary
         * @param {number} id user id
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPreRegister(id: number, expires: number, token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPreRegister(id, expires, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRefreshToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRefreshToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR and filled out their details and clicked submit
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {User} User User to update name, phone, password only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRegister(expires: number, token: string, User: User, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRegistered>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRegister(expires, token, User, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User has clicked the Forgot Password link. Change their old password to a new one
         * @param {ResetPassword} ResetPassword Reset Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authResetPassword(ResetPassword: ResetPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authResetPassword(ResetPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(ForgotPassword: ForgotPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(ForgotPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginUser(Login: Login, options?: any): AxiosPromise<TokenOrMFAChallenge> {
            return localVarFp.authLoginUser(Login, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutUser(Logout: Logout, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.authLogoutUser(Logout, options).then((request) => request(axios, basePath));
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMfa(MFAResponse: MFAResponse, options?: any): AxiosPromise<TokenOrMFAChallenge> {
            return localVarFp.authMfa(MFAResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR. UI wants to check the token is valid and get their name and phone so the user can correct them if necessary
         * @param {number} id user id
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPreRegister(id: number, expires: number, token: string, options?: any): AxiosPromise<User> {
            return localVarFp.authPreRegister(id, expires, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshToken(options?: any): AxiosPromise<TokenResponse> {
            return localVarFp.authRefreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR and filled out their details and clicked submit
         * @param {number} expires for auth register. timestamp when this link expires
         * @param {string} token token to ensure the link is valid
         * @param {User} User User to update name, phone, password only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegister(expires: number, token: string, User: User, options?: any): AxiosPromise<UserRegistered> {
            return localVarFp.authRegister(expires, token, User, options).then((request) => request(axios, basePath));
        },
        /**
         * User has clicked the Forgot Password link. Change their old password to a new one
         * @param {ResetPassword} ResetPassword Reset Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authResetPassword(ResetPassword: ResetPassword, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.authResetPassword(ResetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(ForgotPassword: ForgotPassword, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.forgotPassword(ForgotPassword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
     * @param {Login} Login auth login endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLoginUser(Login: Login, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authLoginUser(Login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logs out current logged in user session
     * @param {Logout} Logout auth logout endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authLogoutUser(Logout: Logout, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authLogoutUser(Logout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
     * @param {MFAResponse} MFAResponse MFA response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authMfa(MFAResponse: MFAResponse, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authMfa(MFAResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR. UI wants to check the token is valid and get their name and phone so the user can correct them if necessary
     * @param {number} id user id
     * @param {number} expires for auth register. timestamp when this link expires
     * @param {string} token token to ensure the link is valid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authPreRegister(id: number, expires: number, token: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPreRegister(id, expires, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a new access and refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRefreshToken(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authRefreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User has clicked link to admin ui /auth/register?id=123&expires=2561287652&token=FOOBAR and filled out their details and clicked submit
     * @param {number} expires for auth register. timestamp when this link expires
     * @param {string} token token to ensure the link is valid
     * @param {User} User User to update name, phone, password only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authRegister(expires: number, token: string, User: User, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authRegister(expires, token, User, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User has clicked the Forgot Password link. Change their old password to a new one
     * @param {ResetPassword} ResetPassword Reset Password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authResetPassword(ResetPassword: ResetPassword, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authResetPassword(ResetPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
     * @param {ForgotPassword} ForgotPassword Forgot Password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public forgotPassword(ForgotPassword: ForgotPassword, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).forgotPassword(ForgotPassword, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComprehensivesApi - axios parameter creator
 * @export
 */
export const ComprehensivesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new comprehensive assessment to dataset
         * @param {ComprehensiveAssessment} ComprehensiveAssessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComprehensive: async (ComprehensiveAssessment: ComprehensiveAssessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ComprehensiveAssessment' is not null or undefined
            assertParamExists('addComprehensive', 'ComprehensiveAssessment', ComprehensiveAssessment)
            const localVarPath = `/comprehensives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ComprehensiveAssessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft Delete a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComprehensive: async (comprehensiveId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comprehensiveId' is not null or undefined
            assertParamExists('deleteComprehensive', 'comprehensiveId', comprehensiveId)
            const localVarPath = `/comprehensives/{comprehensiveId}`
                .replace(`{${"comprehensiveId"}}`, encodeURIComponent(String(comprehensiveId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComprehensiveById: async (comprehensiveId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comprehensiveId' is not null or undefined
            assertParamExists('getComprehensiveById', 'comprehensiveId', comprehensiveId)
            const localVarPath = `/comprehensives/{comprehensiveId}`
                .replace(`{${"comprehensiveId"}}`, encodeURIComponent(String(comprehensiveId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all comprehensive assessments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<ComprehensiveType>} [type] comma separated list of comprehensive assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {Array<ComprehensiveOutcome>} [outcome] comma separated list of comprehensive assessment outcomes to include in result set (name enum / string values). blank / missing means show all types
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {'all' | 'incomplete' | 'complete'} [completedAt] filter the results to show only completed or only incomplete assessments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComprehensives: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, type?: Array<ComprehensiveType>, outcome?: Array<ComprehensiveOutcome>, sinceTime?: number, showDeleted?: number, orderBy?: string, completedAt?: 'all' | 'incomplete' | 'complete', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/comprehensives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (outcome) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (completedAt !== undefined) {
                localVarQueryParameter['completedAt'] = completedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {ComprehensiveAssessment} [ComprehensiveAssessment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComprehensive: async (comprehensiveId: number, ComprehensiveAssessment?: ComprehensiveAssessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comprehensiveId' is not null or undefined
            assertParamExists('updateComprehensive', 'comprehensiveId', comprehensiveId)
            const localVarPath = `/comprehensives/{comprehensiveId}`
                .replace(`{${"comprehensiveId"}}`, encodeURIComponent(String(comprehensiveId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ComprehensiveAssessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComprehensivesApi - functional programming interface
 * @export
 */
export const ComprehensivesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComprehensivesApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new comprehensive assessment to dataset
         * @param {ComprehensiveAssessment} ComprehensiveAssessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComprehensive(ComprehensiveAssessment: ComprehensiveAssessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComprehensiveAssessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComprehensive(ComprehensiveAssessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft Delete a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComprehensive(comprehensiveId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComprehensive(comprehensiveId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComprehensiveById(comprehensiveId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComprehensiveAssessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComprehensiveById(comprehensiveId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all comprehensive assessments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<ComprehensiveType>} [type] comma separated list of comprehensive assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {Array<ComprehensiveOutcome>} [outcome] comma separated list of comprehensive assessment outcomes to include in result set (name enum / string values). blank / missing means show all types
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {'all' | 'incomplete' | 'complete'} [completedAt] filter the results to show only completed or only incomplete assessments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComprehensives(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, type?: Array<ComprehensiveType>, outcome?: Array<ComprehensiveOutcome>, sinceTime?: number, showDeleted?: number, orderBy?: string, completedAt?: 'all' | 'incomplete' | 'complete', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComprehensiveAssessmentsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComprehensives(page, pageSize, search, org, team, player, type, outcome, sinceTime, showDeleted, orderBy, completedAt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {ComprehensiveAssessment} [ComprehensiveAssessment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComprehensive(comprehensiveId: number, ComprehensiveAssessment?: ComprehensiveAssessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComprehensiveAssessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComprehensive(comprehensiveId, ComprehensiveAssessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComprehensivesApi - factory interface
 * @export
 */
export const ComprehensivesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComprehensivesApiFp(configuration)
    return {
        /**
         * Add a new comprehensive assessment to dataset
         * @param {ComprehensiveAssessment} ComprehensiveAssessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComprehensive(ComprehensiveAssessment: ComprehensiveAssessment, options?: any): AxiosPromise<ComprehensiveAssessment> {
            return localVarFp.addComprehensive(ComprehensiveAssessment, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft Delete a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComprehensive(comprehensiveId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteComprehensive(comprehensiveId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComprehensiveById(comprehensiveId: number, options?: any): AxiosPromise<ComprehensiveAssessment> {
            return localVarFp.getComprehensiveById(comprehensiveId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all comprehensive assessments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<ComprehensiveType>} [type] comma separated list of comprehensive assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {Array<ComprehensiveOutcome>} [outcome] comma separated list of comprehensive assessment outcomes to include in result set (name enum / string values). blank / missing means show all types
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {'all' | 'incomplete' | 'complete'} [completedAt] filter the results to show only completed or only incomplete assessments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComprehensives(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, type?: Array<ComprehensiveType>, outcome?: Array<ComprehensiveOutcome>, sinceTime?: number, showDeleted?: number, orderBy?: string, completedAt?: 'all' | 'incomplete' | 'complete', options?: any): AxiosPromise<ComprehensiveAssessmentsOnPage> {
            return localVarFp.getComprehensives(page, pageSize, search, org, team, player, type, outcome, sinceTime, showDeleted, orderBy, completedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a comprehensive assessment
         * @param {number} comprehensiveId ID of the comprehensive assessment
         * @param {ComprehensiveAssessment} [ComprehensiveAssessment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComprehensive(comprehensiveId: number, ComprehensiveAssessment?: ComprehensiveAssessment, options?: any): AxiosPromise<ComprehensiveAssessment> {
            return localVarFp.updateComprehensive(comprehensiveId, ComprehensiveAssessment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComprehensivesApi - object-oriented interface
 * @export
 * @class ComprehensivesApi
 * @extends {BaseAPI}
 */
export class ComprehensivesApi extends BaseAPI {
    /**
     * Add a new comprehensive assessment to dataset
     * @param {ComprehensiveAssessment} ComprehensiveAssessment Assessment to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivesApi
     */
    public addComprehensive(ComprehensiveAssessment: ComprehensiveAssessment, options?: AxiosRequestConfig) {
        return ComprehensivesApiFp(this.configuration).addComprehensive(ComprehensiveAssessment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft Delete a comprehensive assessment
     * @param {number} comprehensiveId ID of the comprehensive assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivesApi
     */
    public deleteComprehensive(comprehensiveId: number, options?: AxiosRequestConfig) {
        return ComprehensivesApiFp(this.configuration).deleteComprehensive(comprehensiveId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a comprehensive assessment
     * @param {number} comprehensiveId ID of the comprehensive assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivesApi
     */
    public getComprehensiveById(comprehensiveId: number, options?: AxiosRequestConfig) {
        return ComprehensivesApiFp(this.configuration).getComprehensiveById(comprehensiveId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all comprehensive assessments
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<ComprehensiveType>} [type] comma separated list of comprehensive assessment types to include in result set (name enum / string values). blank / missing means show all types
     * @param {Array<ComprehensiveOutcome>} [outcome] comma separated list of comprehensive assessment outcomes to include in result set (name enum / string values). blank / missing means show all types
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {'all' | 'incomplete' | 'complete'} [completedAt] filter the results to show only completed or only incomplete assessments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivesApi
     */
    public getComprehensives(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, type?: Array<ComprehensiveType>, outcome?: Array<ComprehensiveOutcome>, sinceTime?: number, showDeleted?: number, orderBy?: string, completedAt?: 'all' | 'incomplete' | 'complete', options?: AxiosRequestConfig) {
        return ComprehensivesApiFp(this.configuration).getComprehensives(page, pageSize, search, org, team, player, type, outcome, sinceTime, showDeleted, orderBy, completedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a comprehensive assessment
     * @param {number} comprehensiveId ID of the comprehensive assessment
     * @param {ComprehensiveAssessment} [ComprehensiveAssessment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivesApi
     */
    public updateComprehensive(comprehensiveId: number, ComprehensiveAssessment?: ComprehensiveAssessment, options?: AxiosRequestConfig) {
        return ComprehensivesApiFp(this.configuration).updateComprehensive(comprehensiveId, ComprehensiveAssessment, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatabaseApi - axios parameter creator
 * @export
 */
export const DatabaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestDatabase: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/database/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestDatabase: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/database/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabaseApi - functional programming interface
 * @export
 */
export const DatabaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestDatabase(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestDatabase(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTestDatabase(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTestDatabase(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatabaseApi - factory interface
 * @export
 */
export const DatabaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabaseApiFp(configuration)
    return {
        /**
         * Creates a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestDatabase(options?: any): AxiosPromise<void> {
            return localVarFp.createTestDatabase(options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a test database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestDatabase(options?: any): AxiosPromise<void> {
            return localVarFp.deleteTestDatabase(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatabaseApi - object-oriented interface
 * @export
 * @class DatabaseApi
 * @extends {BaseAPI}
 */
export class DatabaseApi extends BaseAPI {
    /**
     * Creates a test database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseApi
     */
    public createTestDatabase(options?: AxiosRequestConfig) {
        return DatabaseApiFp(this.configuration).createTestDatabase(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a test database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabaseApi
     */
    public deleteTestDatabase(options?: AxiosRequestConfig) {
        return DatabaseApiFp(this.configuration).deleteTestDatabase(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new event to dataset
         * @param {Event} Event Assessment to be added to assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEvent: async (Event: Event, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Event' is not null or undefined
            assertParamExists('addEvent', 'Event', Event)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Event, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft Delete an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEvent', 'eventId', eventId)
            const localVarPath = `/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * remove the file from the event. Delete it from S3 and from the Event structure in the database
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventFile: async (eventId: number, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEventFile', 'eventId', eventId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('deleteEventFile', 'fileName', fileName)
            const localVarPath = `/events/{eventId}/files/{fileName}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventById: async (eventId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventById', 'eventId', eventId)
            const localVarPath = `/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the file from the event. Get the presigned url and download it from S3
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventFile: async (eventId: number, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventFile', 'eventId', eventId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getEventFile', 'fileName', fileName)
            const localVarPath = `/events/{eventId}/files/{fileName}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all events. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showAll] boolean defaults to 0 to show only open events. If true (non zero) show all events (closed and open)
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (page?: number, pageSize?: number, search?: string, player?: Array<number>, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, orderBy?: string, showAll?: number, sinceTime?: number, showDeleted?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (showAll !== undefined) {
                localVarQueryParameter['showAll'] = showAll;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ignore an event
         * @param {number} eventId ID of the injury event
         * @param {IgnoreEventOptions} [IgnoreEventOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreEvent: async (eventId: number, IgnoreEventOptions?: IgnoreEventOptions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('ignoreEvent', 'eventId', eventId)
            const localVarPath = `/events/{eventId}/ignore`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(IgnoreEventOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an event
         * @param {number} eventId ID of the injury event
         * @param {Event} [Event] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent: async (eventId: number, Event?: Event, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateEvent', 'eventId', eventId)
            const localVarPath = `/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Event, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a file to attach to the event. Usually a pdf containing a neurocognitive report. Uploading a new one replaces any existing one
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEventFile: async (eventId: number, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('uploadEventFile', 'eventId', eventId)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('uploadEventFile', 'fileName', fileName)
            const localVarPath = `/events/{eventId}/files/{fileName}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new event to dataset
         * @param {Event} Event Assessment to be added to assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEvent(Event: Event, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEvent(Event, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft Delete an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvent(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * remove the file from the event. Delete it from S3 and from the Event structure in the database
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventFile(eventId, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventById(eventId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventWithAssessments>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventById(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get the file from the event. Get the presigned url and download it from S3
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventFile(eventId, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all events. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showAll] boolean defaults to 0 to show only open events. If true (non zero) show all events (closed and open)
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(page?: number, pageSize?: number, search?: string, player?: Array<number>, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, orderBy?: string, showAll?: number, sinceTime?: number, showDeleted?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(page, pageSize, search, player, org, team, tournament, orderBy, showAll, sinceTime, showDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ignore an event
         * @param {number} eventId ID of the injury event
         * @param {IgnoreEventOptions} [IgnoreEventOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreEvent(eventId: number, IgnoreEventOptions?: IgnoreEventOptions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IgnoreEventConfirmationInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreEvent(eventId, IgnoreEventOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an event
         * @param {number} eventId ID of the injury event
         * @param {Event} [Event] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvent(eventId: number, Event?: Event, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvent(eventId, Event, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a file to attach to the event. Usually a pdf containing a neurocognitive report. Uploading a new one replaces any existing one
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEventFile(eventId, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Add a new event to dataset
         * @param {Event} Event Assessment to be added to assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEvent(Event: Event, options?: any): AxiosPromise<Event> {
            return localVarFp.addEvent(Event, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft Delete an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent(eventId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * remove the file from the event. Delete it from S3 and from the Event structure in the database
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventFile(eventId: number, fileName: string, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteEventFile(eventId, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an event
         * @param {number} eventId ID of the injury event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventById(eventId: number, options?: any): AxiosPromise<EventWithAssessments> {
            return localVarFp.getEventById(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * get the file from the event. Get the presigned url and download it from S3
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventFile(eventId: number, fileName: string, options?: any): AxiosPromise<GetEventFile200Response> {
            return localVarFp.getEventFile(eventId, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all events. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showAll] boolean defaults to 0 to show only open events. If true (non zero) show all events (closed and open)
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(page?: number, pageSize?: number, search?: string, player?: Array<number>, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, orderBy?: string, showAll?: number, sinceTime?: number, showDeleted?: number, options?: any): AxiosPromise<EventsOnPage> {
            return localVarFp.getEvents(page, pageSize, search, player, org, team, tournament, orderBy, showAll, sinceTime, showDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Ignore an event
         * @param {number} eventId ID of the injury event
         * @param {IgnoreEventOptions} [IgnoreEventOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreEvent(eventId: number, IgnoreEventOptions?: IgnoreEventOptions, options?: any): AxiosPromise<IgnoreEventConfirmationInfo> {
            return localVarFp.ignoreEvent(eventId, IgnoreEventOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an event
         * @param {number} eventId ID of the injury event
         * @param {Event} [Event] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent(eventId: number, Event?: Event, options?: any): AxiosPromise<Event> {
            return localVarFp.updateEvent(eventId, Event, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a file to attach to the event. Usually a pdf containing a neurocognitive report. Uploading a new one replaces any existing one
         * @param {number} eventId ID of the injury event
         * @param {string} fileName File basename (no directory)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEventFile(eventId: number, fileName: string, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadEventFile(eventId, fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Add a new event to dataset
     * @param {Event} Event Assessment to be added to assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public addEvent(Event: Event, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).addEvent(Event, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft Delete an event
     * @param {number} eventId ID of the injury event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEvent(eventId: number, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * remove the file from the event. Delete it from S3 and from the Event structure in the database
     * @param {number} eventId ID of the injury event
     * @param {string} fileName File basename (no directory)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventFile(eventId, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an event
     * @param {number} eventId ID of the injury event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventById(eventId: number, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventById(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get the file from the event. Get the presigned url and download it from S3
     * @param {number} eventId ID of the injury event
     * @param {string} fileName File basename (no directory)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventFile(eventId, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all events. Search string is player name
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {number} [showAll] boolean defaults to 0 to show only open events. If true (non zero) show all events (closed and open)
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEvents(page?: number, pageSize?: number, search?: string, player?: Array<number>, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, orderBy?: string, showAll?: number, sinceTime?: number, showDeleted?: number, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEvents(page, pageSize, search, player, org, team, tournament, orderBy, showAll, sinceTime, showDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ignore an event
     * @param {number} eventId ID of the injury event
     * @param {IgnoreEventOptions} [IgnoreEventOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public ignoreEvent(eventId: number, IgnoreEventOptions?: IgnoreEventOptions, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).ignoreEvent(eventId, IgnoreEventOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an event
     * @param {number} eventId ID of the injury event
     * @param {Event} [Event] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEvent(eventId: number, Event?: Event, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEvent(eventId, Event, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a file to attach to the event. Usually a pdf containing a neurocognitive report. Uploading a new one replaces any existing one
     * @param {number} eventId ID of the injury event
     * @param {string} fileName File basename (no directory)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public uploadEventFile(eventId: number, fileName: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).uploadEventFile(eventId, fileName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExternalConcussionsApi - axios parameter creator
 * @export
 */
export const ExternalConcussionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create an external concussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalConcussion: async (playerId: number, ExternalConcussion: ExternalConcussion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('createExternalConcussion', 'playerId', playerId)
            // verify required parameter 'ExternalConcussion' is not null or undefined
            assertParamExists('createExternalConcussion', 'ExternalConcussion', ExternalConcussion)
            const localVarPath = `/players/{playerId}/externalConcussions`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ExternalConcussion, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the external concussions this user can see. Paginated and filtered, sorted newest first.
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalConcussions: async (playerId: number, page?: number, pageSize?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getExternalConcussions', 'playerId', playerId)
            const localVarPath = `/players/{playerId}/externalConcussions`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an external concussion
         * @param {number} externalConcussionId ID of the externalConcussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalConcussion: async (externalConcussionId: number, playerId: number, ExternalConcussion: ExternalConcussion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalConcussionId' is not null or undefined
            assertParamExists('updateExternalConcussion', 'externalConcussionId', externalConcussionId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updateExternalConcussion', 'playerId', playerId)
            // verify required parameter 'ExternalConcussion' is not null or undefined
            assertParamExists('updateExternalConcussion', 'ExternalConcussion', ExternalConcussion)
            const localVarPath = `/players/{playerId}/externalConcussions/{externalConcussionId}`
                .replace(`{${"externalConcussionId"}}`, encodeURIComponent(String(externalConcussionId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ExternalConcussion, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalConcussionsApi - functional programming interface
 * @export
 */
export const ExternalConcussionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalConcussionsApiAxiosParamCreator(configuration)
    return {
        /**
         * create an external concussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExternalConcussion(playerId: number, ExternalConcussion: ExternalConcussion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalConcussion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExternalConcussion(playerId, ExternalConcussion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the external concussions this user can see. Paginated and filtered, sorted newest first.
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalConcussions(playerId: number, page?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalConcussionsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalConcussions(playerId, page, pageSize, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update an external concussion
         * @param {number} externalConcussionId ID of the externalConcussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExternalConcussion(externalConcussionId: number, playerId: number, ExternalConcussion: ExternalConcussion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalConcussion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExternalConcussion(externalConcussionId, playerId, ExternalConcussion, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExternalConcussionsApi - factory interface
 * @export
 */
export const ExternalConcussionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalConcussionsApiFp(configuration)
    return {
        /**
         * create an external concussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalConcussion(playerId: number, ExternalConcussion: ExternalConcussion, options?: any): AxiosPromise<ExternalConcussion> {
            return localVarFp.createExternalConcussion(playerId, ExternalConcussion, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the external concussions this user can see. Paginated and filtered, sorted newest first.
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalConcussions(playerId: number, page?: number, pageSize?: number, orderBy?: string, options?: any): AxiosPromise<ExternalConcussionsOnPage> {
            return localVarFp.getExternalConcussions(playerId, page, pageSize, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * update an external concussion
         * @param {number} externalConcussionId ID of the externalConcussion
         * @param {number} playerId ID of the player
         * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExternalConcussion(externalConcussionId: number, playerId: number, ExternalConcussion: ExternalConcussion, options?: any): AxiosPromise<ExternalConcussion> {
            return localVarFp.updateExternalConcussion(externalConcussionId, playerId, ExternalConcussion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalConcussionsApi - object-oriented interface
 * @export
 * @class ExternalConcussionsApi
 * @extends {BaseAPI}
 */
export class ExternalConcussionsApi extends BaseAPI {
    /**
     * create an external concussion
     * @param {number} playerId ID of the player
     * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConcussionsApi
     */
    public createExternalConcussion(playerId: number, ExternalConcussion: ExternalConcussion, options?: AxiosRequestConfig) {
        return ExternalConcussionsApiFp(this.configuration).createExternalConcussion(playerId, ExternalConcussion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the external concussions this user can see. Paginated and filtered, sorted newest first.
     * @param {number} playerId ID of the player
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConcussionsApi
     */
    public getExternalConcussions(playerId: number, page?: number, pageSize?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return ExternalConcussionsApiFp(this.configuration).getExternalConcussions(playerId, page, pageSize, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update an external concussion
     * @param {number} externalConcussionId ID of the externalConcussion
     * @param {number} playerId ID of the player
     * @param {ExternalConcussion} ExternalConcussion Review ExternalConcussion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalConcussionsApi
     */
    public updateExternalConcussion(externalConcussionId: number, playerId: number, ExternalConcussion: ExternalConcussion, options?: AxiosRequestConfig) {
        return ExternalConcussionsApiFp(this.configuration).updateExternalConcussion(externalConcussionId, playerId, ExternalConcussion, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FixturesApi - axios parameter creator
 * @export
 */
export const FixturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new fixture
         * @param {Fixture} Fixture Created fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFixture: async (Fixture: Fixture, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Fixture' is not null or undefined
            assertParamExists('addFixture', 'Fixture', Fixture)
            const localVarPath = `/fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Fixture, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete fixture
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFixture: async (fixtureId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('deleteFixture', 'fixtureId', fixtureId)
            const localVarPath = `/fixtures/{fixtureId}`
                .replace(`{${"fixtureId"}}`, encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get fixture by id
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixtureById: async (fixtureId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('getFixtureById', 'fixtureId', fixtureId)
            const localVarPath = `/fixtures/{fixtureId}`
                .replace(`{${"fixtureId"}}`, encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all fixtures
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [kickoffAfter] return fixtures with a kickoffAt &gt;&#x3D; unix time in microseconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixtures: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, venue?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, kickoffAfter?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (venue) {
                localVarQueryParameter['venue'] = venue;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (kickoffAfter !== undefined) {
                localVarQueryParameter['kickoffAfter'] = kickoffAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * merge all the stuff from fromFixtureId into fixtureId and delete fromFixtureId
         * @param {number} fixtureId ID of the fixture
         * @param {number} fromFixtureId fixture to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeFixture: async (fixtureId: number, fromFixtureId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('mergeFixture', 'fixtureId', fixtureId)
            // verify required parameter 'fromFixtureId' is not null or undefined
            assertParamExists('mergeFixture', 'fromFixtureId', fromFixtureId)
            const localVarPath = `/fixtures/{fixtureId}/mergeFrom/{fromFixtureId}`
                .replace(`{${"fixtureId"}}`, encodeURIComponent(String(fixtureId)))
                .replace(`{${"fromFixtureId"}}`, encodeURIComponent(String(fromFixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing fixture.
         * @param {number} fixtureId ID of the fixture
         * @param {Fixture} Fixture Updated fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFixture: async (fixtureId: number, Fixture: Fixture, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureId' is not null or undefined
            assertParamExists('updateFixture', 'fixtureId', fixtureId)
            // verify required parameter 'Fixture' is not null or undefined
            assertParamExists('updateFixture', 'Fixture', Fixture)
            const localVarPath = `/fixtures/{fixtureId}`
                .replace(`{${"fixtureId"}}`, encodeURIComponent(String(fixtureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Fixture, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FixturesApi - functional programming interface
 * @export
 */
export const FixturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FixturesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new fixture
         * @param {Fixture} Fixture Created fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFixture(Fixture: Fixture, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fixture>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFixture(Fixture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete fixture
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFixture(fixtureId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFixture(fixtureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get fixture by id
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFixtureById(fixtureId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fixture>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFixtureById(fixtureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all fixtures
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [kickoffAfter] return fixtures with a kickoffAt &gt;&#x3D; unix time in microseconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFixtures(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, venue?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, kickoffAfter?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixturesOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFixtures(page, pageSize, search, org, team, tournament, venue, sinceTime, showDeleted, orderBy, kickoffAfter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * merge all the stuff from fromFixtureId into fixtureId and delete fromFixtureId
         * @param {number} fixtureId ID of the fixture
         * @param {number} fromFixtureId fixture to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeFixture(fixtureId: number, fromFixtureId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeFixture(fixtureId, fromFixtureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing fixture.
         * @param {number} fixtureId ID of the fixture
         * @param {Fixture} Fixture Updated fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFixture(fixtureId: number, Fixture: Fixture, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fixture>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFixture(fixtureId, Fixture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FixturesApi - factory interface
 * @export
 */
export const FixturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FixturesApiFp(configuration)
    return {
        /**
         * Create a new fixture
         * @param {Fixture} Fixture Created fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFixture(Fixture: Fixture, options?: any): AxiosPromise<Fixture> {
            return localVarFp.addFixture(Fixture, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete fixture
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFixture(fixtureId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteFixture(fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get fixture by id
         * @param {number} fixtureId ID of the fixture
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixtureById(fixtureId: number, options?: any): AxiosPromise<Fixture> {
            return localVarFp.getFixtureById(fixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all fixtures
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [kickoffAfter] return fixtures with a kickoffAt &gt;&#x3D; unix time in microseconds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFixtures(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, venue?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, kickoffAfter?: number, options?: any): AxiosPromise<FixturesOnPage> {
            return localVarFp.getFixtures(page, pageSize, search, org, team, tournament, venue, sinceTime, showDeleted, orderBy, kickoffAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * merge all the stuff from fromFixtureId into fixtureId and delete fromFixtureId
         * @param {number} fixtureId ID of the fixture
         * @param {number} fromFixtureId fixture to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeFixture(fixtureId: number, fromFixtureId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.mergeFixture(fixtureId, fromFixtureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing fixture.
         * @param {number} fixtureId ID of the fixture
         * @param {Fixture} Fixture Updated fixture object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFixture(fixtureId: number, Fixture: Fixture, options?: any): AxiosPromise<Fixture> {
            return localVarFp.updateFixture(fixtureId, Fixture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FixturesApi - object-oriented interface
 * @export
 * @class FixturesApi
 * @extends {BaseAPI}
 */
export class FixturesApi extends BaseAPI {
    /**
     * Create a new fixture
     * @param {Fixture} Fixture Created fixture object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public addFixture(Fixture: Fixture, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).addFixture(Fixture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete fixture
     * @param {number} fixtureId ID of the fixture
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public deleteFixture(fixtureId: number, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).deleteFixture(fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get fixture by id
     * @param {number} fixtureId ID of the fixture
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public getFixtureById(fixtureId: number, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).getFixtureById(fixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all fixtures
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {Array<number>} [venue] comma separated list of integer venue ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {number} [kickoffAfter] return fixtures with a kickoffAt &gt;&#x3D; unix time in microseconds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public getFixtures(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, venue?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, kickoffAfter?: number, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).getFixtures(page, pageSize, search, org, team, tournament, venue, sinceTime, showDeleted, orderBy, kickoffAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * merge all the stuff from fromFixtureId into fixtureId and delete fromFixtureId
     * @param {number} fixtureId ID of the fixture
     * @param {number} fromFixtureId fixture to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public mergeFixture(fixtureId: number, fromFixtureId: number, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).mergeFixture(fixtureId, fromFixtureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing fixture.
     * @param {number} fixtureId ID of the fixture
     * @param {Fixture} Fixture Updated fixture object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FixturesApi
     */
    public updateFixture(fixtureId: number, Fixture: Fixture, options?: AxiosRequestConfig) {
        return FixturesApiFp(this.configuration).updateFixture(fixtureId, Fixture, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IccApi - axios parameter creator
 * @export
 */
export const IccApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a new icc review. Back end sends an email to the ICC with a link so they can do the review
         * @param {ICCReviewRequest} ICCReviewRequest Created review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIccReview: async (ICCReviewRequest: ICCReviewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ICCReviewRequest' is not null or undefined
            assertParamExists('addIccReview', 'ICCReviewRequest', ICCReviewRequest)
            const localVarPath = `/iccreviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ICCReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline review by id
         * @summary 
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineIccReviewById: async (iccReviewId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iccReviewId' is not null or undefined
            assertParamExists('declineIccReviewById', 'iccReviewId', iccReviewId)
            const localVarPath = `/iccreviews/{iccReviewId}/decline`
                .replace(`{${"iccReviewId"}}`, encodeURIComponent(String(iccReviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIccReview: async (iccReviewId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iccReviewId' is not null or undefined
            assertParamExists('deleteIccReview', 'iccReviewId', iccReviewId)
            const localVarPath = `/iccreviews/{iccReviewId}`
                .replace(`{${"iccReviewId"}}`, encodeURIComponent(String(iccReviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get review by id
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIccReviewById: async (iccReviewId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iccReviewId' is not null or undefined
            assertParamExists('getIccReviewById', 'iccReviewId', iccReviewId)
            const localVarPath = `/iccreviews/{iccReviewId}`
                .replace(`{${"iccReviewId"}}`, encodeURIComponent(String(iccReviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all icc reviews this user can see in reverse date order (newest first). For an ICC role that is all the reviews assignedTo them or that are open to anyone. For an org or team it is reviews for their players
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showCompleted] DEPRECATED. Use show&#x3D; instead
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {'all' | 'complete' | 'incomplete'} [show] status of reviews to show. Pick one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIccReviews: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, showCompleted?: number, event?: Array<number>, show?: 'all' | 'complete' | 'incomplete', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/iccreviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (showCompleted !== undefined) {
                localVarQueryParameter['showCompleted'] = showCompleted;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (show !== undefined) {
                localVarQueryParameter['show'] = show;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf: async (assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assessment) {
                localVarQueryParameter['assessment'] = assessment;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (iccreview) {
                localVarQueryParameter['iccreview'] = iccreview;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {ICCReview} ICCReview Updated review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIccReview: async (iccReviewId: number, ICCReview: ICCReview, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iccReviewId' is not null or undefined
            assertParamExists('updateIccReview', 'iccReviewId', iccReviewId)
            // verify required parameter 'ICCReview' is not null or undefined
            assertParamExists('updateIccReview', 'ICCReview', ICCReview)
            const localVarPath = `/iccreviews/{iccReviewId}`
                .replace(`{${"iccReviewId"}}`, encodeURIComponent(String(iccReviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ICCReview, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IccApi - functional programming interface
 * @export
 */
export const IccApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IccApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a new icc review. Back end sends an email to the ICC with a link so they can do the review
         * @param {ICCReviewRequest} ICCReviewRequest Created review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addIccReview(ICCReviewRequest: ICCReviewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addIccReview(ICCReviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Decline review by id
         * @summary 
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineIccReviewById(iccReviewId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineIccReviewById(iccReviewId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIccReview(iccReviewId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIccReview(iccReviewId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get review by id
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIccReviewById(iccReviewId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIccReviewById(iccReviewId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all icc reviews this user can see in reverse date order (newest first). For an ICC role that is all the reviews assignedTo them or that are open to anyone. For an org or team it is reviews for their players
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showCompleted] DEPRECATED. Use show&#x3D; instead
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {'all' | 'complete' | 'incomplete'} [show] status of reviews to show. Pick one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIccReviews(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, showCompleted?: number, event?: Array<number>, show?: 'all' | 'complete' | 'incomplete', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReviewsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIccReviews(page, pageSize, search, org, team, player, sinceTime, showDeleted, orderBy, showCompleted, event, show, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdf(assessment, event, iccreview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {ICCReview} ICCReview Updated review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIccReview(iccReviewId: number, ICCReview: ICCReview, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIccReview(iccReviewId, ICCReview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IccApi - factory interface
 * @export
 */
export const IccApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IccApiFp(configuration)
    return {
        /**
         * Request a new icc review. Back end sends an email to the ICC with a link so they can do the review
         * @param {ICCReviewRequest} ICCReviewRequest Created review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIccReview(ICCReviewRequest: ICCReviewRequest, options?: any): AxiosPromise<ICCReview> {
            return localVarFp.addIccReview(ICCReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline review by id
         * @summary 
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineIccReviewById(iccReviewId: number, options?: any): AxiosPromise<ICCReview> {
            return localVarFp.declineIccReviewById(iccReviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIccReview(iccReviewId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteIccReview(iccReviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get review by id
         * @param {number} iccReviewId ID of the ICC Review
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIccReviewById(iccReviewId: number, options?: any): AxiosPromise<ICCReview> {
            return localVarFp.getIccReviewById(iccReviewId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all icc reviews this user can see in reverse date order (newest first). For an ICC role that is all the reviews assignedTo them or that are open to anyone. For an org or team it is reviews for their players
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {number} [showCompleted] DEPRECATED. Use show&#x3D; instead
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {'all' | 'complete' | 'incomplete'} [show] status of reviews to show. Pick one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIccReviews(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, showCompleted?: number, event?: Array<number>, show?: 'all' | 'complete' | 'incomplete', options?: any): AxiosPromise<ICCReviewsOnPage> {
            return localVarFp.getIccReviews(page, pageSize, search, org, team, player, sinceTime, showDeleted, orderBy, showCompleted, event, show, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: any): AxiosPromise<PDFUrl> {
            return localVarFp.getPdf(assessment, event, iccreview, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing icc review
         * @param {number} iccReviewId ID of the ICC Review
         * @param {ICCReview} ICCReview Updated review object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIccReview(iccReviewId: number, ICCReview: ICCReview, options?: any): AxiosPromise<ICCReview> {
            return localVarFp.updateIccReview(iccReviewId, ICCReview, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IccApi - object-oriented interface
 * @export
 * @class IccApi
 * @extends {BaseAPI}
 */
export class IccApi extends BaseAPI {
    /**
     * Request a new icc review. Back end sends an email to the ICC with a link so they can do the review
     * @param {ICCReviewRequest} ICCReviewRequest Created review object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public addIccReview(ICCReviewRequest: ICCReviewRequest, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).addIccReview(ICCReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline review by id
     * @summary 
     * @param {number} iccReviewId ID of the ICC Review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public declineIccReviewById(iccReviewId: number, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).declineIccReviewById(iccReviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete icc review
     * @param {number} iccReviewId ID of the ICC Review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public deleteIccReview(iccReviewId: number, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).deleteIccReview(iccReviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get review by id
     * @param {number} iccReviewId ID of the ICC Review
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public getIccReviewById(iccReviewId: number, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).getIccReviewById(iccReviewId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all icc reviews this user can see in reverse date order (newest first). For an ICC role that is all the reviews assignedTo them or that are open to anyone. For an org or team it is reviews for their players
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {number} [showCompleted] DEPRECATED. Use show&#x3D; instead
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {'all' | 'complete' | 'incomplete'} [show] status of reviews to show. Pick one
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public getIccReviews(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, showCompleted?: number, event?: Array<number>, show?: 'all' | 'complete' | 'incomplete', options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).getIccReviews(page, pageSize, search, org, team, player, sinceTime, showDeleted, orderBy, showCompleted, event, show, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a url to download a pdf report from
     * @param {Array<number>} [assessment] comma separated list of integer assessment ids
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).getPdf(assessment, event, iccreview, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing icc review
     * @param {number} iccReviewId ID of the ICC Review
     * @param {ICCReview} ICCReview Updated review object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IccApi
     */
    public updateIccReview(iccReviewId: number, ICCReview: ICCReview, options?: AxiosRequestConfig) {
        return IccApiFp(this.configuration).updateIccReview(iccReviewId, ICCReview, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImgApi - axios parameter creator
 * @export
 */
export const ImgApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Webhook for iMG providers to post iMG Alerts into our system
         * @summary 
         * @param {string} providerIncomingWebHookId incomingWebhookId of the iMGProvider
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iMGWebhook: async (providerIncomingWebHookId: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerIncomingWebHookId' is not null or undefined
            assertParamExists('iMGWebhook', 'providerIncomingWebHookId', providerIncomingWebHookId)
            const localVarPath = `/iMG/webhook/{providerIncomingWebHookId}`
                .replace(`{${"providerIncomingWebHookId"}}`, encodeURIComponent(String(providerIncomingWebHookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImgApi - functional programming interface
 * @export
 */
export const ImgApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImgApiAxiosParamCreator(configuration)
    return {
        /**
         * Webhook for iMG providers to post iMG Alerts into our system
         * @summary 
         * @param {string} providerIncomingWebHookId incomingWebhookId of the iMGProvider
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iMGWebhook(providerIncomingWebHookId: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICCReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iMGWebhook(providerIncomingWebHookId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImgApi - factory interface
 * @export
 */
export const ImgApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImgApiFp(configuration)
    return {
        /**
         * Webhook for iMG providers to post iMG Alerts into our system
         * @summary 
         * @param {string} providerIncomingWebHookId incomingWebhookId of the iMGProvider
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iMGWebhook(providerIncomingWebHookId: string, body?: object, options?: any): AxiosPromise<ICCReview> {
            return localVarFp.iMGWebhook(providerIncomingWebHookId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImgApi - object-oriented interface
 * @export
 * @class ImgApi
 * @extends {BaseAPI}
 */
export class ImgApi extends BaseAPI {
    /**
     * Webhook for iMG providers to post iMG Alerts into our system
     * @summary 
     * @param {string} providerIncomingWebHookId incomingWebhookId of the iMGProvider
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImgApi
     */
    public iMGWebhook(providerIncomingWebHookId: string, body?: object, options?: AxiosRequestConfig) {
        return ImgApiFp(this.configuration).iMGWebhook(providerIncomingWebHookId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MetaApi - axios parameter creator
 * @export
 */
export const MetaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new api key
         * @param {ApiKey} ApiKey Api Key to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApiKey: async (ApiKey: ApiKey, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ApiKey' is not null or undefined
            assertParamExists('addApiKey', 'ApiKey', ApiKey)
            const localVarPath = `/apikeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ApiKey, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an Api Key
         * @param {number} apiKeyId ID of the api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: async (apiKeyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKey', 'apiKeyId', apiKeyId)
            const localVarPath = `/apikeys/{apiKeyId}`
                .replace(`{${"apiKeyId"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the api keys this user can see. Paginated and sorted by org name then key name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: async (page?: number, pageSize?: number, org?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apikeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get the current version of the api and other information about it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getChangesSince: async (org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/changes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (assessment) {
                localVarQueryParameter['assessment'] = assessment;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * displays an html page containing the OpenAPI yaml spec rendered in a human friendly ui as documentation
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDocs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by admin ui to show home page graphs
         * @param {number} [startTime] unix timestamp in milliseconds. Return GraphData from this time forward. Default to today -7 days
         * @param {number} [endTime] unix timestamp in milliseconds. Return GraphData between startTime and endTime. Default to now()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphData: async (startTime?: number, endTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/graphs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lookups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of timezones we can use for venues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimezones: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/timezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logMessage: async (MessageToLog: MessageToLog, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'MessageToLog' is not null or undefined
            assertParamExists('logMessage', 'MessageToLog', MessageToLog)
            const localVarPath = `/logMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(MessageToLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * global search across many object types
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<SearchItemType>} [type] comma separated types of data to return. missing or blank value returns all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (search?: string, page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<SearchItemType>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetaApi - functional programming interface
 * @export
 */
export const MetaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetaApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new api key
         * @param {ApiKey} ApiKey Api Key to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addApiKey(ApiKey: ApiKey, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addApiKey(ApiKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an Api Key
         * @param {number} apiKeyId ID of the api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKey(apiKeyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKey(apiKeyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the api keys this user can see. Paginated and sorted by org name then key name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeys(page?: number, pageSize?: number, org?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeysOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeys(page, pageSize, org, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get the current version of the api and other information about it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Changes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangesSince(org, team, player, assessment, sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * displays an html page containing the OpenAPI yaml spec rendered in a human friendly ui as documentation
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getDocs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by admin ui to show home page graphs
         * @param {number} [startTime] unix timestamp in milliseconds. Return GraphData from this time forward. Default to today -7 days
         * @param {number} [endTime] unix timestamp in milliseconds. Return GraphData between startTime and endTime. Default to now()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphData(startTime?: number, endTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphData(startTime, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLookups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lookups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLookups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of timezones we can use for venues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimezones(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Timezones>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimezones(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logMessage(MessageToLog: MessageToLog, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logMessage(MessageToLog, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * global search across many object types
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<SearchItemType>} [type] comma separated types of data to return. missing or blank value returns all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(search?: string, page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<SearchItemType>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(search, page, pageSize, org, team, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetaApi - factory interface
 * @export
 */
export const MetaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetaApiFp(configuration)
    return {
        /**
         * Add a new api key
         * @param {ApiKey} ApiKey Api Key to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApiKey(ApiKey: ApiKey, options?: any): AxiosPromise<ApiKey> {
            return localVarFp.addApiKey(ApiKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an Api Key
         * @param {number} apiKeyId ID of the api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(apiKeyId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteApiKey(apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the api keys this user can see. Paginated and sorted by org name then key name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys(page?: number, pageSize?: number, org?: Array<number>, options?: any): AxiosPromise<ApiKeysOnPage> {
            return localVarFp.getApiKeys(page, pageSize, org, options).then((request) => request(axios, basePath));
        },
        /**
         * get the current version of the api and other information about it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiVersion(options?: any): AxiosPromise<ApiVersion> {
            return localVarFp.getApiVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: any): AxiosPromise<Changes> {
            return localVarFp.getChangesSince(org, team, player, assessment, sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * displays an html page containing the OpenAPI yaml spec rendered in a human friendly ui as documentation
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDocs(options?: any): AxiosPromise<string> {
            return localVarFp.getDocs(options).then((request) => request(axios, basePath));
        },
        /**
         * Used by admin ui to show home page graphs
         * @param {number} [startTime] unix timestamp in milliseconds. Return GraphData from this time forward. Default to today -7 days
         * @param {number} [endTime] unix timestamp in milliseconds. Return GraphData between startTime and endTime. Default to now()
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphData(startTime?: number, endTime?: number, options?: any): AxiosPromise<GraphData> {
            return localVarFp.getGraphData(startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookups(options?: any): AxiosPromise<Lookups> {
            return localVarFp.getLookups(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(options?: any): AxiosPromise<Array<Position>> {
            return localVarFp.getPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of timezones we can use for venues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimezones(options?: any): AxiosPromise<Timezones> {
            return localVarFp.getTimezones(options).then((request) => request(axios, basePath));
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logMessage(MessageToLog: MessageToLog, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.logMessage(MessageToLog, options).then((request) => request(axios, basePath));
        },
        /**
         * global search across many object types
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<SearchItemType>} [type] comma separated types of data to return. missing or blank value returns all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(search?: string, page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<SearchItemType>, options?: any): AxiosPromise<SearchResult> {
            return localVarFp.search(search, page, pageSize, org, team, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
export class MetaApi extends BaseAPI {
    /**
     * Add a new api key
     * @param {ApiKey} ApiKey Api Key to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public addApiKey(ApiKey: ApiKey, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).addApiKey(ApiKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an Api Key
     * @param {number} apiKeyId ID of the api key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public deleteApiKey(apiKeyId: number, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).deleteApiKey(apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the api keys this user can see. Paginated and sorted by org name then key name
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getApiKeys(page?: number, pageSize?: number, org?: Array<number>, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getApiKeys(page, pageSize, org, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get the current version of the api and other information about it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getApiVersion(options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getApiVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
     * @summary (Legacy) Get Changes Since
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<number>} [assessment] comma separated list of integer assessment ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getChangesSince(org, team, player, assessment, sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * displays an html page containing the OpenAPI yaml spec rendered in a human friendly ui as documentation
     * @summary (Legacy) Get Dashboard (initial sync)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getDocs(options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getDocs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by admin ui to show home page graphs
     * @param {number} [startTime] unix timestamp in milliseconds. Return GraphData from this time forward. Default to today -7 days
     * @param {number} [endTime] unix timestamp in milliseconds. Return GraphData between startTime and endTime. Default to now()
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getGraphData(startTime?: number, endTime?: number, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getGraphData(startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all lookup strings for all types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getLookups(options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getLookups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all positions a player can hold eg full back
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getPositions(options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of timezones we can use for venues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public getTimezones(options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).getTimezones(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * write some text to the api logs for diagnostic purposes
     * @param {MessageToLog} MessageToLog The message to log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public logMessage(MessageToLog: MessageToLog, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).logMessage(MessageToLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * global search across many object types
     * @param {string} [search] return only items where this string occurs in the name
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<SearchItemType>} [type] comma separated types of data to return. missing or blank value returns all
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    public search(search?: string, page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, type?: Array<SearchItemType>, options?: AxiosRequestConfig) {
        return MetaApiFp(this.configuration).search(search, page, pageSize, org, team, type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobileApi - axios parameter creator
 * @export
 */
export const MobileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment: async (Assessment: Assessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Assessment' is not null or undefined
            assertParamExists('addAssessment', 'Assessment', Assessment)
            const localVarPath = `/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Assessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('addPlayerToTeam', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginUser: async (Login: Login, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Login' is not null or undefined
            assertParamExists('authLoginUser', 'Login', Login)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Login, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutUser: async (Logout: Logout, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Logout' is not null or undefined
            assertParamExists('authLogoutUser', 'Logout', Logout)
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Logout, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMfa: async (MFAResponse: MFAResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'MFAResponse' is not null or undefined
            assertParamExists('authMfa', 'MFAResponse', MFAResponse)
            const localVarPath = `/auth/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(MFAResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (ForgotPassword: ForgotPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ForgotPassword' is not null or undefined
            assertParamExists('forgotPassword', 'ForgotPassword', ForgotPassword)
            const localVarPath = `/auth/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ForgotPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById: async (assessmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getAssessmentById', 'assessmentId', assessmentId)
            const localVarPath = `/assessments/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessments: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getChangesSince: async (org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/changes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (assessment) {
                localVarQueryParameter['assessment'] = assessment;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lookups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf: async (assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (assessment) {
                localVarQueryParameter['assessment'] = assessment;
            }

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (iccreview) {
                localVarQueryParameter['iccreview'] = iccreview;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerById: async (playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerById', 'playerId', playerId)
            const localVarPath = `/players/{playerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (includeBaselineDate !== undefined) {
                localVarQueryParameter['includeBaselineDate'] = includeBaselineDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersWithNoComprehensiveBaseline: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reports/playersWithNoComprehensiveBaseline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserDashboard: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logMessage: async (MessageToLog: MessageToLog, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'MessageToLog' is not null or undefined
            assertParamExists('logMessage', 'MessageToLog', MessageToLog)
            const localVarPath = `/logMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(MessageToLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (UserDevice: UserDevice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserDevice' is not null or undefined
            assertParamExists('register', 'UserDevice', UserDevice)
            const localVarPath = `/notifications/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPushNotification: async (PushNotification: PushNotification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'PushNotification' is not null or undefined
            assertParamExists('testPushNotification', 'PushNotification', PushNotification)
            const localVarPath = `/notifications/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PushNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregister: async (UserDevice: UserDevice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserDevice' is not null or undefined
            assertParamExists('unregister', 'UserDevice', UserDevice)
            const localVarPath = `/notifications/unregister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessment: async (assessmentId: number, Assessment: Assessment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('updateAssessment', 'assessmentId', assessmentId)
            // verify required parameter 'Assessment' is not null or undefined
            assertParamExists('updateAssessment', 'Assessment', Assessment)
            const localVarPath = `/assessments/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Assessment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotifications: async (NotificationReadAt: Array<NotificationReadAt>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'NotificationReadAt' is not null or undefined
            assertParamExists('updateNotifications', 'NotificationReadAt', NotificationReadAt)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(NotificationReadAt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayer: async (playerId: number, Player: Player, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updatePlayer', 'playerId', playerId)
            // verify required parameter 'Player' is not null or undefined
            assertParamExists('updatePlayer', 'Player', Player)
            const localVarPath = `/players/{playerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Player, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('updateTeamPlayer', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobileApi - functional programming interface
 * @export
 */
export const MobileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobileApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAssessment(Assessment: Assessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAssessment(Assessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamPlayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayerToTeam(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLoginUser(Login: Login, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenOrMFAChallenge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginUser(Login, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogoutUser(Logout: Logout, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutUser(Logout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authMfa(MFAResponse: MFAResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenOrMFAChallenge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authMfa(MFAResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRefreshToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRefreshToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(ForgotPassword: ForgotPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(ForgotPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentById(assessmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentById(assessmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Changes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangesSince(org, team, player, assessment, sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLookups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lookups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLookups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdf(assessment, event, iccreview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerById(playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerById(playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayersOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayersOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Position>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getUserDashboard(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardTeams>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logMessage(MessageToLog: MessageToLog, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logMessage(MessageToLog, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(UserDevice: UserDevice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(UserDevice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testPushNotification(PushNotification: PushNotification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testPushNotification(PushNotification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregister(UserDevice: UserDevice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregister(UserDevice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssessment(assessmentId, Assessment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationReadAtResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotifications(NotificationReadAt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlayer(playerId: number, Player: Player, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlayer(playerId, Player, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamPlayer(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobileApi - factory interface
 * @export
 */
export const MobileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobileApiFp(configuration)
    return {
        /**
         * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
         * @param {Assessment} Assessment Assessment to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment(Assessment: Assessment, options?: any): AxiosPromise<Assessment> {
            return localVarFp.addAssessment(Assessment, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<Array<TeamPlayer>> {
            return localVarFp.addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
         * @param {Login} Login auth login endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginUser(Login: Login, options?: any): AxiosPromise<TokenOrMFAChallenge> {
            return localVarFp.authLoginUser(Login, options).then((request) => request(axios, basePath));
        },
        /**
         * Logs out current logged in user session
         * @param {Logout} Logout auth logout endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutUser(Logout: Logout, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.authLogoutUser(Logout, options).then((request) => request(axios, basePath));
        },
        /**
         * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
         * @param {MFAResponse} MFAResponse MFA response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMfa(MFAResponse: MFAResponse, options?: any): AxiosPromise<TokenOrMFAChallenge> {
            return localVarFp.authMfa(MFAResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a new access and refresh token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshToken(options?: any): AxiosPromise<TokenResponse> {
            return localVarFp.authRefreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
         * @param {ForgotPassword} ForgotPassword Forgot Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(ForgotPassword: ForgotPassword, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.forgotPassword(ForgotPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * Find Assessment by ID. Returns an assessment
         * @param {number} assessmentId ID of the assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById(assessmentId: number, options?: any): AxiosPromise<Assessment> {
            return localVarFp.getAssessmentById(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: any): AxiosPromise<AssessmentsOnPage> {
            return localVarFp.getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
         * @summary (Legacy) Get Changes Since
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: any): AxiosPromise<Changes> {
            return localVarFp.getChangesSince(org, team, player, assessment, sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all lookup strings for all types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookups(options?: any): AxiosPromise<Lookups> {
            return localVarFp.getLookups(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a url to download a pdf report from
         * @param {Array<number>} [assessment] comma separated list of integer assessment ids
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: any): AxiosPromise<PDFUrl> {
            return localVarFp.getPdf(assessment, event, iccreview, options).then((request) => request(axios, basePath));
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerById(playerId: number, options?: any): AxiosPromise<Player> {
            return localVarFp.getPlayerById(playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: any): AxiosPromise<PlayersOnPage> {
            return localVarFp.getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: any): AxiosPromise<PlayersOnPage> {
            return localVarFp.getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all positions a player can hold eg full back
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(options?: any): AxiosPromise<Array<Position>> {
            return localVarFp.getPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserDashboard(options?: any): AxiosPromise<Array<DashboardTeams>> {
            return localVarFp.getUserDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * write some text to the api logs for diagnostic purposes
         * @param {MessageToLog} MessageToLog The message to log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logMessage(MessageToLog: MessageToLog, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.logMessage(MessageToLog, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(UserDevice: UserDevice, options?: any): AxiosPromise<UserDeviceResponse> {
            return localVarFp.register(UserDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPushNotification(PushNotification: PushNotification, options?: any): AxiosPromise<PushNotificationResponse> {
            return localVarFp.testPushNotification(PushNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregister(UserDevice: UserDevice, options?: any): AxiosPromise<UserDeviceResponse> {
            return localVarFp.unregister(UserDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing assessment
         * @param {number} assessmentId ID of the assessment
         * @param {Assessment} Assessment Update assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessment(assessmentId: number, Assessment: Assessment, options?: any): AxiosPromise<Assessment> {
            return localVarFp.updateAssessment(assessmentId, Assessment, options).then((request) => request(axios, basePath));
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: any): AxiosPromise<Array<NotificationReadAtResponse>> {
            return localVarFp.updateNotifications(NotificationReadAt, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayer(playerId: number, Player: Player, options?: any): AxiosPromise<Player> {
            return localVarFp.updatePlayer(playerId, Player, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<TeamPlayer> {
            return localVarFp.updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobileApi - object-oriented interface
 * @export
 * @class MobileApi
 * @extends {BaseAPI}
 */
export class MobileApi extends BaseAPI {
    /**
     * Add a new assessment to the RHR dataset. Assessment business logic rules, create or allocate to existing event (by player, time, assessment type), if baseline check reference limits (create pending reTest) and modes for the assessmentType (hia1, hia2, hia3) etc.
     * @param {Assessment} Assessment Assessment to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public addAssessment(Assessment: Assessment, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).addAssessment(Assessment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new player to a team
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logs user into the system. Response is either an MFA challenge, or the data needed for a valid session
     * @param {Login} Login auth login endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public authLoginUser(Login: Login, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).authLoginUser(Login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logs out current logged in user session
     * @param {Logout} Logout auth logout endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public authLogoutUser(Logout: Logout, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).authLogoutUser(Logout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * send the user entered mfa code from /auth/login back to the api for verification. It it is valid, replies with the data needed for a valid session. If the mfaCode is missing, resend the code to the specified device and reply with an MFAChallenge
     * @param {MFAResponse} MFAResponse MFA response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public authMfa(MFAResponse: MFAResponse, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).authMfa(MFAResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a new access and refresh token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public authRefreshToken(options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).authRefreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User Forgot their Password. Send them a link by email to click to supply a new one. For the admin UI, the link should be /auth/set-password?email=foo@example.com&token=somevalue. For the mobile UI, todo specify
     * @param {ForgotPassword} ForgotPassword Forgot Password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public forgotPassword(ForgotPassword: ForgotPassword, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).forgotPassword(ForgotPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find Assessment by ID. Returns an assessment
     * @param {number} assessmentId ID of the assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getAssessmentById(assessmentId: number, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getAssessmentById(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the assessments this user can see. Paginated and filtered, sorted newest first. Search string is player name
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {Array<AssessmentTypeName>} [type] comma separated list of assessment types to include in result set (name enum / string values). blank / missing means show all types
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getAssessments(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, player?: Array<number>, event?: Array<number>, tournament?: Array<number>, search?: string, sinceTime?: number, showDeleted?: number, type?: Array<AssessmentTypeName>, orderBy?: string, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getAssessments(page, pageSize, org, team, player, event, tournament, search, sinceTime, showDeleted, type, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used by mobile app to assist with offline sync. Search the database for all the teams, players, assessments that match the IDs passed as parameters and have been updated sinceTime
     * @summary (Legacy) Get Changes Since
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {Array<number>} [assessment] comma separated list of integer assessment ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getChangesSince(org?: Array<number>, team?: Array<number>, player?: Array<number>, assessment?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getChangesSince(org, team, player, assessment, sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all lookup strings for all types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getLookups(options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getLookups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a url to download a pdf report from
     * @param {Array<number>} [assessment] comma separated list of integer assessment ids
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [iccreview] comma separated list of integer ICC Review ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getPdf(assessment?: Array<number>, event?: Array<number>, iccreview?: Array<number>, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getPdf(assessment, event, iccreview, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get player by id
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getPlayerById(playerId: number, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getPlayerById(playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all players this user can see that match the filters in the query parameters
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {boolean} [includeBaselineDate] Include baseline date information for each player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all players this user can see that match the filters in the query parameters
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all positions a player can hold eg full back
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getPositions(options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get teams, players and baselines for the mobile app
     * @summary (Legacy) Get Dashboard (initial sync)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public getUserDashboard(options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).getUserDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * write some text to the api logs for diagnostic purposes
     * @param {MessageToLog} MessageToLog The message to log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public logMessage(MessageToLog: MessageToLog, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).logMessage(MessageToLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a device to receive Push Notifications (backend process)
     * @param {UserDevice} UserDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public register(UserDevice: UserDevice, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).register(UserDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
     * @param {PushNotification} PushNotification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public testPushNotification(PushNotification: PushNotification, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).testPushNotification(PushNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unregister a device to receive Push Notifications (backend process)
     * @param {UserDevice} UserDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public unregister(UserDevice: UserDevice, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).unregister(UserDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing assessment
     * @param {number} assessmentId ID of the assessment
     * @param {Assessment} Assessment Update assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public updateAssessment(assessmentId: number, Assessment: Assessment, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).updateAssessment(assessmentId, Assessment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indicates if the User has read or acted on a notification
     * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).updateNotifications(NotificationReadAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a player
     * @param {number} playerId ID of the player
     * @param {Player} Player Update player object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public updatePlayer(playerId: number, Player: Player, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).updatePlayer(playerId, Player, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a player in a team. Set position etc
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobileApi
     */
    public updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return MobileApiFp(this.configuration).updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the notifications restricted by the logged user OR all notifications if logged user is an Admin. In reverse date order.
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (page?: number, pageSize?: number, search?: string, sinceTime?: number, showDeleted?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (UserDevice: UserDevice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserDevice' is not null or undefined
            assertParamExists('register', 'UserDevice', UserDevice)
            const localVarPath = `/notifications/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPushNotification: async (PushNotification: PushNotification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'PushNotification' is not null or undefined
            assertParamExists('testPushNotification', 'PushNotification', PushNotification)
            const localVarPath = `/notifications/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PushNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregister: async (UserDevice: UserDevice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'UserDevice' is not null or undefined
            assertParamExists('unregister', 'UserDevice', UserDevice)
            const localVarPath = `/notifications/unregister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserDevice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotifications: async (NotificationReadAt: Array<NotificationReadAt>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'NotificationReadAt' is not null or undefined
            assertParamExists('updateNotifications', 'NotificationReadAt', NotificationReadAt)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(NotificationReadAt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * List the notifications restricted by the logged user OR all notifications if logged user is an Admin. In reverse date order.
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(page?: number, pageSize?: number, search?: string, sinceTime?: number, showDeleted?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(page, pageSize, search, sinceTime, showDeleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(UserDevice: UserDevice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(UserDevice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testPushNotification(PushNotification: PushNotification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testPushNotification(PushNotification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregister(UserDevice: UserDevice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeviceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregister(UserDevice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationReadAtResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotifications(NotificationReadAt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * List the notifications restricted by the logged user OR all notifications if logged user is an Admin. In reverse date order.
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(page?: number, pageSize?: number, search?: string, sinceTime?: number, showDeleted?: number, options?: any): AxiosPromise<NotificationsOnPage> {
            return localVarFp.getNotifications(page, pageSize, search, sinceTime, showDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(UserDevice: UserDevice, options?: any): AxiosPromise<UserDeviceResponse> {
            return localVarFp.register(UserDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
         * @param {PushNotification} PushNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPushNotification(PushNotification: PushNotification, options?: any): AxiosPromise<PushNotificationResponse> {
            return localVarFp.testPushNotification(PushNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * Unregister a device to receive Push Notifications (backend process)
         * @param {UserDevice} UserDevice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregister(UserDevice: UserDevice, options?: any): AxiosPromise<UserDeviceResponse> {
            return localVarFp.unregister(UserDevice, options).then((request) => request(axios, basePath));
        },
        /**
         * Indicates if the User has read or acted on a notification
         * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: any): AxiosPromise<Array<NotificationReadAtResponse>> {
            return localVarFp.updateNotifications(NotificationReadAt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * List the notifications restricted by the logged user OR all notifications if logged user is an Admin. In reverse date order.
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(page?: number, pageSize?: number, search?: string, sinceTime?: number, showDeleted?: number, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(page, pageSize, search, sinceTime, showDeleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a device to receive Push Notifications (backend process)
     * @param {UserDevice} UserDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public register(UserDevice: UserDevice, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).register(UserDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint used FOR TEST PURPOSES ONLY. It tests if the API is able to send a Push Notification to specific User via Firebase (backend process)
     * @param {PushNotification} PushNotification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public testPushNotification(PushNotification: PushNotification, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).testPushNotification(PushNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unregister a device to receive Push Notifications (backend process)
     * @param {UserDevice} UserDevice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public unregister(UserDevice: UserDevice, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).unregister(UserDevice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indicates if the User has read or acted on a notification
     * @param {Array<NotificationReadAt>} NotificationReadAt List of Notifications ID and its readAt date-time object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateNotifications(NotificationReadAt: Array<NotificationReadAt>, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotifications(NotificationReadAt, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrgsApi - axios parameter creator
 * @export
 */
export const OrgsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new org / union
         * @param {Org} Org Created org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrg: async (Org: Org, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Org' is not null or undefined
            assertParamExists('addOrg', 'Org', Org)
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Org, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrgPlayer: async (orgId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('addOrgPlayer', 'orgId', orgId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addOrgPlayer', 'playerId', playerId)
            const localVarPath = `/orgs/{orgId}/players/{playerId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete org
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg: async (orgId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrg', 'orgId', orgId)
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgPlayer: async (orgId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrgPlayer', 'orgId', orgId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('deleteOrgPlayer', 'playerId', playerId)
            const localVarPath = `/orgs/{orgId}/players/{playerId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * start union data export
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUnionData: async (orgId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('exportUnionData', 'orgId', orgId)
            const localVarPath = `/orgs/{orgId}/export`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get org by id
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgById: async (orgId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrgById', 'orgId', orgId)
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all orgs / unions matching the filters in the parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgs: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, showDeleted?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing org.
         * @param {number} orgId ID of the org / union
         * @param {Org} Org Updated org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg: async (orgId: number, Org: Org, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrg', 'orgId', orgId)
            // verify required parameter 'Org' is not null or undefined
            assertParamExists('updateOrg', 'Org', Org)
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Org, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * uploads an image
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOrgPhoto: async (orgId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('uploadOrgPhoto', 'orgId', orgId)
            const localVarPath = `/orgs/{orgId}/uploadPhoto`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgsApi - functional programming interface
 * @export
 */
export const OrgsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrgsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new org / union
         * @param {Org} Org Created org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrg(Org: Org, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Org>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrg(Org, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrgPlayer(orgId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete org
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrg(orgId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrg(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrgPlayer(orgId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * start union data export
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUnionData(orgId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportUnionData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUnionData(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get org by id
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgById(orgId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Org>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgById(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all orgs / unions matching the filters in the parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgs(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgs(page, pageSize, search, org, team, player, showDeleted, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing org.
         * @param {number} orgId ID of the org / union
         * @param {Org} Org Updated org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrg(orgId: number, Org: Org, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Org>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrg(orgId, Org, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * uploads an image
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadOrgPhoto(orgId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadOrgPhoto(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrgsApi - factory interface
 * @export
 */
export const OrgsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrgsApiFp(configuration)
    return {
        /**
         * Create new org / union
         * @param {Org} Org Created org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrg(Org: Org, options?: any): AxiosPromise<Org> {
            return localVarFp.addOrg(Org, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrgPlayer(orgId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.addOrgPlayer(orgId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete org
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg(orgId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgPlayer(orgId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteOrgPlayer(orgId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * start union data export
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUnionData(orgId: number, options?: any): AxiosPromise<ExportUnionData200Response> {
            return localVarFp.exportUnionData(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get org by id
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgById(orgId: number, options?: any): AxiosPromise<Org> {
            return localVarFp.getOrgById(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all orgs / unions matching the filters in the parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgs(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, showDeleted?: number, orderBy?: string, options?: any): AxiosPromise<OrgsOnPage> {
            return localVarFp.getOrgs(page, pageSize, search, org, team, player, showDeleted, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing org.
         * @param {number} orgId ID of the org / union
         * @param {Org} Org Updated org object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg(orgId: number, Org: Org, options?: any): AxiosPromise<Org> {
            return localVarFp.updateOrg(orgId, Org, options).then((request) => request(axios, basePath));
        },
        /**
         * uploads an image
         * @param {number} orgId ID of the org / union
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOrgPhoto(orgId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadOrgPhoto(orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
export class OrgsApi extends BaseAPI {
    /**
     * Create new org / union
     * @param {Org} Org Created org object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public addOrg(Org: Org, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).addOrg(Org, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a player to an org.
     * @param {number} orgId ID of the org / union
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public addOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).addOrgPlayer(orgId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete org
     * @param {number} orgId ID of the org / union
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public deleteOrg(orgId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).deleteOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a player from an org.
     * @param {number} orgId ID of the org / union
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public deleteOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).deleteOrgPlayer(orgId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * start union data export
     * @param {number} orgId ID of the org / union
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public exportUnionData(orgId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).exportUnionData(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get org by id
     * @param {number} orgId ID of the org / union
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgById(orgId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).getOrgById(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all orgs / unions matching the filters in the parameters
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrgs(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, player?: Array<number>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).getOrgs(page, pageSize, search, org, team, player, showDeleted, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing org.
     * @param {number} orgId ID of the org / union
     * @param {Org} Org Updated org object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public updateOrg(orgId: number, Org: Org, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).updateOrg(orgId, Org, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * uploads an image
     * @param {number} orgId ID of the org / union
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public uploadOrgPhoto(orgId: number, options?: AxiosRequestConfig) {
        return OrgsApiFp(this.configuration).uploadOrgPhoto(orgId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlayersApi - axios parameter creator
 * @export
 */
export const PlayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrgPlayer: async (orgId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('addOrgPlayer', 'orgId', orgId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addOrgPlayer', 'playerId', playerId)
            const localVarPath = `/orgs/{orgId}/players/{playerId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a new player
         * @param {Player} Player Create new Player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayer: async (Player: Player, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Player' is not null or undefined
            assertParamExists('addPlayer', 'Player', Player)
            const localVarPath = `/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Player, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add to Player Status History. Adds a record to the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerStatus: async (playerId: number, PlayerHistory: PlayerHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addPlayerStatus', 'playerId', playerId)
            // verify required parameter 'PlayerHistory' is not null or undefined
            assertParamExists('addPlayerStatus', 'PlayerHistory', PlayerHistory)
            const localVarPath = `/players/{playerId}/status`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PlayerHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('addPlayerToTeam', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgPlayer: async (orgId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrgPlayer', 'orgId', orgId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('deleteOrgPlayer', 'playerId', playerId)
            const localVarPath = `/orgs/{orgId}/players/{playerId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete player
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayer: async (playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('deletePlayer', 'playerId', playerId)
            const localVarPath = `/players/{playerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a player status / audit entry. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayerStatus: async (playerId: number, statusId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('deletePlayerStatus', 'playerId', playerId)
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('deletePlayerStatus', 'statusId', statusId)
            const localVarPath = `/players/{playerId}/status/{statusId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"statusId"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the most recent baseline for a player, merged with any subsequent retests. Used for pdf generation
         * @param {number} playerId ID of the player
         * @param {number} [atTime] unix timestamp. Return player baseline as at this timetimestamp (or before)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerBaseline: async (playerId: number, atTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerBaseline', 'playerId', playerId)
            const localVarPath = `/players/{playerId}/baseline`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (atTime !== undefined) {
                localVarQueryParameter['atTime'] = atTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerById: async (playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerById', 'playerId', playerId)
            const localVarPath = `/players/{playerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the player status history from the player audit table
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerHistory: async (playerId: number, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('getPlayerHistory', 'playerId', playerId)
            const localVarPath = `/players/{playerId}/status`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * show the statuses for a player
         * @summary ListAll PlayerStatuses
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatus: async (event?: Array<number>, player?: Array<number>, page?: number, pageSize?: number, sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/playerStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (event) {
                localVarQueryParameter['event'] = event;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (includeBaselineDate !== undefined) {
                localVarQueryParameter['includeBaselineDate'] = includeBaselineDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersWithNoComprehensiveBaseline: async (page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reports/playersWithNoComprehensiveBaseline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (player) {
                localVarQueryParameter['player'] = player;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReviews: async (page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teamPlayerReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * merge all the stuff from fromPlayerId into playerId and delete fromPlayerId
         * @param {number} playerId ID of the player
         * @param {number} fromPlayerId player to delete
         * @param {MergePlayer} MergePlayer fields to copy from other player into this one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergePlayer: async (playerId: number, fromPlayerId: number, MergePlayer: MergePlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('mergePlayer', 'playerId', playerId)
            // verify required parameter 'fromPlayerId' is not null or undefined
            assertParamExists('mergePlayer', 'fromPlayerId', fromPlayerId)
            // verify required parameter 'MergePlayer' is not null or undefined
            assertParamExists('mergePlayer', 'MergePlayer', MergePlayer)
            const localVarPath = `/players/{playerId}/mergeFrom/{fromPlayerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"fromPlayerId"}}`, encodeURIComponent(String(fromPlayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(MergePlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamPlayer: async (teamId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeTeamPlayer', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('removeTeamPlayer', 'playerId', playerId)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayer: async (playerId: number, Player: Player, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updatePlayer', 'playerId', playerId)
            // verify required parameter 'Player' is not null or undefined
            assertParamExists('updatePlayer', 'Player', Player)
            const localVarPath = `/players/{playerId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Player, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Player Status History. Edits a record in the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayerStatus: async (playerId: number, statusId: number, PlayerHistory: PlayerHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updatePlayerStatus', 'playerId', playerId)
            // verify required parameter 'statusId' is not null or undefined
            assertParamExists('updatePlayerStatus', 'statusId', statusId)
            // verify required parameter 'PlayerHistory' is not null or undefined
            assertParamExists('updatePlayerStatus', 'PlayerHistory', PlayerHistory)
            const localVarPath = `/players/{playerId}/status/{statusId}`
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
                .replace(`{${"statusId"}}`, encodeURIComponent(String(statusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PlayerHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('updateTeamPlayer', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamPlayerImage: async (teamId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('uploadTeamPlayerImage', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('uploadTeamPlayerImage', 'playerId', playerId)
            const localVarPath = `/teams/{teamId}/player/{playerId}/uploadImage`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlayersApi - functional programming interface
 * @export
 */
export const PlayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrgPlayer(orgId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Store a new player
         * @param {Player} Player Create new Player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayer(Player: Player, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayer(Player, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add to Player Status History. Adds a record to the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayerStatus(playerId: number, PlayerHistory: PlayerHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayerStatus(playerId, PlayerHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamPlayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayerToTeam(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrgPlayer(orgId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete player
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlayer(playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlayer(playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a player status / audit entry. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlayerStatus(playerId: number, statusId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlayerStatus(playerId, statusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the most recent baseline for a player, merged with any subsequent retests. Used for pdf generation
         * @param {number} playerId ID of the player
         * @param {number} [atTime] unix timestamp. Return player baseline as at this timetimestamp (or before)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerBaseline(playerId: number, atTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerBaseline(playerId, atTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerById(playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerById(playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the player status history from the player audit table
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerHistory(playerId: number, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayerHistoryOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerHistory(playerId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * show the statuses for a player
         * @summary ListAll PlayerStatuses
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayerStatus(event?: Array<number>, player?: Array<number>, page?: number, pageSize?: number, sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayerHistoryOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayerStatus(event, player, page, pageSize, sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayersOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayersOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayerReviewsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamReviews(page, pageSize, team, org, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * merge all the stuff from fromPlayerId into playerId and delete fromPlayerId
         * @param {number} playerId ID of the player
         * @param {number} fromPlayerId player to delete
         * @param {MergePlayer} MergePlayer fields to copy from other player into this one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergePlayer(playerId: number, fromPlayerId: number, MergePlayer: MergePlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergePlayer(playerId, fromPlayerId, MergePlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTeamPlayer(teamId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTeamPlayer(teamId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlayer(playerId: number, Player: Player, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Player>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlayer(playerId, Player, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update Player Status History. Edits a record in the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlayerStatus(playerId: number, statusId: number, PlayerHistory: PlayerHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlayerStatus(playerId, statusId, PlayerHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamPlayer(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTeamPlayerImage(teamId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTeamPlayerImage(teamId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlayersApi - factory interface
 * @export
 */
export const PlayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlayersApiFp(configuration)
    return {
        /**
         * Add a player to an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrgPlayer(orgId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.addOrgPlayer(orgId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a new player
         * @param {Player} Player Create new Player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayer(Player: Player, options?: any): AxiosPromise<Player> {
            return localVarFp.addPlayer(Player, options).then((request) => request(axios, basePath));
        },
        /**
         * Add to Player Status History. Adds a record to the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerStatus(playerId: number, PlayerHistory: PlayerHistory, options?: any): AxiosPromise<Player> {
            return localVarFp.addPlayerStatus(playerId, PlayerHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<Array<TeamPlayer>> {
            return localVarFp.addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a player from an org.
         * @param {number} orgId ID of the org / union
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgPlayer(orgId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteOrgPlayer(orgId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete player
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayer(playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deletePlayer(playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a player status / audit entry. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlayerStatus(playerId: number, statusId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deletePlayerStatus(playerId, statusId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the most recent baseline for a player, merged with any subsequent retests. Used for pdf generation
         * @param {number} playerId ID of the player
         * @param {number} [atTime] unix timestamp. Return player baseline as at this timetimestamp (or before)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerBaseline(playerId: number, atTime?: number, options?: any): AxiosPromise<Assessment> {
            return localVarFp.getPlayerBaseline(playerId, atTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get player by id
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerById(playerId: number, options?: any): AxiosPromise<Player> {
            return localVarFp.getPlayerById(playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the player status history from the player audit table
         * @param {number} playerId ID of the player
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerHistory(playerId: number, page?: number, pageSize?: number, options?: any): AxiosPromise<PlayerHistoryOnPage> {
            return localVarFp.getPlayerHistory(playerId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * show the statuses for a player
         * @summary ListAll PlayerStatuses
         * @param {Array<number>} [event] comma separated list of integer event ids
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayerStatus(event?: Array<number>, player?: Array<number>, page?: number, pageSize?: number, sinceTime?: number, options?: any): AxiosPromise<PlayerHistoryOnPage> {
            return localVarFp.getPlayerStatus(event, player, page, pageSize, sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {boolean} [includeBaselineDate] Include baseline date information for each player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: any): AxiosPromise<PlayersOnPage> {
            return localVarFp.getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all players this user can see that match the filters in the query parameters
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [player] comma separated list of integer player ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: any): AxiosPromise<PlayersOnPage> {
            return localVarFp.getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: any): AxiosPromise<TeamPlayerReviewsOnPage> {
            return localVarFp.getTeamReviews(page, pageSize, team, org, options).then((request) => request(axios, basePath));
        },
        /**
         * merge all the stuff from fromPlayerId into playerId and delete fromPlayerId
         * @param {number} playerId ID of the player
         * @param {number} fromPlayerId player to delete
         * @param {MergePlayer} MergePlayer fields to copy from other player into this one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergePlayer(playerId: number, fromPlayerId: number, MergePlayer: MergePlayer, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.mergePlayer(playerId, fromPlayerId, MergePlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamPlayer(teamId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.removeTeamPlayer(teamId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a player
         * @param {number} playerId ID of the player
         * @param {Player} Player Update player object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayer(playerId: number, Player: Player, options?: any): AxiosPromise<Player> {
            return localVarFp.updatePlayer(playerId, Player, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Player Status History. Edits a record in the audit trail for a player. This corresponds to the player audit table
         * @param {number} playerId ID of the player
         * @param {number} statusId ID of the status item
         * @param {PlayerHistory} PlayerHistory 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlayerStatus(playerId: number, statusId: number, PlayerHistory: PlayerHistory, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.updatePlayerStatus(playerId, statusId, PlayerHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<TeamPlayer> {
            return localVarFp.updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamPlayerImage(teamId: number, playerId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadTeamPlayerImage(teamId, playerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlayersApi - object-oriented interface
 * @export
 * @class PlayersApi
 * @extends {BaseAPI}
 */
export class PlayersApi extends BaseAPI {
    /**
     * Add a player to an org.
     * @param {number} orgId ID of the org / union
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public addOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).addOrgPlayer(orgId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a new player
     * @param {Player} Player Create new Player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public addPlayer(Player: Player, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).addPlayer(Player, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add to Player Status History. Adds a record to the audit trail for a player. This corresponds to the player audit table
     * @param {number} playerId ID of the player
     * @param {PlayerHistory} PlayerHistory 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public addPlayerStatus(playerId: number, PlayerHistory: PlayerHistory, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).addPlayerStatus(playerId, PlayerHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new player to a team
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a player from an org.
     * @param {number} orgId ID of the org / union
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public deleteOrgPlayer(orgId: number, playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).deleteOrgPlayer(orgId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete player
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public deletePlayer(playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).deletePlayer(playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a player status / audit entry. This corresponds to the player audit table
     * @param {number} playerId ID of the player
     * @param {number} statusId ID of the status item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public deletePlayerStatus(playerId: number, statusId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).deletePlayerStatus(playerId, statusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the most recent baseline for a player, merged with any subsequent retests. Used for pdf generation
     * @param {number} playerId ID of the player
     * @param {number} [atTime] unix timestamp. Return player baseline as at this timetimestamp (or before)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayerBaseline(playerId: number, atTime?: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayerBaseline(playerId, atTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get player by id
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayerById(playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayerById(playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the player status history from the player audit table
     * @param {number} playerId ID of the player
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayerHistory(playerId: number, page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayerHistory(playerId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * show the statuses for a player
     * @summary ListAll PlayerStatuses
     * @param {Array<number>} [event] comma separated list of integer event ids
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayerStatus(event?: Array<number>, player?: Array<number>, page?: number, pageSize?: number, sinceTime?: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayerStatus(event, player, page, pageSize, sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all players this user can see that match the filters in the query parameters
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<PlayerStatus>} [status] comma separated list of string player statuses
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {boolean} [includeBaselineDate] Include baseline date information for each player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayers(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, search?: string, status?: Array<PlayerStatus>, player?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, includeBaselineDate?: boolean, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayers(page, pageSize, org, team, tournament, search, status, player, sinceTime, showDeleted, orderBy, includeBaselineDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all players this user can see that match the filters in the query parameters
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [player] comma separated list of integer player ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getPlayersWithNoComprehensiveBaseline(page?: number, pageSize?: number, org?: Array<number>, team?: Array<number>, search?: string, player?: Array<number>, sinceTime?: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getPlayersWithNoComprehensiveBaseline(page, pageSize, org, team, search, player, sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all currently open (not yet approved) reviews of which players are in each team
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).getTeamReviews(page, pageSize, team, org, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * merge all the stuff from fromPlayerId into playerId and delete fromPlayerId
     * @param {number} playerId ID of the player
     * @param {number} fromPlayerId player to delete
     * @param {MergePlayer} MergePlayer fields to copy from other player into this one
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public mergePlayer(playerId: number, fromPlayerId: number, MergePlayer: MergePlayer, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).mergePlayer(playerId, fromPlayerId, MergePlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public removeTeamPlayer(teamId: number, playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).removeTeamPlayer(teamId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a player
     * @param {number} playerId ID of the player
     * @param {Player} Player Update player object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public updatePlayer(playerId: number, Player: Player, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).updatePlayer(playerId, Player, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Player Status History. Edits a record in the audit trail for a player. This corresponds to the player audit table
     * @param {number} playerId ID of the player
     * @param {number} statusId ID of the status item
     * @param {PlayerHistory} PlayerHistory 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public updatePlayerStatus(playerId: number, statusId: number, PlayerHistory: PlayerHistory, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).updatePlayerStatus(playerId, statusId, PlayerHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a player in a team. Set position etc
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads an image of a player for this team because a player may belong to multiple teams
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    public uploadTeamPlayerImage(teamId: number, playerId: number, options?: AxiosRequestConfig) {
        return PlayersApiFp(this.configuration).uploadTeamPlayerImage(teamId, playerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SyncApi - axios parameter creator
 * @export
 */
export const SyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a list of unsyncables to be resolved or already resolved
         * @summary 
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {boolean} [showResolved] Whether to show resolved unsyncables instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnsyncables: async (page?: number, pageSize?: number, showResolved?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unsyncables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Entrypoint for new sync
         * @summary 
         * @param {string} syncVersion Which version of the sync to use
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sync: async (syncVersion: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncVersion' is not null or undefined
            assertParamExists('sync', 'syncVersion', syncVersion)
            const localVarPath = `/sync/{syncVersion}`
                .replace(`{${"syncVersion"}}`, encodeURIComponent(String(syncVersion)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an unsyncable to be resolved
         * @summary 
         * @param {number} userId ID of the user
         * @param {string} storeId store id
         * @param {number} changeId change id
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnsyncable: async (userId: number, storeId: string, changeId: number, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUnsyncable', 'userId', userId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('updateUnsyncable', 'storeId', storeId)
            // verify required parameter 'changeId' is not null or undefined
            assertParamExists('updateUnsyncable', 'changeId', changeId)
            const localVarPath = `/unsyncables/{userId}/{storeId}/{changeId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"changeId"}}`, encodeURIComponent(String(changeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncApi - functional programming interface
 * @export
 */
export const SyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SyncApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a list of unsyncables to be resolved or already resolved
         * @summary 
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {boolean} [showResolved] Whether to show resolved unsyncables instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnsyncables(page?: number, pageSize?: number, showResolved?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnsyncables(page, pageSize, showResolved, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Entrypoint for new sync
         * @summary 
         * @param {string} syncVersion Which version of the sync to use
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sync(syncVersion: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sync(syncVersion, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an unsyncable to be resolved
         * @summary 
         * @param {number} userId ID of the user
         * @param {string} storeId store id
         * @param {number} changeId change id
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUnsyncable(userId: number, storeId: string, changeId: number, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUnsyncable(userId, storeId, changeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SyncApi - factory interface
 * @export
 */
export const SyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SyncApiFp(configuration)
    return {
        /**
         * Get a list of unsyncables to be resolved or already resolved
         * @summary 
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {boolean} [showResolved] Whether to show resolved unsyncables instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnsyncables(page?: number, pageSize?: number, showResolved?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.getUnsyncables(page, pageSize, showResolved, options).then((request) => request(axios, basePath));
        },
        /**
         * Entrypoint for new sync
         * @summary 
         * @param {string} syncVersion Which version of the sync to use
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sync(syncVersion: string, body?: object, options?: any): AxiosPromise<object> {
            return localVarFp.sync(syncVersion, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an unsyncable to be resolved
         * @summary 
         * @param {number} userId ID of the user
         * @param {string} storeId store id
         * @param {number} changeId change id
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnsyncable(userId: number, storeId: string, changeId: number, body?: object, options?: any): AxiosPromise<object> {
            return localVarFp.updateUnsyncable(userId, storeId, changeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncApi - object-oriented interface
 * @export
 * @class SyncApi
 * @extends {BaseAPI}
 */
export class SyncApi extends BaseAPI {
    /**
     * Get a list of unsyncables to be resolved or already resolved
     * @summary 
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {boolean} [showResolved] Whether to show resolved unsyncables instead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public getUnsyncables(page?: number, pageSize?: number, showResolved?: boolean, options?: AxiosRequestConfig) {
        return SyncApiFp(this.configuration).getUnsyncables(page, pageSize, showResolved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Entrypoint for new sync
     * @summary 
     * @param {string} syncVersion Which version of the sync to use
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public sync(syncVersion: string, body?: object, options?: AxiosRequestConfig) {
        return SyncApiFp(this.configuration).sync(syncVersion, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an unsyncable to be resolved
     * @summary 
     * @param {number} userId ID of the user
     * @param {string} storeId store id
     * @param {number} changeId change id
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public updateUnsyncable(userId: number, storeId: string, changeId: number, body?: object, options?: AxiosRequestConfig) {
        return SyncApiFp(this.configuration).updateUnsyncable(userId, storeId, changeId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TeamsApi - axios parameter creator
 * @export
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('addPlayerToTeam', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('addPlayerToTeam', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a new team
         * @param {Team} Team Create new Team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeam: async (Team: Team, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Team' is not null or undefined
            assertParamExists('addTeam', 'Team', Team)
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Team, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new team review. POST body should ignore the token because this is generated server side. Almost all fields will be empty except teamId
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReviewCreate} [TeamPlayerReviewCreate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamReview: async (teamId: number, TeamPlayerReviewCreate?: TeamPlayerReviewCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addTeamReview', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/playerReview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayerReviewCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentTeam: async (tournamentId: number, teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('addTournamentTeam', 'tournamentId', tournamentId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addTournamentTeam', 'teamId', teamId)
            const localVarPath = `/tournaments/{tournamentId}/teams/{teamId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing team.
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeam', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentTeam: async (tournamentId: number, teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournamentTeam', 'tournamentId', tournamentId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTournamentTeam', 'teamId', teamId)
            const localVarPath = `/tournaments/{tournamentId}/teams/{teamId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all players in a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersInTeam: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getPlayersInTeam', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/players`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a team by Id
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamById: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamById', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a currently open review of which players are in a team. Auth is optional if the token query parameter is valid
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReview: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamReview', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/playerReview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReviews: async (page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teamPlayerReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated teams matching the filters in the parameters that the currently logged in user can see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (page?: number, pageSize?: number, org?: Array<number>, tournament?: Array<number>, search?: string, team?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamPlayer: async (teamId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeTeamPlayer', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('removeTeamPlayer', 'playerId', playerId)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a team review. PATCH body should verify the token matches the one in the database if the user is not authenticated
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReview} TeamPlayerReview Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeamReview: async (teamId: number, TeamPlayerReview: TeamPlayerReview, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('saveTeamReview', 'teamId', teamId)
            // verify required parameter 'TeamPlayerReview' is not null or undefined
            assertParamExists('saveTeamReview', 'TeamPlayerReview', TeamPlayerReview)
            const localVarPath = `/teams/{teamId}/playerReview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayerReview, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing team.
         * @param {number} teamId ID of the team
         * @param {Team} Team Updated team object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (teamId: number, Team: Team, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeam', 'teamId', teamId)
            // verify required parameter 'Team' is not null or undefined
            assertParamExists('updateTeam', 'Team', Team)
            const localVarPath = `/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Team, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer: async (teamId: number, playerId: number, TeamPlayer: TeamPlayer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('updateTeamPlayer', 'playerId', playerId)
            // verify required parameter 'TeamPlayer' is not null or undefined
            assertParamExists('updateTeamPlayer', 'TeamPlayer', TeamPlayer)
            const localVarPath = `/teams/{teamId}/players/{playerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TeamPlayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a default team player image eg a standard shirt
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamDefaultPlayerImage: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('uploadTeamDefaultPlayerImage', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/uploadPlayerImage`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a team logo image
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamLogo: async (teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('uploadTeamLogo', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/uploadLogo`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamPlayerImage: async (teamId: number, playerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('uploadTeamPlayerImage', 'teamId', teamId)
            // verify required parameter 'playerId' is not null or undefined
            assertParamExists('uploadTeamPlayerImage', 'playerId', playerId)
            const localVarPath = `/teams/{teamId}/player/{playerId}/uploadImage`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 * @export
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamPlayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlayerToTeam(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Store a new team
         * @param {Team} Team Create new Team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTeam(Team: Team, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTeam(Team, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new team review. POST body should ignore the token because this is generated server side. Almost all fields will be empty except teamId
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReviewCreate} [TeamPlayerReviewCreate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTeamReview(teamId: number, TeamPlayerReviewCreate?: TeamPlayerReviewCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayerReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTeamReview(teamId, TeamPlayerReviewCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTournamentTeam(tournamentId, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete an existing team.
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeam(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeam(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTournamentTeam(tournamentId, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all players in a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlayersInTeam(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamPlayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlayersInTeam(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a team by Id
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamById(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamById(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a currently open review of which players are in a team. Auth is optional if the token query parameter is valid
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamReview(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayerReview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamReview(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayerReviewsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamReviews(page, pageSize, team, org, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns paginated teams matching the filters in the parameters that the currently logged in user can see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(page?: number, pageSize?: number, org?: Array<number>, tournament?: Array<number>, search?: string, team?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(page, pageSize, org, tournament, search, team, sinceTime, showDeleted, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTeamPlayer(teamId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTeamPlayer(teamId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a team review. PATCH body should verify the token matches the one in the database if the user is not authenticated
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReview} TeamPlayerReview Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTeamReview(teamId: number, TeamPlayerReview: TeamPlayerReview, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTeamReview(teamId, TeamPlayerReview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing team.
         * @param {number} teamId ID of the team
         * @param {Team} Team Updated team object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(teamId: number, Team: Team, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(teamId, Team, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamPlayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamPlayer(teamId, playerId, TeamPlayer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a default team player image eg a standard shirt
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTeamDefaultPlayerImage(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTeamDefaultPlayerImage(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a team logo image
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTeamLogo(teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTeamLogo(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTeamPlayerImage(teamId: number, playerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTeamPlayerImage(teamId, playerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TeamsApi - factory interface
 * @export
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * Add a new player to a team
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<Array<TeamPlayer>> {
            return localVarFp.addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a new team
         * @param {Team} Team Create new Team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeam(Team: Team, options?: any): AxiosPromise<Team> {
            return localVarFp.addTeam(Team, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new team review. POST body should ignore the token because this is generated server side. Almost all fields will be empty except teamId
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReviewCreate} [TeamPlayerReviewCreate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamReview(teamId: number, TeamPlayerReviewCreate?: TeamPlayerReviewCreate, options?: any): AxiosPromise<TeamPlayerReview> {
            return localVarFp.addTeamReview(teamId, TeamPlayerReviewCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentTeam(tournamentId: number, teamId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.addTournamentTeam(tournamentId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing team.
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(teamId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentTeam(tournamentId: number, teamId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.deleteTournamentTeam(tournamentId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all players in a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayersInTeam(teamId: number, options?: any): AxiosPromise<Array<TeamPlayer>> {
            return localVarFp.getPlayersInTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a team by Id
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamById(teamId: number, options?: any): AxiosPromise<Team> {
            return localVarFp.getTeamById(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a currently open review of which players are in a team. Auth is optional if the token query parameter is valid
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReview(teamId: number, options?: any): AxiosPromise<TeamPlayerReview> {
            return localVarFp.getTeamReview(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all currently open (not yet approved) reviews of which players are in each team
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: any): AxiosPromise<TeamPlayerReviewsOnPage> {
            return localVarFp.getTeamReviews(page, pageSize, team, org, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated teams matching the filters in the parameters that the currently logged in user can see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(page?: number, pageSize?: number, org?: Array<number>, tournament?: Array<number>, search?: string, team?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, options?: any): AxiosPromise<TeamsOnPage> {
            return localVarFp.getTeams(page, pageSize, org, tournament, search, team, sinceTime, showDeleted, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTeamPlayer(teamId: number, playerId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.removeTeamPlayer(teamId, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a team review. PATCH body should verify the token matches the one in the database if the user is not authenticated
         * @param {number} teamId ID of the team
         * @param {TeamPlayerReview} TeamPlayerReview Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeamReview(teamId: number, TeamPlayerReview: TeamPlayerReview, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.saveTeamReview(teamId, TeamPlayerReview, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing team.
         * @param {number} teamId ID of the team
         * @param {Team} Team Updated team object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId: number, Team: Team, options?: any): AxiosPromise<Team> {
            return localVarFp.updateTeam(teamId, Team, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a player in a team. Set position etc
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {TeamPlayer} TeamPlayer Updated team player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: any): AxiosPromise<TeamPlayer> {
            return localVarFp.updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a default team player image eg a standard shirt
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamDefaultPlayerImage(teamId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadTeamDefaultPlayerImage(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a team logo image
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamLogo(teamId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadTeamLogo(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads an image of a player for this team because a player may belong to multiple teams
         * @param {number} teamId ID of the team
         * @param {number} playerId ID of the player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTeamPlayerImage(teamId: number, playerId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadTeamPlayerImage(teamId, playerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */
export class TeamsApi extends BaseAPI {
    /**
     * Add a new player to a team
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public addPlayerToTeam(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).addPlayerToTeam(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a new team
     * @param {Team} Team Create new Team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public addTeam(Team: Team, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).addTeam(Team, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new team review. POST body should ignore the token because this is generated server side. Almost all fields will be empty except teamId
     * @param {number} teamId ID of the team
     * @param {TeamPlayerReviewCreate} [TeamPlayerReviewCreate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public addTeamReview(teamId: number, TeamPlayerReviewCreate?: TeamPlayerReviewCreate, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).addTeamReview(teamId, TeamPlayerReviewCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new team to a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public addTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).addTournamentTeam(tournamentId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing team.
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public deleteTeam(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).deleteTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team from a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public deleteTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).deleteTournamentTeam(tournamentId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all players in a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getPlayersInTeam(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getPlayersInTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a team by Id
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeamById(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeamById(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a currently open review of which players are in a team. Auth is optional if the token query parameter is valid
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeamReview(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeamReview(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all currently open (not yet approved) reviews of which players are in each team
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeamReviews(page?: number, pageSize?: number, team?: Array<number>, org?: Array<number>, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeamReviews(page, pageSize, team, org, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated teams matching the filters in the parameters that the currently logged in user can see
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeams(page?: number, pageSize?: number, org?: Array<number>, tournament?: Array<number>, search?: string, team?: Array<number>, sinceTime?: number, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeams(page, pageSize, org, tournament, search, team, sinceTime, showDeleted, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a player from a team. Team and player still exist, we just break the link (and delete a photo for the player team if any)
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public removeTeamPlayer(teamId: number, playerId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).removeTeamPlayer(teamId, playerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a team review. PATCH body should verify the token matches the one in the database if the user is not authenticated
     * @param {number} teamId ID of the team
     * @param {TeamPlayerReview} TeamPlayerReview Created tournament object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public saveTeamReview(teamId: number, TeamPlayerReview: TeamPlayerReview, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).saveTeamReview(teamId, TeamPlayerReview, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing team.
     * @param {number} teamId ID of the team
     * @param {Team} Team Updated team object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public updateTeam(teamId: number, Team: Team, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).updateTeam(teamId, Team, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a player in a team. Set position etc
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {TeamPlayer} TeamPlayer Updated team player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public updateTeamPlayer(teamId: number, playerId: number, TeamPlayer: TeamPlayer, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).updateTeamPlayer(teamId, playerId, TeamPlayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a default team player image eg a standard shirt
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public uploadTeamDefaultPlayerImage(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).uploadTeamDefaultPlayerImage(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a team logo image
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public uploadTeamLogo(teamId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).uploadTeamLogo(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads an image of a player for this team because a player may belong to multiple teams
     * @param {number} teamId ID of the team
     * @param {number} playerId ID of the player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public uploadTeamPlayerImage(teamId: number, playerId: number, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).uploadTeamPlayerImage(teamId, playerId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TermsApi - axios parameter creator
 * @export
 */
export const TermsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get the current terms and conditions a user must agree to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthTerms: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermsApi - functional programming interface
 * @export
 */
export const TermsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermsApiAxiosParamCreator(configuration)
    return {
        /**
         * get the current terms and conditions a user must agree to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthTerms(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Terms>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthTerms(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermsApi - factory interface
 * @export
 */
export const TermsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermsApiFp(configuration)
    return {
        /**
         * get the current terms and conditions a user must agree to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthTerms(options?: any): AxiosPromise<Terms> {
            return localVarFp.getAuthTerms(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermsApi - object-oriented interface
 * @export
 * @class TermsApi
 * @extends {BaseAPI}
 */
export class TermsApi extends BaseAPI {
    /**
     * get the current terms and conditions a user must agree to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsApi
     */
    public getAuthTerms(options?: AxiosRequestConfig) {
        return TermsApiFp(this.configuration).getAuthTerms(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TournamentsApi - axios parameter creator
 * @export
 */
export const TournamentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new Tournament
         * @param {Tournament} Tournament Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournament: async (Tournament: Tournament, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Tournament' is not null or undefined
            assertParamExists('addTournament', 'Tournament', Tournament)
            const localVarPath = `/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Tournament, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentTeam: async (tournamentId: number, teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('addTournamentTeam', 'tournamentId', tournamentId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addTournamentTeam', 'teamId', teamId)
            const localVarPath = `/tournaments/{tournamentId}/teams/{teamId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentVenue: async (tournamentId: number, venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('addTournamentVenue', 'tournamentId', tournamentId)
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('addTournamentVenue', 'venueId', venueId)
            const localVarPath = `/tournaments/{tournamentId}/venues/{venueId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournament: async (tournamentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournament', 'tournamentId', tournamentId)
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentTeam: async (tournamentId: number, teamId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournamentTeam', 'tournamentId', tournamentId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTournamentTeam', 'teamId', teamId)
            const localVarPath = `/tournaments/{tournamentId}/teams/{teamId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentVenue: async (tournamentId: number, venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournamentVenue', 'tournamentId', tournamentId)
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('deleteTournamentVenue', 'venueId', venueId)
            const localVarPath = `/tournaments/{tournamentId}/venues/{venueId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tournament by id
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentById: async (tournamentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getTournamentById', 'tournamentId', tournamentId)
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all tournaments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {string} [endsAtLt] ends at is less than the passed date
         * @param {string} [endsAtGte] ends at is greater than the passed date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournaments: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, venue?: Array<number>, showDeleted?: number, orderBy?: string, endsAtLt?: string, endsAtGte?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (venue) {
                localVarQueryParameter['venue'] = venue;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (endsAtLt !== undefined) {
                localVarQueryParameter['endsAtLt'] = (endsAtLt as any instanceof Date) ?
                    (endsAtLt as any).toISOString().substr(0,10) :
                    endsAtLt;
            }

            if (endsAtGte !== undefined) {
                localVarQueryParameter['endsAtGte'] = (endsAtGte as any instanceof Date) ?
                    (endsAtGte as any).toISOString().substr(0,10) :
                    endsAtGte;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing tournament.
         * @param {number} tournamentId ID of the tournament
         * @param {Tournament} Tournament Updated tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTournament: async (tournamentId: number, Tournament: Tournament, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('updateTournament', 'tournamentId', tournamentId)
            // verify required parameter 'Tournament' is not null or undefined
            assertParamExists('updateTournament', 'Tournament', Tournament)
            const localVarPath = `/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Tournament, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * bulk upload fixtures to a tournament. Some may be new, some may be updates to existing fixtures
         * @param {number} tournamentId ID of the tournament
         * @param {Array<Fixture>} Fixture Fixtures to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTournamentFixtures: async (tournamentId: number, Fixture: Array<Fixture>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('uploadTournamentFixtures', 'tournamentId', tournamentId)
            // verify required parameter 'Fixture' is not null or undefined
            assertParamExists('uploadTournamentFixtures', 'Fixture', Fixture)
            const localVarPath = `/tournaments/{tournamentId}/fixtures`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Fixture, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a logo for the tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTournamentPhoto: async (tournamentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('uploadTournamentPhoto', 'tournamentId', tournamentId)
            const localVarPath = `/tournament/{tournamentId}/uploadPhoto`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TournamentsApi - functional programming interface
 * @export
 */
export const TournamentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TournamentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new Tournament
         * @param {Tournament} Tournament Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTournament(Tournament: Tournament, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTournament(Tournament, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTournamentTeam(tournamentId, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTournamentVenue(tournamentId, venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Soft delete tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTournament(tournamentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTournament(tournamentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTournamentTeam(tournamentId, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTournamentVenue(tournamentId, venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get tournament by id
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTournamentById(tournamentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTournamentById(tournamentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all tournaments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {string} [endsAtLt] ends at is less than the passed date
         * @param {string} [endsAtGte] ends at is greater than the passed date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTournaments(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, venue?: Array<number>, showDeleted?: number, orderBy?: string, endsAtLt?: string, endsAtGte?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TournamentsOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTournaments(page, pageSize, search, org, team, venue, showDeleted, orderBy, endsAtLt, endsAtGte, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing tournament.
         * @param {number} tournamentId ID of the tournament
         * @param {Tournament} Tournament Updated tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTournament(tournamentId: number, Tournament: Tournament, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTournament(tournamentId, Tournament, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * bulk upload fixtures to a tournament. Some may be new, some may be updates to existing fixtures
         * @param {number} tournamentId ID of the tournament
         * @param {Array<Fixture>} Fixture Fixtures to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTournamentFixtures(tournamentId: number, Fixture: Array<Fixture>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTournamentFixtures(tournamentId, Fixture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a logo for the tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTournamentPhoto(tournamentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3FileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTournamentPhoto(tournamentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TournamentsApi - factory interface
 * @export
 */
export const TournamentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TournamentsApiFp(configuration)
    return {
        /**
         * Create a new Tournament
         * @param {Tournament} Tournament Created tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournament(Tournament: Tournament, options?: any): AxiosPromise<Tournament> {
            return localVarFp.addTournament(Tournament, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new team to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentTeam(tournamentId: number, teamId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.addTournamentTeam(tournamentId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentVenue(tournamentId: number, venueId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.addTournamentVenue(tournamentId, venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournament(tournamentId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteTournament(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentTeam(tournamentId: number, teamId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.deleteTournamentTeam(tournamentId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentVenue(tournamentId: number, venueId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteTournamentVenue(tournamentId, venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tournament by id
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentById(tournamentId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.getTournamentById(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all tournaments
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [venue] comma separated list of integer venue ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {string} [endsAtLt] ends at is less than the passed date
         * @param {string} [endsAtGte] ends at is greater than the passed date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournaments(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, venue?: Array<number>, showDeleted?: number, orderBy?: string, endsAtLt?: string, endsAtGte?: string, options?: any): AxiosPromise<TournamentsOnPage> {
            return localVarFp.getTournaments(page, pageSize, search, org, team, venue, showDeleted, orderBy, endsAtLt, endsAtGte, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing tournament.
         * @param {number} tournamentId ID of the tournament
         * @param {Tournament} Tournament Updated tournament object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTournament(tournamentId: number, Tournament: Tournament, options?: any): AxiosPromise<Tournament> {
            return localVarFp.updateTournament(tournamentId, Tournament, options).then((request) => request(axios, basePath));
        },
        /**
         * bulk upload fixtures to a tournament. Some may be new, some may be updates to existing fixtures
         * @param {number} tournamentId ID of the tournament
         * @param {Array<Fixture>} Fixture Fixtures to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTournamentFixtures(tournamentId: number, Fixture: Array<Fixture>, options?: any): AxiosPromise<Tournament> {
            return localVarFp.uploadTournamentFixtures(tournamentId, Fixture, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a logo for the tournament
         * @param {number} tournamentId ID of the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTournamentPhoto(tournamentId: number, options?: any): AxiosPromise<S3FileUpload> {
            return localVarFp.uploadTournamentPhoto(tournamentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TournamentsApi - object-oriented interface
 * @export
 * @class TournamentsApi
 * @extends {BaseAPI}
 */
export class TournamentsApi extends BaseAPI {
    /**
     * Create a new Tournament
     * @param {Tournament} Tournament Created tournament object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public addTournament(Tournament: Tournament, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).addTournament(Tournament, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new team to a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public addTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).addTournamentTeam(tournamentId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new venue to a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public addTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).addTournamentVenue(tournamentId, venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete tournament
     * @param {number} tournamentId ID of the tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public deleteTournament(tournamentId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).deleteTournament(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team from a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public deleteTournamentTeam(tournamentId: number, teamId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).deleteTournamentTeam(tournamentId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team from a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public deleteTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).deleteTournamentVenue(tournamentId, venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tournament by id
     * @param {number} tournamentId ID of the tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public getTournamentById(tournamentId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).getTournamentById(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all tournaments
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [venue] comma separated list of integer venue ids
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {string} [endsAtLt] ends at is less than the passed date
     * @param {string} [endsAtGte] ends at is greater than the passed date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public getTournaments(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, venue?: Array<number>, showDeleted?: number, orderBy?: string, endsAtLt?: string, endsAtGte?: string, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).getTournaments(page, pageSize, search, org, team, venue, showDeleted, orderBy, endsAtLt, endsAtGte, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing tournament.
     * @param {number} tournamentId ID of the tournament
     * @param {Tournament} Tournament Updated tournament object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public updateTournament(tournamentId: number, Tournament: Tournament, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).updateTournament(tournamentId, Tournament, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * bulk upload fixtures to a tournament. Some may be new, some may be updates to existing fixtures
     * @param {number} tournamentId ID of the tournament
     * @param {Array<Fixture>} Fixture Fixtures to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public uploadTournamentFixtures(tournamentId: number, Fixture: Array<Fixture>, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).uploadTournamentFixtures(tournamentId, Fixture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a logo for the tournament
     * @param {number} tournamentId ID of the tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    public uploadTournamentPhoto(tournamentId: number, options?: AxiosRequestConfig) {
        return TournamentsApiFp(this.configuration).uploadTournamentPhoto(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * User accepts the terms and condtions. Tell the api which version they accepted. createdAt should be set to now()
         * @param {number} userId ID of the user
         * @param {TermsAccepted} [TermsAccepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms: async (userId: number, TermsAccepted?: TermsAccepted, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('acceptTerms', 'userId', userId)
            const localVarPath = `/users/{userId}/terms`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(TermsAccepted, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create user. Ignore the user.id if it is set. If email is set to a different value than in the database, do we need to go through the email verification flow again? If password is not set, ignore it. Update the password only if a password value is provided. Minimum length checks are done on the front end
         * @param {User} User Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (User: User, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'User' is not null or undefined
            assertParamExists('addUser', 'User', User)
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(User, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * add a new role to a user
         * @param {number} userId ID of the user
         * @param {UserRole} [UserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserRole: async (userId: number, UserRole?: UserRole, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addUserRole', 'userId', userId)
            const localVarPath = `/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete user
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete a role from a user
         * @param {number} userId ID of the user
         * @param {number} roleId ID of the user role (the role record for a specific user). Usually paied with UserIdInPath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRole: async (userId: number, roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserRole', 'userId', userId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteUserRole', 'roleId', roleId)
            const localVarPath = `/users/{userId}/roles/{roleId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user by user id
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserDashboard: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user data s3 upload url
         * @param {UserDataReportUrlParameters} [UserDataReportUrlParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataS3UploadUrl: async (UserDataReportUrlParameters?: UserDataReportUrlParameters, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/reportUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(UserDataReportUrlParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of users we are allowed to see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<Role>} [role] comma separated list of string role names
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, role?: Array<Role>, showDeleted?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (org) {
                localVarQueryParameter['org'] = org;
            }

            if (team) {
                localVarQueryParameter['team'] = team;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (role) {
                localVarQueryParameter['role'] = role;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * what can the user see may have changed since last time we checked
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMePermissionChanges: async (sinceTime?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/permissionChanges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sinceTime !== undefined) {
                localVarQueryParameter['sinceTime'] = sinceTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * change all foreign keys that refer to otherUserId to userId and hard delete otherUser
         * @param {number} userId ID of the user
         * @param {number} otherUserId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeUser: async (userId: number, otherUserId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('mergeUser', 'userId', userId)
            // verify required parameter 'otherUserId' is not null or undefined
            assertParamExists('mergeUser', 'otherUserId', otherUserId)
            const localVarPath = `/users/{userId}/mergeFrom/{otherUserId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"otherUserId"}}`, encodeURIComponent(String(otherUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a user email to retry their activation with a new token because the old expired
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserActivation: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendUserActivation', 'userId', userId)
            const localVarPath = `/users/{userId}/resendAuth`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An admin unlocks a user account that has failed to log in more than 10 times
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unlockUser', 'userId', userId)
            const localVarPath = `/users/{userId}/unlock`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user
         * @param {number} userId ID of the user
         * @param {User} User Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: number, User: User, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'User' is not null or undefined
            assertParamExists('updateUser', 'User', User)
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(User, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * User accepts the terms and condtions. Tell the api which version they accepted. createdAt should be set to now()
         * @param {number} userId ID of the user
         * @param {TermsAccepted} [TermsAccepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTerms(userId: number, TermsAccepted?: TermsAccepted, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermsAccepted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTerms(userId, TermsAccepted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create user. Ignore the user.id if it is set. If email is set to a different value than in the database, do we need to go through the email verification flow again? If password is not set, ignore it. Update the password only if a password value is provided. Minimum length checks are done on the front end
         * @param {User} User Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(User: User, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUser(User, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * add a new role to a user
         * @param {number} userId ID of the user
         * @param {UserRole} [UserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserRole(userId: number, UserRole?: UserRole, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserRole(userId, UserRole, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete user
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete a role from a user
         * @param {number} userId ID of the user
         * @param {number} roleId ID of the user role (the role record for a specific user). Usually paied with UserIdInPath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserRole(userId: number, roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserRole(userId, roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get user by user id
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getUserDashboard(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DashboardTeams>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get user data s3 upload url
         * @param {UserDataReportUrlParameters} [UserDataReportUrlParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDataS3UploadUrl(UserDataReportUrlParameters?: UserDataReportUrlParameters, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDataS3UploadUrl(UserDataReportUrlParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of users we are allowed to see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<Role>} [role] comma separated list of string role names
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, role?: Array<Role>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(page, pageSize, search, org, team, tournament, role, showDeleted, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * what can the user see may have changed since last time we checked
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersMePermissionChanges(sinceTime?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionChanges>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersMePermissionChanges(sinceTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * change all foreign keys that refer to otherUserId to userId and hard delete otherUser
         * @param {number} userId ID of the user
         * @param {number} otherUserId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeUser(userId: number, otherUserId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeUser(userId, otherUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sends a user email to retry their activation with a new token because the old expired
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserActivation(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserActivation(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * An admin unlocks a user account that has failed to log in more than 10 times
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update user
         * @param {number} userId ID of the user
         * @param {User} User Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: number, User: User, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, User, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * User accepts the terms and condtions. Tell the api which version they accepted. createdAt should be set to now()
         * @param {number} userId ID of the user
         * @param {TermsAccepted} [TermsAccepted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms(userId: number, TermsAccepted?: TermsAccepted, options?: any): AxiosPromise<TermsAccepted> {
            return localVarFp.acceptTerms(userId, TermsAccepted, options).then((request) => request(axios, basePath));
        },
        /**
         * Create user. Ignore the user.id if it is set. If email is set to a different value than in the database, do we need to go through the email verification flow again? If password is not set, ignore it. Update the password only if a password value is provided. Minimum length checks are done on the front end
         * @param {User} User Created user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser(User: User, options?: any): AxiosPromise<User> {
            return localVarFp.addUser(User, options).then((request) => request(axios, basePath));
        },
        /**
         * add a new role to a user
         * @param {number} userId ID of the user
         * @param {UserRole} [UserRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserRole(userId: number, UserRole?: UserRole, options?: any): AxiosPromise<UserRole> {
            return localVarFp.addUserRole(userId, UserRole, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete user
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete a role from a user
         * @param {number} userId ID of the user
         * @param {number} roleId ID of the user role (the role record for a specific user). Usually paied with UserIdInPath
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserRole(userId: number, roleId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteUserRole(userId, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user by user id
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: number, options?: any): AxiosPromise<User> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get teams, players and baselines for the mobile app
         * @summary (Legacy) Get Dashboard (initial sync)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserDashboard(options?: any): AxiosPromise<Array<DashboardTeams>> {
            return localVarFp.getUserDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user data s3 upload url
         * @param {UserDataReportUrlParameters} [UserDataReportUrlParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDataS3UploadUrl(UserDataReportUrlParameters?: UserDataReportUrlParameters, options?: any): AxiosPromise<string> {
            return localVarFp.getUserDataS3UploadUrl(UserDataReportUrlParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of users we are allowed to see
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [org] comma separated list of integer org ids
         * @param {Array<number>} [team] comma separated list of integer team ids
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {Array<Role>} [role] comma separated list of string role names
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, role?: Array<Role>, showDeleted?: number, orderBy?: string, options?: any): AxiosPromise<UsersOnPage> {
            return localVarFp.getUsers(page, pageSize, search, org, team, tournament, role, showDeleted, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * what can the user see may have changed since last time we checked
         * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMePermissionChanges(sinceTime?: number, options?: any): AxiosPromise<PermissionChanges> {
            return localVarFp.getUsersMePermissionChanges(sinceTime, options).then((request) => request(axios, basePath));
        },
        /**
         * change all foreign keys that refer to otherUserId to userId and hard delete otherUser
         * @param {number} userId ID of the user
         * @param {number} otherUserId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeUser(userId: number, otherUserId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.mergeUser(userId, otherUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a user email to retry their activation with a new token because the old expired
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserActivation(userId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.resendUserActivation(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * An admin unlocks a user account that has failed to log in more than 10 times
         * @param {number} userId ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockUser(userId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.unlockUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user
         * @param {number} userId ID of the user
         * @param {User} User Updated user object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: number, User: User, options?: any): AxiosPromise<User> {
            return localVarFp.updateUser(userId, User, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * User accepts the terms and condtions. Tell the api which version they accepted. createdAt should be set to now()
     * @param {number} userId ID of the user
     * @param {TermsAccepted} [TermsAccepted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public acceptTerms(userId: number, TermsAccepted?: TermsAccepted, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).acceptTerms(userId, TermsAccepted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create user. Ignore the user.id if it is set. If email is set to a different value than in the database, do we need to go through the email verification flow again? If password is not set, ignore it. Update the password only if a password value is provided. Minimum length checks are done on the front end
     * @param {User} User Created user object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addUser(User: User, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).addUser(User, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * add a new role to a user
     * @param {number} userId ID of the user
     * @param {UserRole} [UserRole] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addUserRole(userId: number, UserRole?: UserRole, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).addUserRole(userId, UserRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete user
     * @param {number} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUser(userId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete a role from a user
     * @param {number} userId ID of the user
     * @param {number} roleId ID of the user role (the role record for a specific user). Usually paied with UserIdInPath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUserRole(userId: number, roleId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserRole(userId, roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user by user id
     * @param {number} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserById(userId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get teams, players and baselines for the mobile app
     * @summary (Legacy) Get Dashboard (initial sync)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserDashboard(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user data s3 upload url
     * @param {UserDataReportUrlParameters} [UserDataReportUrlParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserDataS3UploadUrl(UserDataReportUrlParameters?: UserDataReportUrlParameters, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserDataS3UploadUrl(UserDataReportUrlParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of users we are allowed to see
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [org] comma separated list of integer org ids
     * @param {Array<number>} [team] comma separated list of integer team ids
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {Array<Role>} [role] comma separated list of string role names
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsers(page?: number, pageSize?: number, search?: string, org?: Array<number>, team?: Array<number>, tournament?: Array<number>, role?: Array<Role>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsers(page, pageSize, search, org, team, tournament, role, showDeleted, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * what can the user see may have changed since last time we checked
     * @param {number} [sinceTime] unix epoch timestamp in milliseconds. Return only objects that have changed on or since this timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsersMePermissionChanges(sinceTime?: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersMePermissionChanges(sinceTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * change all foreign keys that refer to otherUserId to userId and hard delete otherUser
     * @param {number} userId ID of the user
     * @param {number} otherUserId user to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public mergeUser(userId: number, otherUserId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).mergeUser(userId, otherUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a user email to retry their activation with a new token because the old expired
     * @param {number} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resendUserActivation(userId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).resendUserActivation(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An admin unlocks a user account that has failed to log in more than 10 times
     * @param {number} userId ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public unlockUser(userId: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).unlockUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user
     * @param {number} userId ID of the user
     * @param {User} User Updated user object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(userId: number, User: User, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(userId, User, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VenuesApi - axios parameter creator
 * @export
 */
export const VenuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentVenue: async (tournamentId: number, venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('addTournamentVenue', 'tournamentId', tournamentId)
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('addTournamentVenue', 'venueId', venueId)
            const localVarPath = `/tournaments/{tournamentId}/venues/{venueId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create venue
         * @param {Venue} Venue Created venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVenue: async (Venue: Venue, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Venue' is not null or undefined
            assertParamExists('addVenue', 'Venue', Venue)
            const localVarPath = `/venues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Venue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentVenue: async (tournamentId: number, venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('deleteTournamentVenue', 'tournamentId', tournamentId)
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('deleteTournamentVenue', 'venueId', venueId)
            const localVarPath = `/tournaments/{tournamentId}/venues/{venueId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)))
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing venue
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVenue: async (venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('deleteVenue', 'venueId', venueId)
            const localVarPath = `/venues/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get venue by id
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenueById: async (venueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('getVenueById', 'venueId', venueId)
            const localVarPath = `/venues/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * returns all venues
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenues: async (page?: number, pageSize?: number, search?: string, tournament?: Array<number>, showDeleted?: number, orderBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/venues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tournament) {
                localVarQueryParameter['tournament'] = tournament;
            }

            if (showDeleted !== undefined) {
                localVarQueryParameter['showDeleted'] = showDeleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * change all foreign keys that refer to otherVenueId to venueId and hard delete otherVenue
         * @param {number} venueId ID of the venue
         * @param {number} otherVenueId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeVenue: async (venueId: number, otherVenueId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('mergeVenue', 'venueId', venueId)
            // verify required parameter 'otherVenueId' is not null or undefined
            assertParamExists('mergeVenue', 'otherVenueId', otherVenueId)
            const localVarPath = `/venues/{venueId}/mergeFrom/{otherVenueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)))
                .replace(`{${"otherVenueId"}}`, encodeURIComponent(String(otherVenueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing venue
         * @param {number} venueId ID of the venue
         * @param {Venue} Venue Updated Venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVenue: async (venueId: number, Venue: Venue, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'venueId' is not null or undefined
            assertParamExists('updateVenue', 'venueId', venueId)
            // verify required parameter 'Venue' is not null or undefined
            assertParamExists('updateVenue', 'Venue', Venue)
            const localVarPath = `/venues/{venueId}`
                .replace(`{${"venueId"}}`, encodeURIComponent(String(venueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(Venue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VenuesApi - functional programming interface
 * @export
 */
export const VenuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VenuesApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tournament>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTournamentVenue(tournamentId, venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create venue
         * @param {Venue} Venue Created venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addVenue(Venue: Venue, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Venue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addVenue(Venue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTournamentVenue(tournamentId, venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete an existing venue
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVenue(venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVenue(venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get venue by id
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVenueById(venueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Venue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVenueById(venueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * returns all venues
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVenues(page?: number, pageSize?: number, search?: string, tournament?: Array<number>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VenuesOnPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVenues(page, pageSize, search, tournament, showDeleted, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * change all foreign keys that refer to otherVenueId to venueId and hard delete otherVenue
         * @param {number} venueId ID of the venue
         * @param {number} otherVenueId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeVenue(venueId: number, otherVenueId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeVenue(venueId, otherVenueId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update an existing venue
         * @param {number} venueId ID of the venue
         * @param {Venue} Venue Updated Venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVenue(venueId: number, Venue: Venue, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Venue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVenue(venueId, Venue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VenuesApi - factory interface
 * @export
 */
export const VenuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VenuesApiFp(configuration)
    return {
        /**
         * Add a new venue to a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTournamentVenue(tournamentId: number, venueId: number, options?: any): AxiosPromise<Tournament> {
            return localVarFp.addTournamentVenue(tournamentId, venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create venue
         * @param {Venue} Venue Created venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addVenue(Venue: Venue, options?: any): AxiosPromise<Venue> {
            return localVarFp.addVenue(Venue, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team from a tournament
         * @param {number} tournamentId ID of the tournament
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTournamentVenue(tournamentId: number, venueId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteTournamentVenue(tournamentId, venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing venue
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVenue(venueId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.deleteVenue(venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get venue by id
         * @param {number} venueId ID of the venue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenueById(venueId: number, options?: any): AxiosPromise<Venue> {
            return localVarFp.getVenueById(venueId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns all venues
         * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
         * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
         * @param {string} [search] return only items where this string occurs in the name
         * @param {Array<number>} [tournament] comma separated list of integer tournament ids
         * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
         * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVenues(page?: number, pageSize?: number, search?: string, tournament?: Array<number>, showDeleted?: number, orderBy?: string, options?: any): AxiosPromise<VenuesOnPage> {
            return localVarFp.getVenues(page, pageSize, search, tournament, showDeleted, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * change all foreign keys that refer to otherVenueId to venueId and hard delete otherVenue
         * @param {number} venueId ID of the venue
         * @param {number} otherVenueId user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeVenue(venueId: number, otherVenueId: number, options?: any): AxiosPromise<ApiResponse> {
            return localVarFp.mergeVenue(venueId, otherVenueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing venue
         * @param {number} venueId ID of the venue
         * @param {Venue} Venue Updated Venue object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVenue(venueId: number, Venue: Venue, options?: any): AxiosPromise<Venue> {
            return localVarFp.updateVenue(venueId, Venue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VenuesApi - object-oriented interface
 * @export
 * @class VenuesApi
 * @extends {BaseAPI}
 */
export class VenuesApi extends BaseAPI {
    /**
     * Add a new venue to a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public addTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).addTournamentVenue(tournamentId, venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create venue
     * @param {Venue} Venue Created venue object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public addVenue(Venue: Venue, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).addVenue(Venue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team from a tournament
     * @param {number} tournamentId ID of the tournament
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public deleteTournamentVenue(tournamentId: number, venueId: number, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).deleteTournamentVenue(tournamentId, venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing venue
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public deleteVenue(venueId: number, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).deleteVenue(venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get venue by id
     * @param {number} venueId ID of the venue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public getVenueById(venueId: number, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).getVenueById(venueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * returns all venues
     * @param {number} [page] Which page of the full data set to show. Pages number from 1.  Use 0 to return the entire data set on the first page
     * @param {number} [pageSize] desired number of items per page. All except the last page of results should have this number of items on it
     * @param {string} [search] return only items where this string occurs in the name
     * @param {Array<number>} [tournament] comma separated list of integer tournament ids
     * @param {number} [showDeleted] boolean. If zero, return only rows with deletedAt&#x3D;null. If non zero, return all rows
     * @param {string} [orderBy] a human readable string that says what named sort configuration to apply eg completedAt:desc or teamName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public getVenues(page?: number, pageSize?: number, search?: string, tournament?: Array<number>, showDeleted?: number, orderBy?: string, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).getVenues(page, pageSize, search, tournament, showDeleted, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * change all foreign keys that refer to otherVenueId to venueId and hard delete otherVenue
     * @param {number} venueId ID of the venue
     * @param {number} otherVenueId user to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public mergeVenue(venueId: number, otherVenueId: number, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).mergeVenue(venueId, otherVenueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing venue
     * @param {number} venueId ID of the venue
     * @param {Venue} Venue Updated Venue object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VenuesApi
     */
    public updateVenue(venueId: number, Venue: Venue, options?: AxiosRequestConfig) {
        return VenuesApiFp(this.configuration).updateVenue(venueId, Venue, options).then((request) => request(this.axios, this.basePath));
    }
}


